const en = {
    'chatAiDevis.qualityIncell': 'InCell',
    'chatAiDevis.qualityOled': 'OLED',
    'chatAiDevis.qualityOriginal': 'Original / OEM',
    'chatAiDevis.qualityCompatible': 'Compatible',
    'chatAiDevis.qualityReconditionné': 'Refurbished',
    'chatAiDevis.qualityPremium': 'Premium',
    'chatAiDevis.qualityStandard': 'Standard',
    'chatAiDevis.fieldName': 'name',
    'chatAiDevis.fieldPhone': 'phone',
    'chatAiDevis.fieldEmail': 'email',
    'chatAiDevis.familyAccessoryStock': 'Accessory · in stock',
    'chatAiDevis.familyAccessoryCapped': 'Accessory · ≤€49',
    'chatAiDevis.familyAccessory': 'Accessory',
    'chatAiDevis.familyPart': 'Part',
    'chatAiDevis.familyScreen': 'Screen',
    'chatAiDevis.badgeFallback': 'Estimated price (fallback)',
    'chatAiDevis.badgeModelScore': 'Model score {{score}}',
    'chatAiDevis.badgeModelScoreShort': 'Model score',
    'chatAiDevis.badgeNeedsReview': 'To review',
    'chatAiDevis.altOtherParts': 'Other parts (all suppliers)',
    'chatAiDevis.altSelected': 'Selected',
    'chatAiDevis.useBtn': 'Use',
    'chatAiDevis.compareTitle': 'Comparison Jens / Mobilax / LCD-Phone',
    'chatAiDevis.compareCurrentLabel': 'Current:',
    'chatAiDevis.htSuffix': 'excl. tax',
    'chatAiDevis.compareNoneFound': 'No part found at the 3 suppliers.',
    'chatAiDevis.colSupplier': 'Supplier',
    'chatAiDevis.colPart': 'Part',
    'chatAiDevis.colPurchaseHt': 'Purchase excl. tax',
    'chatAiDevis.colTtcEst': 'Est. incl. tax',
    'chatAiDevis.colStock': 'Stock',
    'chatAiDevis.colExactModel': 'Exact model',
    'chatAiDevis.badgeCheapest': 'cheapest',
    'chatAiDevis.badgeCurrent': 'current',
    'chatAiDevis.scoreInline': 'score {{score}}',
    'chatAiDevis.compareNoResultFor': 'No result: {{suppliers}}',
    'chatAiDevis.cadbotEmptyCache': 'CADBOT request — supplier cache empty. Enter the purchase price (excl. tax) then Approve to send the quote.',
    'chatAiDevis.purchaseMissingZero': 'Purchase price missing (€0) — Refresh the part or enter the purchase price manually.',
    'chatAiDevis.supplierPrimary': 'primary',
    'chatAiDevis.supplierAlternate': 'alternate',
    'chatAiDevis.defaultRepair': 'Repair',
    'chatAiDevis.defaultPart': 'Part',
    'chatAiDevis.defaultClient': 'Customer',
    'chatAiDevis.identityIncompleteInline': 'Client details incomplete ({{fields}}) — required before approval',
    'chatAiDevis.willSendTo': 'Quote will be sent to {{email}}',
    'chatAiDevis.phName': 'Full name *',
    'chatAiDevis.phPhone': 'Phone *',
    'chatAiDevis.phEmail': 'Email *',
    'chatAiDevis.saveIdentityBtn': 'Save client details',
    'chatAiDevis.ttcCalcul': 'incl. tax · /calcul',
    'chatAiDevis.selectedPart': 'Selected part',
    'chatAiDevis.purchasePriceHt': 'Purchase price (excl. tax)',
    'chatAiDevis.labor': 'Labor',
    'chatAiDevis.recalcTotal': 'Recalculate total',
    'chatAiDevis.hideCompare': 'Hide comparison',
    'chatAiDevis.compareBtn': 'Compare Jens / Mobilax / LCD-Phone',
    'chatAiDevis.showAlternatives': 'Show alternatives (list)',
    'chatAiDevis.hideAlternatives': 'Hide alternatives (list)',
    'chatAiDevis.botStaff': 'Staff bot',
    'chatAiDevis.bestPartAuto': 'Best part (auto)',
    'chatAiDevis.pdf': 'PDF',
    'chatAiDevis.approveSingle': 'Approve (single)',
    'chatAiDevis.reject': 'Reject',
    'chatAiDevis.print': 'Print',
    'chatAiDevis.dirAdminTitle': 'Management / store admin',
    'chatAiDevis.delete': 'Delete',
    'chatAiDevis.approvedShort': 'Approved',
    'chatAiDevis.rejectedShort': 'Rejected',
    'chatAiDevis.batchLabel': 'Batch {{count}} quotes',
    'chatAiDevis.clientChat': 'Client chat',
    'chatAiDevis.approveAllSend': 'Approve all {{count}} & send',
    'chatAiDevis.deleteBatch': 'Delete batch',
    'chatAiDevis.pageTitle': 'AI Quotes — validation',
    'chatAiDevis.pageSubtitle': '4 options per screen request · InCell · OLED · Refurbished · Original',
    'chatAiDevis.filterPending': 'Pending',
    'chatAiDevis.filterApproved': 'Approved',
    'chatAiDevis.filterRejected': 'Rejected',
    'chatAiDevis.filterAll': 'All',
    'chatAiDevis.infoTitle': 'AI Chat & Auto-Devis — suppliers',
    'chatAiDevis.infoJensPrimary': 'is the primary supplier (priority in scoring).',
    'chatAiDevis.infoAnd': 'and',
    'chatAiDevis.infoMobilaxLcd': 'are consulted for a better match or if Jens doesn\'t have the part.',
    'chatAiDevis.infoEachRange': 'Each range (InCell, OLED, etc.) may come from a different supplier — check before approval.',
    'chatAiDevis.infoCompareExplain': '« Compare Jens / Mobilax / LCD-Phone » shows the purchase price excl. tax, the estimated incl.-tax total, the stock and the exact model at each supplier — « Use » switches the draft.',
    'chatAiDevis.infoBadgesLabel': 'Badges:',
    'chatAiDevis.infoBadgesCheck': '— check the part before approval.',
    'chatAiDevis.infoBotStaffExplain': '(right panel) — describe a repair to create the drafts, or type « comparer » to see all suppliers.',
    'chatAiDevis.loading': 'Loading…',
    'chatAiDevis.noQuotesPending': 'No pending quotes.',
    'chatAiDevis.noQuotes': 'No quotes.',
    'chatAiDevis.emptyHint': 'Use the Auto-Devis Bot on the right to create one (e.g. « Screen iPhone 14 »).',
    'chatAiDevis.backToStaff': '← Back to staff area',
    'chatAiDevis.botAutoDevis': 'Auto-Devis Bot',
    'chatAiDevis.staffSpace': '← Staff area',
    'chatAiDevis.errPdfPreview': 'PDF preview error',
    'chatAiDevis.alertPurchaseMissingPrint': 'Purchase price missing — enter a price or refresh the part before printing.',
    'chatAiDevis.errPrintTicket': '80mm ticket printing error',
    'chatAiDevis.errRecalc': 'Recalculation error',
    'chatAiDevis.errPartNotFound': 'Part not found in the supplier cache',
    'chatAiDevis.errCompare': 'Supplier comparison error',
    'chatAiDevis.errAlternatives': 'Error loading alternatives',
    'chatAiDevis.errSaveIdentity': 'Error saving client details',
    'chatAiDevis.alertIdentityIncomplete': 'Client details incomplete: {{fields}}. Name, phone and email are required before approving and sending the quote.',
    'chatAiDevis.mailWillSend': 'An email with the PDF will be sent to: {{email}}',
    'chatAiDevis.noClientEmail': '(No client email — chat validation only)',
    'chatAiDevis.confirmApprove': 'Approve this quote and send it to the client?',
    'chatAiDevis.sumupWarn': 'Warning: the SumUp payment link could not be created ({{error}}). The email button will offer payment on click; check the SumUp API key in the settings.',
    'chatAiDevis.sumupUnavailable': 'SumUp unavailable',
    'chatAiDevis.approvedMailSent': 'Quote approved — email sent to {{email}}.',
    'chatAiDevis.approvedSent': 'Quote approved and sent to the client.',
    'chatAiDevis.errApprove': 'Validation error',
    'chatAiDevis.confirmApproveBatch': 'Approve the {{count}} quotes and send the summary to the client?',
    'chatAiDevis.batchApproved': '{{count}} quotes approved and sent to the client.',
    'chatAiDevis.errApproveBatch': 'Batch validation error',
    'chatAiDevis.promptRejectReason': 'Reason for rejection (optional):',
    'chatAiDevis.errGeneric': 'Error',
    'chatAiDevis.confirmDeleteDevis': 'Permanently delete quote {{ref}}?\n\nThis action is irreversible.',
    'chatAiDevis.errDelete': 'Deletion error',
    'chatAiDevis.confirmDeleteBatch': 'Permanently delete the {{count}} quotes in the batch?\n\nThis action is irreversible.',
    'chatAiDevis.errDeleteBatch': 'Batch deletion error',
    'saLayout.nav_dashboard': 'Dashboard',
    'saLayout.nav_analytics': 'Analytics',
    'saLayout.nav_companies': 'Companies',
    'saLayout.nav_subscriptions': 'Subscriptions',
    'saLayout.nav_users': 'Users',
    'saLayout.nav_stats': 'Statistics',
    'saLayout.nav_communications': 'Communications',
    'saLayout.nav_impersonation': 'Support Mode',
    'saLayout.nav_config': 'Configuration',
    'saLayout.nav_integrations': 'API Integrations',
    'saLayout.nav_security': 'Security (2FA)',
    'saLayout.nav_logs': 'Logs & Audit',
    'saLayout.super_admin': 'Super Admin',
    'saLayout.role_super_admin': 'Super Administrator',
    'saLayout.logout': 'Log out',
    'saLayout.top_bar_title': 'Super Admin Panel',
    'saConfig.error': 'Error',
    'saConfig.confirmMaintenance': 'Enable maintenance mode? Customers will no longer be able to access the platform.',
    'saConfig.title': 'Configuration',
    'saConfig.subtitle': 'Global platform settings',
    'saConfig.saved': 'Saved',
    'saConfig.saving': 'Saving...',
    'saConfig.save': 'Save',
    'saConfig.maintenanceTitle': 'Maintenance Mode',
    'saConfig.maintenanceDesc': 'Temporarily block customer access',
    'saConfig.generalSettings': 'General Settings',
    'saConfig.platformName': 'Platform name',
    'saConfig.gracePeriod': 'Grace period (days)',
    'saConfig.plans': 'Pricing Plans',
    'saConfig.planPrice': 'Price (EUR/month)',
    'saConfig.maxShops': 'Max shops',
    'saConfig.maxUsers': 'Max users',
    'saConfig.features': 'Features',
    'saImpersonation.title': 'Support Mode (Impersonation)',
    'saImpersonation.subtitle': 'Temporarily access a company\'s account',
    'saImpersonation.confirmEnter': 'Enter support mode for this company?',
    'saImpersonation.errorGeneric': 'Error',
    'saImpersonation.activeBannerTitle': 'Support Mode active',
    'saImpersonation.connectedAs': 'Connected as: {{name}}',
    'saImpersonation.stopSupport': 'Exit support mode',
    'saImpersonation.warningTitle': 'Warning — Sensitive feature',
    'saImpersonation.warningText': 'Impersonation gives you full access to the client\'s account. All your actions are logged. The client\'s password will never be changed.',
    'saImpersonation.searchPlaceholder': 'Search for a company...',
    'saImpersonation.emptyList': 'No company found',
    'saImpersonation.companyMeta': '{{email}} - Plan {{plan}}',
    'saImpersonation.enterBtn': 'Enter',
    'saPackages.title': 'Package management',
    'saPackages.subtitle': 'Directly replace the ZIPs and the Windows agent served in production.',
    'saPackages.refresh': 'Refresh',
    'saPackages.statAvailable': 'Available artifacts',
    'saPackages.statTotalSize': 'Total size',
    'saPackages.statAlert': 'Alert',
    'saPackages.alertText': 'Replacements overwrite the live file. There is no separate deletion.',
    'saPackages.statusAvailable': 'Available',
    'saPackages.statusMissing': 'Missing',
    'saPackages.download': 'Download',
    'saPackages.activeFile': 'Active file',
    'saPackages.size': 'Size',
    'saPackages.lastUpdate': 'Last update',
    'saPackages.uploadedBy': 'Uploaded by',
    'saPackages.replaceLiveFile': 'Replace the live file',
    'saPackages.uploading': 'Uploading…',
    'saPackages.replace': 'Replace',
    'saPackages.replaceHint': 'The chosen file directly replaces the one served to users on remobiles.com.',
    'saPackages.selectedFile': 'Selected file: {{name}}',
    'saPackages.errorLoad': 'Error loading files',
    'saPackages.downloadLinkUnavailable': 'Download link unavailable',
    'saPackages.downloadFailed': 'Download failed',
    'saPackages.selectFileFor': 'Select a file for {{label}}.',
    'saPackages.confirmReplace': 'Replace {{label}} now with {{name}}?',
    'saPackages.replaceSuccess': '{{label}} replaced successfully.',
    'saPackages.errorUpload': 'Error during upload',
    'saPackages.superAdminOnly': 'Super admin access only',
    'saPackages.superAdminDesc': 'This page lets you update the files currently served by remobiles.com. Public download links remain driven by the backend\'s signed routes.',
    'saDashboard.title': 'Dashboard',
    'saDashboard.subtitle': 'Overview of the {{brand}} platform',
    'saDashboard.companies': 'Companies',
    'saDashboard.activeCount': '{{count}} active',
    'saDashboard.users': 'Users',
    'saDashboard.shops': 'Shops',
    'saDashboard.mrr': 'MRR',
    'saDashboard.mrrSub': 'Monthly recurring revenue',
    'saDashboard.newThisMonth': 'New this month',
    'saDashboard.expired': 'Expired',
    'saDashboard.suspended': 'Suspended',
    'saDashboard.recentCompanies': 'Recent companies',
    'saDashboard.viewAll': 'View all',
    'saDashboard.noCompanies': 'No companies yet',
    'saDashboard.recentActivity': 'Recent activity',
    'saDashboard.noActivity': 'No recent activity',
    'saAnalytics.title': 'Platform Analytics',
    'saAnalytics.subtitle': 'Global KPIs and performance by company',
    'saAnalytics.kpiRepairsToday': 'Repairs today',
    'saAnalytics.kpiActiveRepairs': 'Active repairs',
    'saAnalytics.kpiRevenueMonth': 'Revenue this month',
    'saAnalytics.kpiClientsTotal': 'Total clients',
    'saAnalytics.kpiRepairsWeek': 'Repairs this week',
    'saAnalytics.kpiRepairsMonth': 'Repairs this month',
    'saAnalytics.kpiRepairsTotal': 'Total repairs',
    'saAnalytics.kpiRevenueTotal': 'Total revenue',
    'saAnalytics.kpiActiveCompanies': 'Active companies',
    'saAnalytics.companyPerformance': 'Performance by company',
    'saAnalytics.companiesCount': '{{count}} companies',
    'saAnalytics.emptyCompanies': 'No active companies',
    'saAnalytics.colCompany': 'Company',
    'saAnalytics.colPlan': 'Plan',
    'saAnalytics.colRepairs': 'Repairs',
    'saAnalytics.colActive': 'Active',
    'saAnalytics.colClients': 'Clients',
    'saAnalytics.colStock': 'Stock',
    'saAnalytics.colSales': 'Sales',
    'saAnalytics.colRevenue': 'Revenue',
    'saAnalytics.colAvgTime': 'Avg. time',
    'saAnalytics.daysShort': '{{n}}d',
    'saLogs.title': 'Log & Security',
    'saLogs.subtitle': 'Action audit and system health',
    'saLogs.systemHealth': 'System Health',
    'saLogs.database': 'Database',
    'saLogs.statusOk': 'OK',
    'saLogs.statusError': 'Error',
    'saLogs.filterAll': 'All actions',
    'saLogs.filterCreateCompany': 'Company creation',
    'saLogs.filterUpdateCompany': 'Company update',
    'saLogs.filterSuspend': 'Suspension',
    'saLogs.filterActivate': 'Reactivation',
    'saLogs.filterImpersonate': 'Impersonation',
    'saLogs.filterCreateUser': 'User creation',
    'saLogs.filterDeleteUser': 'User deletion',
    'saLogs.filterResetPassword': 'Password reset',
    'saLogs.filterUpdateSubscription': 'Subscription update',
    'saLogs.filterUpdateConfig': 'Config update',
    'saLogs.entriesCount': '{{count}} entries',
    'saLogs.empty': 'No entries in the log',
    'saLogs.onTarget': 'on {{target}}',
    'saLogs.byUserAt': 'by {{user}} - {{date}}',
    'saComm.title': 'Communications',
    'saComm.messagesSent': '{{count}} messages sent',
    'saComm.newMessage': 'New message',
    'saComm.emptyList': 'No communication sent',
    'saComm.noSubject': 'No subject',
    'saComm.allClients': 'All clients',
    'saComm.companiesCount': '{{count}} company(ies)',
    'saComm.modalTitle': 'Send a communication',
    'saComm.typeLabel': 'Type',
    'saComm.typeNotification': 'Notification',
    'saComm.typeMaintenance': 'Maintenance',
    'saComm.typeUpdate': 'Update',
    'saComm.recipients': 'Recipients',
    'saComm.targetSelected': 'Selection',
    'saComm.targetedCompanies': 'Targeted companies',
    'saComm.subjectLabel': 'Subject *',
    'saComm.messageLabel': 'Message *',
    'saComm.cancel': 'Cancel',
    'saComm.send': 'Send',
    'saComm.errorGeneric': 'Error',
    'saSecurity.pageTitle': 'Account security',
    'saSecurity.pageSubtitle': '2FA, IP restriction and security settings',
    'saSecurity.errorGeneric': 'Error',
    'saSecurity.twoFAEnabledSuccess': '2FA enabled successfully!',
    'saSecurity.invalidCode': 'Invalid code',
    'saSecurity.twoFADisabled': '2FA disabled',
    'saSecurity.saveError': 'Error while saving',
    'saSecurity.twoFATitle': 'Two-factor authentication (2FA)',
    'saSecurity.statusEnabled': 'Enabled',
    'saSecurity.statusDisabled': 'Disabled',
    'saSecurity.setupBtn': 'Set up 2FA',
    'saSecurity.scanQrInstruction': 'Scan this QR code with Google Authenticator:',
    'saSecurity.qrCodeAlt': 'QR code',
    'saSecurity.manualKeyInstruction': 'Or enter this key manually:',
    'saSecurity.verificationCodeLabel': 'Verification code',
    'saSecurity.verifyBtn': 'Verify',
    'saSecurity.disableInstruction': 'To disable 2FA, enter your current code:',
    'saSecurity.ipRestrictionTitle': 'IP restriction (optional)',
    'saSecurity.ipRestrictionSubtitle': 'Restrict super admin access to certain IP addresses',
    'saSecurity.ipPlaceholder': 'One IP per line (e.g. 192.168.1.1)',
    'saSecurity.saved': 'Saved',
    'saSecurity.save': 'Save',
    'saStats.title': 'Business Statistics',
    'saStats.subtitle': 'Financial analysis and projections',
    'saStats.mrrTitle': 'Monthly Recurring Revenue (MRR)',
    'saStats.planDistTitle': 'Plan Distribution',
    'saStats.emptyData': 'No data',
    'saStats.churnTitle': 'Churn Rate',
    'saStats.cancelledCount': '{{count}} cancelled',
    'saStats.growthTitle': 'Growth - New companies',
    'repairUi.repairs': 'Repairs',
    'repairUi.repairSheet': 'Repair record',
    'repairUi.edit': 'Edit',
    'repairUi.print': 'Print',
    'repairUi.backToRepairs': 'Back to repairs',
    'repairUi.editRepair': 'Edit repair',
    'repairUi.newDeposit': 'New drop-off',
    'repairUi.ref': 'Ref',
    'saSubscriptions.title': 'Subscriptions',
    'saSubscriptions.count': '{{count}} subscriptions',
    'saSubscriptions.filter_all_statuses': 'All statuses',
    'saSubscriptions.filter_all_plans': 'All plans',
    'saSubscriptions.status_active': 'Active',
    'saSubscriptions.status_suspended': 'Suspended',
    'saSubscriptions.status_expired': 'Expired',
    'saSubscriptions.status_overdue': 'Overdue',
    'saSubscriptions.status_cancelled': 'Cancelled',
    'saSubscriptions.col_company': 'Company',
    'saSubscriptions.col_plan': 'Plan',
    'saSubscriptions.col_price': 'Price',
    'saSubscriptions.col_status': 'Status',
    'saSubscriptions.col_next_billing': 'Next billing',
    'saSubscriptions.col_discount': 'Discount',
    'saSubscriptions.col_actions': 'Actions',
    'saSubscriptions.empty': 'No subscriptions',
    'saSubscriptions.action_edit': 'Edit',
    'saSubscriptions.action_extend': 'Extend',
    'saSubscriptions.modal_title': 'Edit subscription',
    'saSubscriptions.label_discount': 'Discount (%)',
    'saSubscriptions.plan_option_start': 'Start ({{price}})',
    'saSubscriptions.plan_option_pro': 'Pro ({{price}})',
    'saSubscriptions.plan_option_super': 'Super ({{price}})',
    'saSubscriptions.cancel': 'Cancel',
    'saSubscriptions.save': 'Save',
    'saSubscriptions.prompt_extend_days': 'Number of days to add:',
    'saSubscriptions.error': 'Error',
    'saUsers.title': 'Users',
    'saUsers.totalUsers': '{{count}} users',
    'saUsers.newUser': 'New user',
    'saUsers.searchPlaceholder': 'Search...',
    'saUsers.filterAllRoles': 'All roles',
    'saUsers.roleSuperAdmin': 'Super Admin',
    'saUsers.roleAdmin': 'Admin',
    'saUsers.roleUser': 'Employee',
    'saUsers.roleTechnicien': 'Technician',
    'saUsers.roleClient': 'Client',
    'saUsers.roleB2b': 'B2B',
    'saUsers.emptyState': 'No users found',
    'saUsers.colUser': 'User',
    'saUsers.colRole': 'Role',
    'saUsers.colCompany': 'Company',
    'saUsers.colCreatedAt': 'Created on',
    'saUsers.colActions': 'Actions',
    'saUsers.resetPassword': 'Reset password',
    'saUsers.delete': 'Delete',
    'saUsers.labelUsername': 'Username',
    'saUsers.labelEmail': 'Email',
    'saUsers.labelPassword': 'Password',
    'saUsers.companyNone': 'None',
    'saUsers.cancel': 'Cancel',
    'saUsers.create': 'Create',
    'saUsers.labelNewPassword': 'New password',
    'saUsers.reset': 'Reset',
    'saUsers.error': 'Error',
    'saUsers.resetSuccess': 'Password reset successfully',
    'saUsers.confirmDelete': 'Delete user {{username}}?',
    'saCompanies.status_active': 'Active',
    'saCompanies.status_suspended': 'Suspended',
    'saCompanies.status_overdue': 'Overdue',
    'saCompanies.status_archived': 'Archived',
    'saCompanies.error': 'Error',
    'saCompanies.confirm_suspend': 'Suspend this company?',
    'saCompanies.suspend_reason_manual': 'Suspended manually',
    'saCompanies.confirm_archive': 'Archive this company? This action is irreversible.',
    'saCompanies.reminder_sent': 'Reminder email sent',
    'saCompanies.reminder_error': 'Error while sending',
    'saCompanies.title': 'Companies',
    'saCompanies.total_companies': '{{count}} companies in total',
    'saCompanies.new_company': 'New company',
    'saCompanies.search_placeholder': 'Search...',
    'saCompanies.filter_all_status': 'All statuses',
    'saCompanies.filter_overdue': 'Overdue',
    'saCompanies.filter_all_plans': 'All plans',
    'saCompanies.empty': 'No company found',
    'saCompanies.col_company': 'Company',
    'saCompanies.col_plan': 'Plan',
    'saCompanies.col_status': 'Status',
    'saCompanies.col_users': 'Users',
    'saCompanies.col_registered': 'Registered on',
    'saCompanies.col_actions': 'Actions',
    'saCompanies.action_view': 'View',
    'saCompanies.action_reminder': 'Send a payment reminder',
    'saCompanies.action_suspend': 'Suspend',
    'saCompanies.action_reactivate': 'Reactivate',
    'saCompanies.action_archive': 'Archive',
    'saCompanies.field_company_name': 'Company name',
    'saCompanies.field_contact': 'Main contact',
    'saCompanies.field_email': 'Email',
    'saCompanies.field_phone': 'Phone',
    'saCompanies.field_address': 'Address',
    'saCompanies.field_plan': 'Subscription plan',
    'saCompanies.plan_option_start': 'Start ({{price}}/month)',
    'saCompanies.plan_option_pro': 'Pro ({{price}}/month)',
    'saCompanies.plan_option_super': 'Super ({{price}}/month)',
    'saCompanies.field_shop_count': 'Number of shops',
    'saCompanies.admin_account': 'Company admin account',
    'saCompanies.field_admin_email': 'Admin email',
    'saCompanies.field_password': 'Password',
    'saCompanies.field_notes': 'Internal notes',
    'saCompanies.cancel': 'Cancel',
    'saCompanies.create_company': 'Create company',
    'saCompanies.users_count': '{{count}} users',
    'saCompanies.subscription': 'Subscription',
    'saCompanies.monthly_price': 'Monthly price',
    'saCompanies.next_billing': 'Next billing',
    'saCompanies.no_users': 'No users',
    'qrRouter.redirecting': 'Redirecting...',
    'subscriptionPages.verifyingPayment': 'Verifying payment...',
    'subscriptionPages.successTitle': 'Payment successful!',
    'subscriptionPages.successBody': 'Your subscription is now active.',
    'subscriptionPages.goToDashboard': 'Go to dashboard',
    'subscriptionPages.processingPayment': 'Payment being processed...',
    'subscriptionPages.errorTitle': 'Error',
    'subscriptionPages.errorBody': 'Unable to verify the payment.',
    'subscriptionPages.backToDashboard': 'Back to dashboard',
    'subscriptionPages.cancelTitle': 'Payment cancelled',
    'subscriptionPages.cancelBody': 'The payment was cancelled. You can try again at any time.',
    'common.error': 'Error',
    'notes.uploadError': 'Error during upload',
    'notes.downloadError': 'Error during download',
    'notes.confirmDeleteFile': 'Delete this file?',
    'notes.uploading': 'Uploading...',
    'notes.attach': 'Attach',
    'notes.addedBy': 'Added by {{author}} — {{date}}',
    'notes.sizeBytes': '{{size}} B',
    'notes.sizeKb': '{{size}} KB',
    'notes.sizeMb': '{{size}} MB',
    'historique.subtitle': 'Sales, receipts and deposits',
    'historique.centreActivite': 'Activity Center',
    'historique.filtresRecherche': 'Filters & search',
    'historique.rechercher': 'Search',
    'historique.searchPlaceholder': 'Item, reference…',
    'historique.vendeur': 'Seller',
    'historique.tous': 'All',
    'historique.dateDebut': 'Start date',
    'historique.dateFin': 'End date',
    'historique.magasin': 'Store',
    'historique.filtrer': 'Filter',
    'historique.reinitialiser': 'Reset',
    'historique.totalVentes': 'Total sales',
    'historique.totalAcomptes': 'Total deposits',
    'historique.totalRetraits': 'Total withdrawals',
    'historique.totalGlobal': 'Grand total',
    'historique.commVentes': 'Sales comm. ({{pct}}%)',
    'historique.commReparations': 'Repairs comm. ({{pct}}%)',
    'historique.commCommandes': 'Orders comm. ({{pct}}%)',
    'historique.totalCommissions': 'Total commissions',
    'historique.popupsAutoriser': 'Please allow pop-ups to print.',
    'historique.erreurTelechargement': 'Error during download',
    'historique.vendeurDatesRequis': 'Please enter seller + dates',
    'historique.erreurImpressionRapport': 'Error printing report',
    'historique.erreurConfirmationSumup': 'Error confirming SumUp',
    'historique.confirmRefusPaiement': 'Mark this payment as refused / cancelled?',
    'historique.erreurRefusSumup': 'Error refusing SumUp',
    'dash.forceOpen': 'Force open',
    'dash.force': 'Force',
    'dash.forceOpenTitle': 'Force open register {{magasin}}',
    'dash.forceOpenWarning': 'Any open register will be automatically closed. A new register will be created with the entered amount.',
    'dash.noOpenCaisseToForce': 'No open register to force-close for {{magasin}}.',
    'dash.thisMagasin': 'this store',
    'dash.statusOpenF': 'Open',
    'dash.statusClosedF': 'Closed',
    'dash.openMagasin': 'Open {{magasin}}',
    'dash.forceOpenShort': 'Force open',
    'dash.closeMagasin': 'Close {{magasin}}',
    'dash.forceCloseShort': 'Force close',
    'dash.subtitleNetwork': 'Network view · register · KPIs',
    'dash.subtitleWorkshop': 'Workshop · repairs',
    'dash.subtitleDefault': 'Dashboard · sales & activity',
    'dash.caisseActionsByStore': 'Register actions by store',
    'devisFactures.printPopupBlocked': 'Please allow pop-ups to print.',
    'devisFactures.errorPrintTicket': 'Ticket printing error',
    'devisFactures.errorPrintA4': 'A4 printing error',
    'devisFactures.errorConvert': 'Error converting to order',
    'devisFactures.errorDelete': 'Deletion error',
    'devisFactures.errorInvalidEmail': 'Invalid email address',
    'devisFactures.emailSent': '{{type}} sent to {{email}}',
    'devisFactures.errorSendEmail': 'Error sending email',
    'devisFactures.linkedTo': 'Linked to {{ref}}',
    'devisFactures.sendByEmail': 'Send by email',
    'devisFactures.detachConfirm': 'Detach this quote from {{ref}}?',
    'devisFactures.error': 'Error',
    'devisFactures.attachToRepair': 'Attach to a repair',
    'devisFactures.emailModalTitle': 'Send {{type}} by email',
    'devisFactures.refLabel': 'Ref:',
    'devisFactures.a4PdfNote': 'The document will be sent as an A4 PDF',
    'devisFactures.clientEmailLabel': 'Client email address',
    'devisFactures.emailPlaceholder': 'client@example.com',
    'devisFactures.labelDevis': 'Quote',
    'devisFactures.labelFacture': 'Invoice',
    'devisFactures.labelCommande': 'Order',
    'devisFactures.labelAvoir': 'Credit note',
    'devisFactures.labelPaye': 'Paid',
    'devisFactures.labelAnnule': 'Cancelled',
    'devisFactures.labelEnAttente': 'Pending',
    'clients.tabPins': 'PINs / Passwords',
    'clients.pin': 'PIN',
    'clients.error': 'Error',
    'clients.loadError': 'Loading error',
    'clients.saveError': 'Error while saving',
    'clients.sendError': 'Send error',
    'clients.noIdLegacy': 'This client has no ID (legacy). Edit it to update it.',
    'clients.ficheAccessDenied': 'Access denied: only the admin can view the client record.',
    'clients.pinGenerated': 'PIN {{pin}} generated for {{nom}}',
    'clients.ficheClient': 'Client record',
    'clients.optional': 'Optional',
    'clients.genNewPin': 'Generate new PIN',
    'clients.sendPinEmail': 'Send PIN by email',
    'clients.loyaltyLine': 'Loyalty: {{level}} — {{points}} pts — {{purchases}} purchases',
    'clients.repairs': 'Repairs',
    'clients.commandes': 'Orders',
    'clients.devis': 'Quotes',
    'clients.ventesPos': 'POS sales',
    'clients.acomptes': 'Deposits',
    'clients.noneFem': 'None',
    'clients.noneMasc': 'None',
    'cmd.clientPartsTitle': 'Client parts orders',
    'cmd.pageIntro': 'Add parts (in stock or to order) just like in a repair. Deposits are deducted from the total.',
    'cmd.deposits': 'Deposits',
    'cmd.remainingShort': 'Balance',
    'cmd.statusConverting': 'Converting',
    'cmd.repairBadge': 'Repair {{ref}}',
    'cmd.toOrderShort': 'to order',
    'cmd.stockOutShort': 'stock out',
    'cmd.inStockShort': 'in stock',
    'cmd.view': 'View',
    'cmd.addDeposit': '+ Deposit',
    'cmd.settled': 'Settled',
    'cmd.convertToRepair': 'Convert to repair',
    'cmd.trackingWith': 'Tracking: {{num}}',
    'cmd.trackingNumber': 'Tracking number',
    'cmd.newClientParts': 'New parts order',
    'cmd.partsSectionTitle': 'Parts (like in a repair)',
    'cmd.searchStockPlaceholder': 'Search for a part in stock…',
    'cmd.noRef': 'no ref.',
    'cmd.toOrder': 'to order',
    'cmd.stock': 'stock',
    'cmd.qtyShort': 'Qty',
    'cmd.unitPriceLabel': 'Unit price (€)',
    'cmd.stockSection': 'Stock',
    'cmd.alreadyOut': 'Already removed from stock',
    'cmd.decrementOnSave': 'Decrements on save',
    'cmd.stillInStock': 'Still in stock',
    'cmd.outOnConvert': 'Removed on repair conversion',
    'cmd.addPendingBtn': 'Part to order (out of stock)',
    'cmd.pendingTitle': 'Part to order',
    'cmd.designationPlaceholder': 'Designation *',
    'cmd.refOptPlaceholder': 'Ref. (opt.)',
    'cmd.salePricePlaceholder': 'Sale price €',
    'cmd.partsTotal': 'Parts total',
    'cmd.depositsPaid': 'Deposits already paid',
    'cmd.addDepositTitle': 'Add a deposit',
    'cmd.orderLabel': 'Order',
    'cmd.alreadyPaid': 'Already paid',
    'cmd.depositAmount': 'Deposit amount (€)',
    'cmd.paymentMode': 'Payment method',
    'cmd.payCash': 'Cash',
    'cmd.payCard': 'Card',
    'cmd.payTransfer': 'Transfer',
    'cmd.payCheck': 'Check',
    'cmd.newRemainingAfter': 'New balance after deposit:',
    'cmd.depositsPaidTitle': 'Deposits paid',
    'cmd.noDeposits': 'No deposit paid',
    'cmd.trackingPlaceholder': 'e.g. 8R123456789FR',
    'cmd.trackingEmailNote': 'An email will be sent to the client if an email is provided.',
    'cmd.error': 'Error',
    'cmd.errDesignationRequired': 'Designation required for the part to order',
    'cmd.errClientPhoneRequired': 'Client and phone required',
    'cmd.errAddPart': 'Add at least one part (stock search or part to order)',
    'cmd.errDelete': 'Error during deletion',
    'cmd.cancelConfirm': 'Cancel this order?',
    'cmd.errInvalidAmount': 'Invalid amount',
    'cmd.errDepositExceeds': 'The deposit cannot exceed the balance due ({{reste}})',
    'cmd.errPrintTicket': 'Ticket printing error',
    'cmd.errPrintDepositTicket': 'Deposit ticket printing error',
    'cmd.convertConfirm': 'Convert this order into a repair?',
    'cmd.errConvert': 'Repair conversion error',
    'cmd.promptClientEmail': 'Client email:',
    'cmd.emailSent': 'Order form sent to {{email}}',
    'cmd.errSendEmail': 'Email sending error',
    'cmd.errTracking': 'Tracking error',
    'pos.insufficientStock': 'Insufficient stock',
    'pos.partialPaymentConfirm': 'The amount paid ({{paid}}) is less than the total ({{total}}).\n\nRemaining to pay: {{remaining}}\n\nConfirm as a partial payment?',
    'pos.loyaltyRewardEarned': '\n\nLOYALTY: Congratulations! Reward unlocked! 15% off your next purchase or 10% off your next repair!',
    'pos.loyaltyRewardPending': '\n\nLOYALTY: Reward pending (15% off next POS purchase or 10% off a repair)',
    'pos.loyaltyProgress': '\n\nLOYALTY: {{points}}/10 purchases. Only {{remaining}} purchase(s) left before the reward!',
    'pos.partialPaymentLine': '\nPARTIAL PAYMENT - Remaining to pay: {{remaining}}',
    'pos.invoiceSentAuto': '\nInvoice sent automatically to {{email}}',
    'pos.offlineSaleMsg': '\n\nOFFLINE MODE - Sale saved locally.\nSynchronization will happen automatically once the Internet is back.\n(The email and stock update will happen at that time.)',
    'pos.refLabel': 'Ref: {{ref}}',
    'pos.totalLabel': 'Total: {{total}}',
    'pos.saleError': 'Error during the sale.\nHTTP code: {{code}}\nThe sale may not have been saved. Check the history.',
    'pos.unknownStatus': 'unknown',
    'pos.invalidEmailEnter': 'Please enter a valid email address',
    'pos.accountCreated': 'Client account created! The credentials have been sent by email.',
    'pos.accountCreateError': 'Error while creating the account',
    'pos.invalidAmount': 'Invalid amount',
    'pos.acompteDesignation': 'Repair deposit {{ref}}',
    'pos.designationPriceRequired': 'Description and price required',
    'pos.manualAddError': 'Manual add error',
    'pos.adminValidationFailed': 'Admin validation failed',
    'pos.printTicketError': 'Ticket printing error',
    'pos.notAllTicketsPrintedConfirm': '⚠️ You haven\'t printed all the tickets.\n\nThe client must have each ticket. Close anyway?',
    'pos.invalidEmail': 'Invalid email address',
    'pos.invoiceSentTo': 'Invoice sent to {{email}}',
    'pos.sendEmailError': 'Email sending error',
    'pos.caisseClosedOffline': 'Till closed. Connect to the Internet and open the till from the dashboard to make sales.',
    'pos.caisseCachedHint': 'Till status loaded from the local cache (offline mode). The final check will happen when the Internet is back.',
    'pos.catalog': 'Catalog',
    'pos.available': '{{count}} in stock',
    'pos.outOfStockShort': 'Out of stock',
    'pos.acompteRepair': 'Repair deposit',
    'pos.rewardAvailable': 'Reward available!',
    'pos.rewardAutoApplied': '-15% auto-applied',
    'pos.purchases': 'purchases',
    'pos.beforeReward': '({{count}} before reward)',
    'pos.searchClientPlaceholder': 'Search...',
    'pos.clientName': 'Client name',
    'pos.phone': 'Phone',
    'pos.emailOptional': 'Email (optional)',
    'pos.totalCaps': 'TOTAL',
    'pos.willGenerateTickets': 'This sale will generate {{count}} separate tickets:',
    'pos.neutralItems': 'neutral',
    'pos.attachedToSession': '(attached to the session)',
    'pos.clientEmailPlaceholder': 'Client email',
    'pos.sent': 'Sent',
    'pos.send': 'Send',
    'pos.alsoAddToStock': 'Also add to stock',
    'pos.offlineCbHint': 'Offline mode — card payment disabled (the terminal requires the network).',
    'pos.whichMagasinTitle': 'Which store should the sale be recorded in?',
    'pos.close': 'Close',
    'pos.magasinChoiceHelp': 'Choose the store to record this sale in. The selected store will be used for the sale and for items with no explicit store.',
    'pos.magasinLabel': 'Store {{code}}',
    'pos.currentPosSessionFull': 'Current POS session: {{code}}. If you pick another store, the POS session will switch to it for the sale.',
    'pos.validateFor': 'Confirm for {{magasin}}',
    'pos.createClientAccount': 'Create a client account?',
    'pos.createAccountPrompt': 'This client doesn\'t have an account yet. Would you like to create one so they can access their invoices online?',
    'pos.creating': 'Creating...',
    'pos.yesSendCredentials': 'Yes, send the credentials',
    'pos.noThanks': 'No thanks',
    'pos.searchRepair': 'Search for the repair',
    'pos.searchRepairPlaceholder': 'REP0047, client name, model...',
    'pos.priceLabel': 'Price: {{price}}',
    'pos.alreadyPaid': 'Already paid: {{amount}}',
    'pos.remainingDue': 'Remaining due: {{amount}}',
    'pos.changeSelection': 'Change',
    'pos.totalPrice': 'Total price',
    'pos.alreadyPaidShort': 'Already paid',
    'pos.remainingDueShort': 'Remaining due',
    'pos.acompteAmountLabel': 'Deposit amount (EUR)',
    'pos.addToCart': 'Add to cart',
    'pos.saleRecordedTickets': 'Sale recorded — {{count}} tickets generated',
    'pos.printAllForClient': 'Print the {{count}} tickets for the client.',
    'pos.printed': 'Printed',
    'pos.scanToFind': 'Scan to find {{ref}}',
    'pos.detailUnavailable': 'Details unavailable (offline mode?)',
    'pos.payment': 'Payment',
    'pos.printing': 'Printing...',
    'pos.printTicketFor': 'Print ticket {{magasin}}',
    'pos.allTicketsSentToPrint': 'All tickets have been sent to the printer.',
    'pos.ticketsPrintedCount': '{{printed}} / {{total}} ticket(s) printed.',
    'pos.printAllTickets': 'Print all tickets',
    'pos.articlesCount': '{{count}} item(s)',
    'activite.pageTitle': 'Activity Center',
    'activite.pageSubtitle': 'Unified timeline · sales · payments · register · stock · repairs',
    'activite.historiqueDetaille': 'Detailed history',
    'remcaches.err_connexion': 'Server connection error',
    'remcaches.err_champs_requis': 'Username and PIN code are required',
    'remcaches.err_pin_court': 'The PIN code must contain at least 4 digits',
    'remcaches.err_creation': 'Error during creation',
    'remcaches.config_initiale': 'Initial setup',
    'remcaches.deja_config': 'Setup already completed',
    'remcaches.admin_existe': 'An administrator already exists. This page is disabled.',
    'remcaches.aller_connexion': 'Go to login',
    'remcaches.admin_cree': 'Administrator created successfully!',
    'remcaches.label_utilisateur': 'Username:',
    'remcaches.label_role': 'Role:',
    'remcaches.conserver_identifiants': 'Keep these credentials in a safe place. This page will no longer be accessible.',
    'remcaches.se_connecter': 'Log in',
    'remcaches.label_username': 'Username *',
    'remcaches.ph_username': 'e.g. carlos',
    'remcaches.label_pin': 'PIN code (password) *',
    'remcaches.ph_pin': '4 to 6 digits',
    'remcaches.label_email': 'Email (optional)',
    'remcaches.label_telephone': 'Phone (optional)',
    'remcaches.btn_creer_admin': 'Create administrator',
    'remcaches.footer': 'R.E.Mobiles - Secure setup',
    'blog.page_title': 'Phone Repair Blog',
    'blog.subtitle': 'Tips, tricks and news about smartphone repair in French Guiana.',
    'blog.cta_title': 'Need a repair?',
    'blog.cta_desc': 'Contact Resurrection Mobile for a free quote.',
    'blog.loading': 'Loading...',
    'blog.article_not_found': 'Article not found',
    'blog.back_to_blog': 'Back to blog',
    'blog.home': 'Home',
    'blog.see_pricing': 'See our prices',
    'blog.footer_pricing': 'Our prices',
    'blog.empty_title': 'No articles yet',
    'blog.empty_subtitle': 'Come back soon to discover our tips!',
    'brandsModels.error': 'Error',
    'brandsModels.deleteBrandConfirm': 'Delete the brand "{{name}}" and all its models?',
    'brandsModels.noModels': 'No models.',
    'brandsModels.home': 'Home',
    'brandsModels.title': 'Brands & Models',
    'brandsModels.countBrands': '{{count}} brands',
    'brandsModels.countSeries': '{{count}} series',
    'brandsModels.countModels': '{{count}} models',
    'brandsModels.searchPlaceholder': 'Search a brand, series or model...',
    'brandsModels.newBrandPlaceholder': 'New brand...',
    'brandsModels.addBrand': 'Add',
    'brandsModels.loading': 'Loading...',
    'brandsModels.rename': 'Rename',
    'brandsModels.delete': 'Delete',
    'brandsModels.addModelPlaceholder': 'Add a {{brand}} model...',
    'brandsModels.addModel': 'Model',
    'brandsModels.deleteModel': 'Delete this model',
    'brandsModels.noResults': 'No results for this search',
    'brandsModels.empty': 'No brands. Add one above.',
    'allDocs.title': 'All documents',
    'allDocs.docsCount': '{{count}} documents',
    'allDocs.stat.devis': 'Quotes',
    'allDocs.stat.factures': 'Invoices',
    'allDocs.stat.bonsCmd': 'POs',
    'allDocs.stat.tickets': 'Tickets',
    'allDocs.stat.total': 'Total',
    'allDocs.searchPlaceholder': 'Search by ref, client, phone...',
    'allDocs.filter': 'Filter',
    'allDocs.filterAll': 'All',
    'allDocs.type.devis': 'Quote',
    'allDocs.type.facture': 'Invoice',
    'allDocs.type.bonCommande': 'Purchase order',
    'allDocs.type.ticket': 'Ticket',
    'allDocs.col.reference': 'Reference',
    'allDocs.col.type': 'Type',
    'allDocs.col.client': 'Client',
    'allDocs.col.telephone': 'Phone',
    'allDocs.col.total': 'Total',
    'allDocs.col.statut': 'Status',
    'allDocs.col.liaisons': 'Links',
    'allDocs.col.date': 'Date',
    'allDocs.col.actions': 'Actions',
    'allDocs.loading': 'Loading...',
    'allDocs.empty': 'No document found',
    'allDocs.status.devis': 'Quote',
    'allDocs.status.enAttente': 'Pending',
    'allDocs.status.accepte': 'Accepted',
    'allDocs.status.refuse': 'Refused',
    'allDocs.status.payee': 'Paid',
    'allDocs.status.commande': 'Ordered',
    'allDocs.status.enCours': 'In progress',
    'allDocs.status.recu': 'Received',
    'allDocs.status.livre': 'Delivered',
    'allDocs.status.termine': 'Completed',
    'allDocs.action.print': 'Print / View PDF',
    'allDocs.action.download': 'Download PDF',
    'allDocs.action.email': 'Send by email',
    'allDocs.footerCount': '{{count}} document shown',
    'allDocs.footerCountPlural': '{{count}} documents shown',
    'allDocs.printUnavailable': '80 mm ticket printing unavailable for this document (source={{source}}).',
    'allDocs.downloadUnavailable': 'Download unavailable for this type of document (source={{source}}).',
    'allDocs.emailUnavailable': 'Email sending unavailable for this type of document (source={{source}}).',
    'allDocs.emailPrompt': 'Recipient email:',
    'allDocs.emailSent': 'Email sent!',
    'allDocs.error': 'Error: {{msg}}',
    'themeSettings.title': 'Color customization',
    'themeSettings.subtitle': 'Customize the look of your platform',
    'themeSettings.cancel': 'Cancel',
    'themeSettings.saved': 'Saved',
    'themeSettings.saving': 'Saving...',
    'themeSettings.save': 'Save',
    'themeSettings.presetsTitle': 'Preset palettes',
    'themeSettings.customTitle': 'Custom colors',
    'themeSettings.previewTitle': 'Live preview',
    'themeSettings.previewCompany': 'My Company',
    'themeSettings.previewPrimaryBtn': 'Primary Button',
    'themeSettings.previewSecondaryBtn': 'Secondary Button',
    'themeSettings.previewNavDashboard': 'Dashboard',
    'themeSettings.previewNavRepairs': 'Repairs',
    'themeSettings.previewNavStock': 'Stock',
    'themeSettings.previewNavClients': 'Clients',
    'themeSettings.previewStatusInProgress': 'In progress',
    'themeSettings.previewStatusPending': 'Pending',
    'themeSettings.fieldPrimaryLabel': 'Primary Color',
    'themeSettings.fieldPrimaryDesc': 'Buttons, links, main accents',
    'themeSettings.fieldSecondaryLabel': 'Secondary Color',
    'themeSettings.fieldSecondaryDesc': 'Badges, indicators, secondary accents',
    'themeSettings.fieldAccentLabel': 'Accent Color',
    'themeSettings.fieldAccentDesc': 'Header background, contrasting text',
    'themeSettings.fieldSidebarBgLabel': 'Sidebar Background',
    'themeSettings.fieldSidebarBgDesc': 'Background of the side menu',
    'themeSettings.fieldSidebarTextLabel': 'Sidebar Text',
    'themeSettings.fieldSidebarTextDesc': 'Text color in the menu',
    'themeSettings.fieldHeaderBgLabel': 'Header Background',
    'themeSettings.fieldHeaderBgDesc': 'Background of the top bar',
    'themeSettings.presetRougeJaune': 'Red & Yellow',
    'themeSettings.presetGuyane': 'Guyane',
    'themeSettings.presetOceanBleu': 'Blue Ocean',
    'themeSettings.presetRoyalViolet': 'Royal Purple',
    'themeSettings.presetEmeraude': 'Emerald',
    'themeSettings.presetSunset': 'Sunset',
    'boutiqueCmd.pageTitle': 'E-shop Orders',
    'boutiqueCmd.deleteSelection': 'Delete selection ({{count}})',
    'boutiqueCmd.confirmDelete': 'Delete {{count}} order(s)?',
    'boutiqueCmd.errUpdate': 'Error during update',
    'boutiqueCmd.errDelete': 'Error during deletion',
    'boutiqueCmd.noteSent': '✅ Note sent to the customer successfully',
    'boutiqueCmd.errSendNote': 'Error sending the note',
    'boutiqueCmd.trackingSavedEmail': '✅ Tracking number saved and email sent to the customer!',
    'boutiqueCmd.trackingSaved': '✅ Tracking number saved!',
    'boutiqueCmd.errSaveTracking': 'Error while saving',
    'boutiqueCmd.confirmValidateProof': 'Validate this payment proof?',
    'boutiqueCmd.confirmRejectProof': 'Reject this payment proof?',
    'boutiqueCmd.errGeneric': 'Error',
    'boutiqueCmd.errDownload': 'Error during download',
    'boutiqueCmd.statutEnAttente': 'Pending',
    'boutiqueCmd.statutProofUploaded': 'Proof uploaded',
    'boutiqueCmd.statutPayee': 'Paid',
    'boutiqueCmd.statutConfirmee': 'Confirmed',
    'boutiqueCmd.statutPreparee': 'Prepared',
    'boutiqueCmd.statutExpediee': 'Shipped',
    'boutiqueCmd.statutLivree': 'Delivered',
    'boutiqueCmd.statutAnnulee': 'Cancelled',
    'boutiqueCmd.colReference': 'Reference',
    'boutiqueCmd.colClient': 'Customer',
    'boutiqueCmd.colArticles': 'Items',
    'boutiqueCmd.colTotal': 'Total',
    'boutiqueCmd.colAdresse': 'Address',
    'boutiqueCmd.colStatut': 'Status',
    'boutiqueCmd.colSuivi': 'Tracking',
    'boutiqueCmd.colPaiement': 'Payment',
    'boutiqueCmd.colDate': 'Date',
    'boutiqueCmd.colActions': 'Actions',
    'boutiqueCmd.noOrders': 'No orders',
    'boutiqueCmd.editTracking': 'Edit',
    'boutiqueCmd.addTrackingTitle': 'Add tracking number',
    'boutiqueCmd.addTrackingBtn': '+ Tracking',
    'boutiqueCmd.viewProof': 'View proof',
    'boutiqueCmd.validatePayment': 'Validate payment',
    'boutiqueCmd.rejectProof': 'Reject proof',
    'boutiqueCmd.validated': 'Validated',
    'boutiqueCmd.notesMessages': 'Notes/Messages',
    'boutiqueCmd.notesModalTitle': 'Notes & Messages - Order {{ref}}',
    'boutiqueCmd.clientLabel': 'Customer:',
    'boutiqueCmd.phoneLabel': 'Phone:',
    'boutiqueCmd.deliveryAddressLabel': 'Delivery address:',
    'boutiqueCmd.notSpecified': 'Not specified',
    'boutiqueCmd.exchangeHistory': 'Conversation history',
    'boutiqueCmd.noNote': 'No notes for this order',
    'boutiqueCmd.staff': '👤 Staff',
    'boutiqueCmd.client': '👥 Customer',
    'boutiqueCmd.clientResponse': 'Customer reply:',
    'boutiqueCmd.sendMessageTitle': '✉️ Send a message to the customer',
    'boutiqueCmd.notePlaceholder': 'e.g. Hello, could you confirm your delivery address? Thank you.',
    'boutiqueCmd.noteHint': '💡 The customer will receive this message and can reply from their customer area',
    'boutiqueCmd.close': 'Close',
    'boutiqueCmd.sending': 'Sending...',
    'boutiqueCmd.sendToClient': 'Send to customer',
    'boutiqueCmd.trackingNumber': 'Tracking number',
    'boutiqueCmd.orderShortLabel': 'Order:',
    'boutiqueCmd.clientShortLabel': 'Customer:',
    'boutiqueCmd.trackingPlaceholder': 'e.g. LA123456789FR',
    'boutiqueCmd.trackingHint': 'The customer will see this number in their area',
    'boutiqueCmd.cancel': 'Cancel',
    'boutiqueCmd.saving': 'Saving...',
    'boutiqueCmd.save': 'Save',
    'blogAdmin.confirmDelete': 'Delete this article?',
    'blogAdmin.pageTitle': 'Blog & SEO Articles',
    'blogAdmin.pageSubtitle': 'Publish articles and manage the blog content',
    'blogAdmin.viewBlog': 'View blog',
    'blogAdmin.newArticle': 'New article',
    'blogAdmin.tabArticles': 'Articles',
    'blogAdmin.tabContent': 'Page content',
    'blogAdmin.editArticle': 'Edit article',
    'blogAdmin.fieldTitle': 'Title *',
    'blogAdmin.titlePlaceholder': 'e.g. iPhone screen repair in Cayenne: prices and lead times',
    'blogAdmin.fieldExcerpt': 'Excerpt (preview)',
    'blogAdmin.excerptPlaceholder': 'Short description for the list...',
    'blogAdmin.fieldContent': 'Content * (Markdown supported)',
    'blogAdmin.contentPlaceholder': 'Write your article here...',
    'blogAdmin.fieldTags': 'Tags (comma-separated)',
    'blogAdmin.tagsPlaceholder': 'repair, iphone, cayenne',
    'blogAdmin.fieldMeta': 'SEO meta description',
    'blogAdmin.metaPlaceholder': 'Description for Google (160 char. max)',
    'blogAdmin.publishNow': 'Publish immediately',
    'blogAdmin.update': 'Update',
    'blogAdmin.save': 'Save',
    'blogAdmin.loading': 'Loading...',
    'blogAdmin.noArticles': 'No articles',
    'blogAdmin.noArticlesHint': 'Create your first article to improve SEO',
    'blogAdmin.statusPublished': 'PUBLISHED',
    'blogAdmin.statusDraft': 'DRAFT',
    'blogAdmin.byAuthor': 'By {{author}}',
    'blogAdmin.unpublish': 'Unpublish',
    'blogAdmin.publish': 'Publish',
    'blogAdmin.loadingContent': 'Loading content...',
    'blogAdmin.contentNotice1': 'Edit here the content shown on the public page ',
    'blogAdmin.contentNotice2': '. Changes will be visible immediately.',
    'blogAdmin.blogHeader': 'Blog header',
    'blogAdmin.mainTitle': 'Main title',
    'blogAdmin.accentWord': 'Colored word (accent)',
    'blogAdmin.description': 'Description',
    'blogAdmin.ctaSection': 'Call to action (CTA in articles)',
    'blogAdmin.ctaTitle': 'CTA title',
    'blogAdmin.ctaDescription': 'CTA description',
    'blogAdmin.footerSection': 'Footer',
    'blogAdmin.footerText': 'Footer text',
    'blogAdmin.hidePreview': 'Hide preview',
    'blogAdmin.livePreview': 'Live preview',
    'blogAdmin.savedSuccess': 'Saved successfully!',
    'blogAdmin.saving': 'Saving...',
    'blogAdmin.saveContent': 'Save content',
    'blogAdmin.previewLabel': 'Blog page preview',
    'businessCard.title': 'Business cards',
    'businessCard.subtitle': 'Templates, editing and A4 printing (10 cards)',
    'businessCard.previewBtn': 'Preview',
    'businessCard.edit': 'Edit',
    'businessCard.printA4': 'Print A4 (10 cards)',
    'businessCard.chooseTemplate': 'Choose a template ({{count}} available)',
    'businessCard.tplName.classic': 'Classic',
    'businessCard.tplName.modern': 'Modern',
    'businessCard.tplName.gradient': 'Gradient',
    'businessCard.tplName.minimal': 'Minimalist',
    'businessCard.tplName.gold': 'Gold Premium',
    'businessCard.tplName.ocean': 'Ocean',
    'businessCard.tplName.forest': 'Forest',
    'businessCard.tplName.sunset': 'Sunset',
    'businessCard.tplName.corporate': 'Corporate',
    'businessCard.tplName.pastel': 'Rose Pastel',
    'businessCard.tplDesc.classic': 'Clean and professional',
    'businessCard.tplDesc.modern': 'Sleek with cyan accent',
    'businessCard.tplDesc.gradient': 'Vibrant gradient background',
    'businessCard.tplDesc.minimal': 'White and crisp',
    'businessCard.tplDesc.gold': 'Luxurious black and gold',
    'businessCard.tplDesc.ocean': 'Soothing deep blue',
    'businessCard.tplDesc.forest': 'Elegant nature green',
    'businessCard.tplDesc.sunset': 'Warm orange',
    'businessCard.tplDesc.corporate': 'Professional navy blue',
    'businessCard.tplDesc.pastel': 'Soft and feminine',
    'businessCard.logoTransparent': 'Logo with transparent background',
    'businessCard.cardInfo': 'Card information',
    'businessCard.field.companyName': 'Company name',
    'businessCard.field.subtitle': 'Subtitle / Activity',
    'businessCard.field.ownerName': 'Manager\'s name',
    'businessCard.field.ownerTitle': 'Title / Position',
    'businessCard.field.phone': 'Phone',
    'businessCard.field.email': 'Email',
    'businessCard.field.address': 'Address',
    'businessCard.field.city': 'City / Postal code',
    'businessCard.field.website': 'Website',
    'businessCard.field.siret': 'SIRET',
    'businessCard.reset': 'Reset',
    'businessCard.previewTitle': 'Preview — {{name}}',
    'businessCard.viewFront': 'View front',
    'businessCard.viewBack': 'View back',
    'businessCard.standardFormat': 'Standard format: 85 x 55 mm',
    'businessCard.allTemplates': 'All templates',
    'businessCard.printTitle': 'Business Cards',
    'businessCard.recto': 'FRONT',
    'businessCard.verso': 'BACK',
    'hub.title': 'Hub',
    'hub.refresh': 'Refresh',
    'hub.kpiTicketsOpen': '{{n}} open tickets',
    'hub.kpiFacturesToday': '{{n}} invoices today ({{total}})',
    'hub.kpiDevisOpen': '{{n}} open quotes',
    'hub.magasinDefaultName': 'Store 1',
    'hub.magasinBadgeTitle': 'Current store (POS) — {{name}}',
    'hub.counterViewDetailed': 'Detailed view',
    'hub.counterViewCompact': 'Compact view',
    'hub.counterMagasinTitle': '{{name}} — {{tickets}} tickets · {{devis}} quotes · {{total}}',
    'hub.counterCompact': '{{tickets}}T·{{devis}}Q·{{total}}',
    'hub.counterTickets': 'tickets',
    'hub.counterDevis': 'quotes',
    'hub.counterPerDay': '€/day',
    'hub.searchPlaceholder': 'Search a REF (REM0143, POS-..., DEV-00002), a client, a phone…',
    'hub.filterAll': 'All',
    'hub.filterToday': 'Today',
    'hub.filterOverdue': 'Overdue',
    'hub.filterPaid': 'Paid',
    'hub.filterUnpaid': 'Unpaid',
    'hub.columnReparations': 'Repairs',
    'hub.columnFactures': 'Invoices',
    'hub.columnDevis': 'Quotes',
    'hub.seeAll': 'See all',
    'hub.empty': 'No items',
    'hub.actionView': 'View',
    'hub.actionPrint': 'Print',
    'hub.actionMail': 'Send by email',
    'hub.actionMarkReady': 'Mark as ready',
    'hub.walkinClient': 'Walk-in client',
    'hub.invoicedAs': '→ Invoiced: {{ref}}',
    'hub.errorPrint': 'Error while printing',
    'hub.errorPopupBlocked': 'Please allow pop-ups to print.',
    'hub.statusWaiting': 'Pending',
    'hub.statusInProgress': 'In progress',
    'hub.statusReady': 'Ready',
    'hub.statusDelivered': 'Delivered',
    'hub.statusPaid': 'Paid',
    'hub.statusInvoiced': 'Invoiced',
    'hub.statusSent': 'Sent',
    'hub.statusAccepted': 'Accepted',
    'hub.statusCancelled': 'Cancelled',
    'hub.statusDone': 'Done',
    'subscription.title': 'My subscription',
    'subscription.subtitle': 'Manage your plan and billing',
    'subscription.currentPlan': 'Current plan',
    'subscription.status': 'Status',
    'subscription.statusActive': 'Active',
    'subscription.statusTrial': 'Free trial',
    'subscription.monthlyPrice': 'Monthly price',
    'subscription.perMonth': '/mo',
    'subscription.nextBilling': 'Next payment',
    'subscription.changePlan': 'Change plan',
    'subscription.redirecting': 'Redirecting...',
    'subscription.upgrade': 'Upgrade',
    'subscription.downgrade': 'Downgrade',
    'subscription.upgradeTitle': 'Plan upgrade',
    'subscription.downgradeTitle': 'Plan downgrade',
    'subscription.newPlan': 'New plan',
    'subscription.newMonthlyPrice': 'New monthly price',
    'subscription.upgradeDiffNow': 'Difference to pay now',
    'subscription.changeFee': 'Change fee',
    'subscription.downgradeFeeNotice': 'A fixed fee of {{amount}} applies to any plan downgrade.',
    'subscription.cancel': 'Cancel',
    'subscription.confirmWithAmount': 'Confirm ({{amount}})',
    'subscription.toastChanged': 'Your plan was changed successfully!',
    'subscription.toastCancelled': 'The plan change was cancelled.',
    'subscription.errorPreview': 'Error during preview',
    'subscription.errorChange': 'Error while changing plan',
    'subscription.featStartRepairs': 'Repair management',
    'subscription.featStartClients': 'Customer tracking',
    'subscription.featStartQuotesInvoices': 'Quotes & Invoices',
    'subscription.featStartOnePos': '1 point of sale',
    'subscription.featProAllStart': 'Everything in the Start plan',
    'subscription.featProMultiUsers': 'Multi-user',
    'subscription.featProAdvancedStats': 'Advanced statistics',
    'subscription.featProThreePos': '3 points of sale',
    'subscription.featProPrioritySupport': 'Priority support',
    'subscription.featSuperAllPro': 'Everything in the Pro plan',
    'subscription.featSuperUnlimitedPos': 'Unlimited points of sale',
    'subscription.featSuperCustomApi': 'Custom API',
    'subscription.featSuperDedicatedSupport': 'Dedicated 24/7 support',
    'subscription.featSuperWhiteLabel': 'White label',
    'terms.title': 'Terms of Service',
    'terms.edition': 'June 2026',
    'terms.introBefore': 'These terms govern the use of the',
    'terms.introMiddle': ' website, the customer area, the support chat and the repair services provided by',
    'terms.introAfter': ', SASU, Cayenne, French Guiana.',
    'terms.acceptIntro': 'By creating an account or contacting us (website, chat, WhatsApp), you accept these terms as well as our',
    'terms.privacyPolicy': 'privacy policy',
    'terms.servicesTitle': 'Services',
    'terms.servicesBody': 'Phone repair and sales, after-sales tracking, quotes, online payments when enabled, support via chat or WhatsApp Business.',
    'terms.pricingTitle': 'Pricing',
    'terms.pricingBody': 'Quotes and prices communicated (in store, chat, WhatsApp) are indicative until confirmed at the point of sale.',
    'terms.dataTitle': 'Personal data',
    'terms.dataBefore': 'Your data is processed in accordance with the GDPR. Deletion request:',
    'terms.dataAfter': 'or see the “Your rights” section of the privacy policy.',
    'terms.contactTitle': 'Contact',
    'notifSettings.title': 'Push notifications',
    'notifSettings.intro': 'Get a native alert (Windows / macOS / Android) as soon as an important event happens in the shop. Reserved for R.E.Mobiles staff.',
    'notifSettings.statusUnsupported': 'Not supported (iOS 16.4+ required)',
    'notifSettings.statusBlocked': 'Blocked (permission denied)',
    'notifSettings.statusEnabled': 'Enabled on this browser',
    'notifSettings.statusDisabled': 'Not enabled',
    'notifSettings.activeCount': '{{count}} active subscription(s)',
    'notifSettings.enableBtn': 'Enable notifications',
    'notifSettings.testBtn': 'Send test notification',
    'notifSettings.disableBtn': 'Disable',
    'notifSettings.iosHintPre': 'On iPhone, web push notifications require',
    'notifSettings.iosHintPost': 'and the app installed on the home screen (PWA). Update your iPhone, then reinstall the app.',
    'notifSettings.blockedHint': 'Permission denied. Open the browser\'s site settings, allow notifications for this domain, then reload the page.',
    'notifSettings.categoriesTitle': 'Categories',
    'notifSettings.categoriesHint': 'Turn off whatever you don\'t want to receive. Applied immediately, for this account.',
    'notifSettings.catNewTicketLabel': 'New repair ticket',
    'notifSettings.catNewTicketDesc': 'A drop-off is created in the shop.',
    'notifSettings.catTicketReadyLabel': 'Ticket set to "Ready"',
    'notifSettings.catTicketReadyDesc': 'The technician marks the repair as ready. Remember to notify the customer.',
    'notifSettings.catNewInvoiceLabel': 'New POS invoice',
    'notifSettings.catNewInvoiceDesc': 'A sale has just been cashed.',
    'notifSettings.catNewChatLabel': 'New chat message',
    'notifSettings.catNewChatDesc': 'Staff, customer or B2B DM.',
    'notifSettings.catDevisLabel': 'Quote created or accepted',
    'notifSettings.catDevisDesc': 'A new quote is generated or a customer clicks Accept.',
    'notifSettings.accountLabel': 'Account',
    'notifSettings.roleLabel': 'Role',
    'notifSettings.totalSubsLabel': 'Total subscriptions',
    'notifSettings.errPermDenied': 'Permission denied. Enable notifications in the browser settings.',
    'notifSettings.errPermNotGranted': 'Permission not granted.',
    'notifSettings.errVapidUnavailable': 'VAPID key unavailable on the server.',
    'notifSettings.infoEnabled': 'Notifications enabled on this browser.',
    'notifSettings.errEnableFailed': 'Activation failed.',
    'notifSettings.infoDisabled': 'Notifications disabled on this browser.',
    'notifSettings.errDisableFailed': 'Deactivation failed.',
    'notifSettings.errPrefsUpdate': 'Failed to update preferences.',
    'notifSettings.infoTestSent': 'Test notification sent ({{sent}}/{{subs}}). Check your OS notification center.',
    'notifSettings.errNoneSent': 'No notification sent. Check that notifications are enabled on this browser.',
    'notifSettings.errTestFailed': 'Test failed.',
    'guyarepairLogin.subscriberSpace': 'Subscriber Area',
    'guyarepairLogin.businessLoginTitle': 'Business Login',
    'guyarepairLogin.businessLoginSubtitle': 'Sign in to your GUYAREPAIR dashboard',
    'guyarepairLogin.emailLabel': 'Email',
    'guyarepairLogin.emailPlaceholder': 'you@email.com',
    'guyarepairLogin.passwordLabel': 'Password',
    'guyarepairLogin.passwordPlaceholder': 'Your password',
    'guyarepairLogin.loggingIn': 'Signing in...',
    'guyarepairLogin.loginButton': 'Sign in',
    'guyarepairLogin.twoFATitle': '2FA Verification',
    'guyarepairLogin.twoFASubtitle': 'Enter the code from your authenticator app',
    'guyarepairLogin.otpLabel': '6-digit code',
    'guyarepairLogin.verifying': 'Verifying...',
    'guyarepairLogin.verifyButton': 'Verify',
    'guyarepairLogin.backToLogin': 'Back to login',
    'guyarepairLogin.notSubscribedYet': 'Not subscribed yet?',
    'guyarepairLogin.freeTrial': 'Free trial',
    'guyarepairLogin.secureConnection': 'Secure connection',
    'guyarepairLogin.guyarepairHome': 'GUYAREPAIR Home',
    'guyarepairLogin.errInvalidCredentials': 'Incorrect credentials',
    'guyarepairLogin.err2FAInvalid': 'Invalid 2FA code',
    'analytics.period_today': 'Today',
    'analytics.period_7d': '7 days',
    'analytics.period_30d': '30 days',
    'analytics.period_90d': '90 days',
    'analytics.period_365d': '1 year',
    'analytics.alert_suspicious_found': '{{count}} suspicious IP(s) detected!',
    'analytics.alert_no_suspicious': 'No suspicious IP detected.',
    'analytics.page_title': 'Analytics — Visits',
    'analytics.page_subtitle': 'Visit tracking across all your sites',
    'analytics.refresh': 'Refresh',
    'analytics.tab_dashboard': 'Dashboard',
    'analytics.tab_visits': 'Visits',
    'analytics.tab_blocked': 'Blocked IPs',
    'analytics.tab_alerts': 'IP Alerts',
    'analytics.all_sites': 'All sites',
    'analytics.kpi_total_visits': 'Total visits',
    'analytics.kpi_unique_visitors': 'Unique visitors',
    'analytics.kpi_active_sites': 'Active sites',
    'analytics.kpi_countries': 'Countries',
    'analytics.visits_per_day': 'Visits per day',
    'analytics.by_site': 'By site',
    'analytics.by_country': 'By country',
    'analytics.top_pages': 'Most visited pages',
    'analytics.visits_per_hour': 'Visits per hour',
    'analytics.empty_no_visits': 'No visits recorded for this period',
    'analytics.empty_install_script': 'The tracking script must be installed on your sites',
    'analytics.search_placeholder': 'Search by IP, page, country...',
    'analytics.col_date': 'Date',
    'analytics.col_site': 'Site',
    'analytics.col_page': 'Page',
    'analytics.col_country_city': 'Country / City',
    'analytics.col_screen': 'Screen',
    'analytics.col_action': 'Action',
    'analytics.no_visits': 'No visits',
    'analytics.blocked_inline': '(BLOCKED)',
    'analytics.unblock': 'Unblock',
    'analytics.block': 'Block',
    'analytics.visits_count': '{{count}} visits',
    'analytics.blocked_ips_title': 'Blocked IP addresses',
    'analytics.active_count': '{{count}} active',
    'analytics.col_status': 'Status',
    'analytics.col_reason': 'Reason',
    'analytics.col_blocked_by': 'Blocked by',
    'analytics.no_blocked_ips': 'No blocked IPs',
    'analytics.status_blocked': 'BLOCKED',
    'analytics.status_inactive': 'INACTIVE',
    'analytics.reblock': 'Re-block',
    'analytics.alert_config_title': 'Alert configuration',
    'analytics.checking': 'Checking...',
    'analytics.check_now': 'Check now',
    'analytics.saving': 'Saving...',
    'analytics.save': 'Save',
    'analytics.alerts_enabled': 'Alerts enabled',
    'analytics.alerts_enabled_desc': 'Monitors suspicious IPs every 15 min',
    'analytics.threshold_label': 'Threshold (visits/hour)',
    'analytics.alert_email_label': 'Alert email',
    'analytics.autoblock': 'Auto-block',
    'analytics.autoblock_desc': 'Automatically block IPs that exceed the threshold',
    'analytics.alert_history_title': 'Alert history',
    'analytics.alerts_count': '{{count}} alert(s)',
    'analytics.no_alerts': 'No alerts triggered',
    'analytics.col_visits_per_hour': 'Visits/h',
    'analytics.col_sites': 'Sites',
    'analytics.col_autoblocked': 'Auto-blocked',
    'analytics.col_email': 'Email',
    'analytics.yes': 'YES',
    'analytics.no': 'NO',
    'analytics.sent': 'SENT',
    'analytics.confirm_block_title': 'Block this IP?',
    'analytics.confirm_block_ip_prefix': 'IP ',
    'analytics.confirm_block_ip_suffix': ' will be blocked on all sites',
    'analytics.block_reason_placeholder': 'Reason for blocking (optional)...',
    'analytics.cancel': 'Cancel',
    'analytics.blocking': 'Blocking...',
    'analytics.confirm_block': 'Confirm block',
    'guyarepairLanding.navTarifs': 'Pricing',
    'guyarepairLanding.navAnnuaire': 'Directory',
    'guyarepairLanding.navMaReparation': 'My repair',
    'guyarepairLanding.navConnexion': 'Log in',
    'guyarepairLanding.navEssaiGratuit': 'Free trial',
    'guyarepairLanding.heroBadge': 'SaaS repair management platform',
    'guyarepairLanding.heroTitleLine1': 'Manage your repair',
    'guyarepairLanding.heroTitleLine2': 'workshop',
    'guyarepairLanding.heroTitleHighlight': 'simply',
    'guyarepairLanding.heroSubtitle': 'GUYAREPAIR is the all-in-one solution for repair workshops. POS, repair tracking, inventory management, invoicing and customer loyalty — all in a single platform.',
    'guyarepairLanding.heroCtaStart': 'Start for free',
    'guyarepairLanding.heroCtaPricing': 'See pricing',
    'guyarepairLanding.repairLookupTitle': 'Find my repair',
    'guyarepairLanding.repairLookupSubtitle': 'Enter your repair reference to track its progress',
    'guyarepairLanding.repairLookupPlaceholder': 'e.g. TFX0001, MBR0012...',
    'guyarepairLanding.rechercher': 'Search',
    'guyarepairLanding.repairErrorDefault': 'Error during the search',
    'guyarepairLanding.repairFoundAt': 'Repair found at',
    'guyarepairLanding.statutTermine': 'Completed',
    'guyarepairLanding.statutEnCours': 'In progress',
    'guyarepairLanding.statutEnAttente': 'Pending',
    'guyarepairLanding.labelReference': 'Reference',
    'guyarepairLanding.labelAppareil': 'Device',
    'guyarepairLanding.labelProbleme': 'Issue',
    'guyarepairLanding.voirPageDe': 'View {{nom}}\'s page',
    'guyarepairLanding.directoryTitle': 'Find your repairer',
    'guyarepairLanding.directorySubtitle': 'Search for a GUYAREPAIR partner repair shop',
    'guyarepairLanding.searchPlaceholder': 'Shop name, city...',
    'guyarepairLanding.resultats': '{{count}} result(s)',
    'guyarepairLanding.featuresTitle': 'Everything you need',
    'guyarepairLanding.featuresSubtitle': 'A complete suite of tools for your workshop',
    'guyarepairLanding.feature1Title': 'Repair management',
    'guyarepairLanding.feature1Desc': 'Full tracking of every repair, from diagnosis to delivery',
    'guyarepairLanding.feature2Title': 'Point of Sale (POS)',
    'guyarepairLanding.feature2Desc': 'Payments, price calculation, integrated cash management',
    'guyarepairLanding.feature3Title': 'Stock & Inventory',
    'guyarepairLanding.feature3Desc': 'Stock movements, alerts, suppliers and orders',
    'guyarepairLanding.feature4Title': 'Customers & Loyalty',
    'guyarepairLanding.feature4Desc': 'Customer database, loyalty program with rewards',
    'guyarepairLanding.feature5Title': 'Quotes & Invoices',
    'guyarepairLanding.feature5Desc': 'Quick quote creation, conversion to invoice, sending by email',
    'guyarepairLanding.feature6Title': 'Multi-store',
    'guyarepairLanding.feature6Desc': 'Manage multiple stores from a single dashboard',
    'guyarepairLanding.pricingTitle': 'Simple and transparent pricing',
    'guyarepairLanding.pricingSubtitle': 'Choose the plan that fits your business',
    'guyarepairLanding.popular': 'POPULAR',
    'guyarepairLanding.perMonth': 'EUR/month',
    'guyarepairLanding.commencer': 'Get started',
    'guyarepairLanding.copyright': '© {{year}} REMCOMPANY. All rights reserved.',
    'guyarepairLanding.trademarkNotice': 'GUYAREPAIR is the commercial brand of the service.',
    'guyarepairLanding.passwordTooShort': 'The password must be at least 6 characters',
    'guyarepairLanding.registerErrorDefault': 'Error during registration',
    'guyarepairLanding.registerSuccessTitle': 'Registration successful!',
    'guyarepairLanding.successAccountCreated': 'Your account has been created with a',
    'guyarepairLanding.successTrial': '5-day free trial',
    'guyarepairLanding.successLoginHint': 'Log in to set up your workspace. A welcome email has been sent.',
    'guyarepairLanding.seConnecter': 'Log in',
    'guyarepairLanding.createAccountTitle': 'Create your account',
    'guyarepairLanding.planLine': '{{nom}} plan — {{prix}} EUR/month',
    'guyarepairLanding.planLabel': 'Plan',
    'guyarepairLanding.companyNameLabel': 'Company name',
    'guyarepairLanding.contactNameLabel': 'Contact name',
    'guyarepairLanding.phoneLabel': 'Phone',
    'guyarepairLanding.emailLabel': 'Email',
    'guyarepairLanding.passwordLabel': 'Password',
    'guyarepairLanding.cityLabel': 'City',
    'guyarepairLanding.addressLabel': 'Address',
    'guyarepairLanding.directoryToggle': 'Appear in the public GUYAREPAIR directory',
    'guyarepairLanding.creating': 'Creating...',
    'guyarepairLanding.createMyAccount': 'Create my account',
    'guyarepairLanding.alreadyRegistered': 'Already registered?',
    'alertsConfig.saved': 'Alert settings saved',
    'alertsConfig.error': 'Error',
    'alertsConfig.title': 'Automatic alerts',
    'alertsConfig.subtitle': 'Set up automatic alerts for your business. You\'ll receive a daily email when conditions are met.',
    'alertsConfig.emailAlertsLabel': 'Email alerts',
    'alertsConfig.emailAlertsDesc': 'Enable automatic email alerts (pending repairs, out of stock)',
    'alertsConfig.repairAlertsTitle': 'Pending repair alerts',
    'alertsConfig.repairAlertsDesc': 'Get an email when a repair has been pending for more than X days.',
    'alertsConfig.delayLabel': 'Delay (days)',
    'alertsConfig.daysShort': '{{n}}d',
    'alertsConfig.stockAlertsTitle': 'Stock alerts',
    'alertsConfig.stockAlertsDesc': 'Get an email when items are out of stock or below a threshold.',
    'alertsConfig.lowStockThresholdLabel': 'Low stock threshold',
    'alertsConfig.clientNotifLabel': 'Client notifications',
    'alertsConfig.clientNotifDesc': 'Send an email to the client when their repair status changes (completed, in progress, etc.)',
    'alertsConfig.emailSenderInfo': 'The email will be sent from your configured address, or from GUYAREPAIR by default.',
    'alertsConfig.saving': 'Saving...',
    'alertsConfig.save': 'Save',
    'companyAnalytics.title': 'Analytics',
    'companyAnalytics.subtitle': 'Overview of your business performance',
    'companyAnalytics.loadError': 'Error loading data',
    'companyAnalytics.kpiRepairsToday': 'Repairs today',
    'companyAnalytics.kpiThisWeek': '{{count}} this week',
    'companyAnalytics.kpiRevenueToday': 'Revenue today',
    'companyAnalytics.kpiThisMonthAmount': '{{amount}} this month',
    'companyAnalytics.kpiClients': 'Clients',
    'companyAnalytics.kpiNewThisMonth': '{{count}} new this month',
    'companyAnalytics.kpiAvgTime': 'Average time',
    'companyAnalytics.daysShort': '{{count}}d',
    'companyAnalytics.kpiPerRepair': 'per repair',
    'companyAnalytics.statTotalRepairs': 'Total repairs',
    'companyAnalytics.statActive': 'Active',
    'companyAnalytics.statCompleted': 'Completed',
    'companyAnalytics.statStockItems': 'Stock items',
    'companyAnalytics.statOutOfStock': 'Out of stock',
    'companyAnalytics.repairsByStore': 'Repairs in progress by store',
    'companyAnalytics.repairsM1Explicit': '{{count}} explicit M1 repairs',
    'companyAnalytics.repairsLegacy': '{{count}} legacy repairs (pre-M2)',
    'companyAnalytics.totalShown': 'Total shown: {{count}}',
    'companyAnalytics.repairsM2': '{{count}} M2 repairs',
    'companyAnalytics.repairsTrend14Days': 'Repairs (last 14 days)',
    'companyAnalytics.statusDistribution': 'Status distribution',
    'companyAnalytics.noRepairs': 'No repairs',
    'companyAnalytics.revenue': 'Revenue',
    'companyAnalytics.revToday': 'Today',
    'companyAnalytics.revThisWeek': 'This week',
    'companyAnalytics.revThisMonth': 'This month',
    'companyAnalytics.revTotal': 'Total',
    'companyAnalytics.statusPending': 'Pending',
    'companyAnalytics.statusInProgress': 'In progress',
    'companyAnalytics.statusCompleted': 'Completed',
    'companyAnalytics.statusDelivered': 'Delivered',
    'companyAnalytics.statusCancelled': 'Cancelled',
    'staffCommissions.title': 'My commissions',
    'staffCommissions.pdfDownloadError': 'Error downloading the PDF',
    'staffCommissions.downloadMonthSheet': 'Download my monthly statement:',
    'staffCommissions.generating': 'Generating…',
    'staffCommissions.downloadPdf': 'Download PDF',
    'staffCommissions.toReceive': 'To receive',
    'staffCommissions.alreadyReceived': 'Already received',
    'staffCommissions.totalCumulative': 'Cumulative total',
    'staffCommissions.detailByType': 'Breakdown by type',
    'staffCommissions.toPay': 'To pay: {{amount}}',
    'staffCommissions.paidDetail': 'Paid: {{amount}}',
    'staffCommissions.noCommissionYet': 'No commissions yet',
    'staffCommissions.filterAll': 'All',
    'staffCommissions.filterPending': 'To pay',
    'staffCommissions.filterPaid': 'Paid',
    'staffCommissions.filterCancelled': 'Cancelled',
    'staffCommissions.colDate': 'Date',
    'staffCommissions.colType': 'Type',
    'staffCommissions.colTransaction': 'Transaction',
    'staffCommissions.colAmountTtc': 'Amount incl. tax',
    'staffCommissions.colCommission': 'Commission',
    'staffCommissions.colStatus': 'Status',
    'staffCommissions.noCommission': 'No commissions',
    'staffCommissions.month1': 'January',
    'staffCommissions.month2': 'February',
    'staffCommissions.month3': 'March',
    'staffCommissions.month4': 'April',
    'staffCommissions.month5': 'May',
    'staffCommissions.month6': 'June',
    'staffCommissions.month7': 'July',
    'staffCommissions.month8': 'August',
    'staffCommissions.month9': 'September',
    'staffCommissions.month10': 'October',
    'staffCommissions.month11': 'November',
    'staffCommissions.month12': 'December',
    'staffCommissions.typeVentes': 'POS sale',
    'staffCommissions.typeCommandes': 'Order',
    'staffCommissions.typeAcomptes': 'Down payment',
    'staffCommissions.typeReparations': 'Repair',
    'staffCommissions.typeFactures': 'Invoice',
    'staffCommissions.typeDevis': 'Quote',
    'staffCommissions.typeB2b': 'B2B',
    'staffCommissions.typeDeplacement': 'Call-out',
    'labelConfig.title': 'Label Configuration',
    'labelConfig.subtitle': 'Adjust the margins and dimensions for your printer',
    'labelConfig.reset': 'Default values',
    'labelConfig.save': 'Save',
    'labelConfig.saving': 'Saving...',
    'labelConfig.saved': 'Saved',
    'labelConfig.save_error': 'Save error: {{error}}',
    'labelConfig.global_dimensions': 'General dimensions',
    'labelConfig.label_width': 'Label width',
    'labelConfig.label_height': 'Label height',
    'labelConfig.cols': 'Columns',
    'labelConfig.rows': 'Rows',
    'labelConfig.margins_spacing': 'Margins and spacing',
    'labelConfig.left_margin': 'Left margin',
    'labelConfig.top_margin': 'Top margin',
    'labelConfig.h_spacing': 'H spacing',
    'labelConfig.v_spacing': 'V spacing',
    'labelConfig.col_offset_title': 'Offset per column',
    'labelConfig.cols_count': '({{count}} columns)',
    'labelConfig.col_n': 'Col {{n}}',
    'labelConfig.col_offset_hint': 'Positive values = shift to the right. Negative = to the left.',
    'labelConfig.row_offset_title': 'Offset per row',
    'labelConfig.rows_count': '({{count}} rows)',
    'labelConfig.row_n': 'Row {{n}}',
    'labelConfig.row_offset_hint': 'Positive values = shift upward. Negative = downward.',
    'labelConfig.preview_title': 'A4 sheet preview',
    'labelConfig.preview_count': '{{cols}} x {{rows}} = {{total}} labels/sheet',
    'labelConfig.preview_dims': '{{width}} x {{height}} mm',
    'paymentConfig.title': 'Payment configuration',
    'paymentConfig.statusActiveTitle': 'Online payments active',
    'paymentConfig.providerLabel': 'Provider: {{name}}',
    'paymentConfig.statusInactiveTitle': 'Online payments disabled',
    'paymentConfig.statusInactiveDesc': 'Set up a provider to accept online payments. Only offline payments (cash, in-store card) are available.',
    'paymentConfig.chooseProvider': 'Choose your payment provider:',
    'paymentConfig.apiKeysTitle': '{{name}} API keys',
    'paymentConfig.savedPlaceholder': 'Saved: {{value}}',
    'paymentConfig.save': 'Save',
    'paymentConfig.testConnection': 'Test connection',
    'paymentConfig.infoTitle': 'Important information',
    'paymentConfig.info1': 'Online payments are paid directly into your merchant account.',
    'paymentConfig.info2': 'Your API keys are encrypted and stored securely.',
    'paymentConfig.info3': 'Without a valid configuration, only offline payments are available.',
    'paymentConfig.info4': 'Each business manages its own keys independently.',
    'paymentConfig.saveError': 'Save error',
    'paymentConfig.testError': 'Test error',
    'paymentConfig.disableConfirm': 'Disable online payments?',
    'paymentConfig.stripeDesc': 'Card payments, Apple Pay, Google Pay',
    'paymentConfig.sumupDesc': 'Card terminal POS V2 + online payments (merchant_code, client_id/secret)',
    'paymentConfig.fieldPublicKey': 'Public key (pk_...)',
    'paymentConfig.fieldSecretKey': 'Secret key (sk_...)',
    'paymentConfig.fieldWebhookSecret': 'Webhook secret (whsec_...)',
    'paymentConfig.fieldApiKey': 'API key',
    'paymentConfig.fieldMerchantCode': 'Merchant code',
    'paymentConfig.fieldClientId': 'Client ID',
    'paymentConfig.fieldClientSecret': 'Client Secret',
    'loyaltyAdmin.title': 'Loyalty Program',
    'loyaltyAdmin.subtitle': 'Track customer points and rewards',
    'loyaltyAdmin.refresh': 'Refresh',
    'loyaltyAdmin.kpiMembers': 'Members',
    'loyaltyAdmin.kpiPendingRewards': 'Pending rewards',
    'loyaltyAdmin.kpiRedeemed': 'Rewards redeemed',
    'loyaltyAdmin.kpiThreshold': 'Reward threshold',
    'loyaltyAdmin.purchasesSuffix': 'purchases',
    'loyaltyAdmin.rewardRule': '-{{pos}}% POS / -{{repair}}% repair',
    'loyaltyAdmin.topClients': 'Top Loyal Customers',
    'loyaltyAdmin.clientFallback': 'Customer',
    'loyaltyAdmin.flashOffers': 'Flash Offers',
    'loyaltyAdmin.newOffer': 'New offer',
    'loyaltyAdmin.createFlashOffer': 'Create a flash offer',
    'loyaltyAdmin.offerTitlePlaceholder': 'Offer title (e.g. Weekend Special)',
    'loyaltyAdmin.offerDescPlaceholder': 'Description (e.g. Discounted screen repair)',
    'loyaltyAdmin.discountLabel': 'Discount (%)',
    'loyaltyAdmin.endDateLabel': 'End date',
    'loyaltyAdmin.targetLevelsLabel': 'Target levels',
    'loyaltyAdmin.creating': 'Creating...',
    'loyaltyAdmin.createOffer': 'Create offer',
    'loyaltyAdmin.noOffers': 'No flash offers created',
    'loyaltyAdmin.offerMeta': 'Targets: {{levels}} | Emails: {{emails}}',
    'loyaltyAdmin.offerEnd': ' | End: {{date}}',
    'loyaltyAdmin.deactivate': 'Deactivate',
    'loyaltyAdmin.activate': 'Activate',
    'loyaltyAdmin.sendByEmail': 'Send by email',
    'loyaltyAdmin.delete': 'Delete',
    'loyaltyAdmin.allMembers': 'All members ({{count}})',
    'loyaltyAdmin.searchPlaceholder': 'Search...',
    'loyaltyAdmin.colClient': 'Customer',
    'loyaltyAdmin.colPhone': 'Phone',
    'loyaltyAdmin.colPurchases': 'Purchases',
    'loyaltyAdmin.colPoints': 'Points',
    'loyaltyAdmin.colTotalSpent': 'Total spent',
    'loyaltyAdmin.colStatus': 'Status',
    'loyaltyAdmin.colRewards': 'Rewards',
    'loyaltyAdmin.noMembers': 'No members',
    'loyaltyAdmin.rewardAvailable': 'Reward available',
    'loyaltyAdmin.purchasesRemaining': '{{count}} purchases remaining',
    'loyaltyAdmin.pageOf': 'Page {{page}} / {{total}}',
    'loyaltyAdmin.confirmDeleteOffer': 'Delete this offer?',
    'loyaltyAdmin.emailsSent': 'Emails sent',
    'loyaltyAdmin.levelBronze': 'Bronze',
    'loyaltyAdmin.levelArgent': 'Silver',
    'loyaltyAdmin.levelOr': 'Gold',
    'emailConfig.pageTitle': 'Email Configuration',
    'emailConfig.pageSubtitle': 'Configure the SMTP server for sending invoices, quotes and notifications by email.',
    'emailConfig.smtpSection': 'SMTP Server',
    'emailConfig.fieldHost': 'SMTP Host',
    'emailConfig.fieldPort': 'Port',
    'emailConfig.fieldUser': 'SMTP User (email)',
    'emailConfig.fieldPassword': 'Email password',
    'emailConfig.passwordPlaceholderExisting': '•••••••• (leave empty to keep)',
    'emailConfig.passwordPlaceholderNew': 'Hostinger email password',
    'emailConfig.useSsl': 'Use SSL/TLS (recommended for port 465)',
    'emailConfig.enableEmails': 'Enable email sending',
    'emailConfig.tipTitle': 'Hostinger tip:',
    'emailConfig.tipBody': 'the email password is different from the hPanel password. You can check or reset it in hPanel → Emails → Email Accounts → Manage.',
    'emailConfig.senderSection': 'Sender',
    'emailConfig.fieldSenderName': 'Sender name',
    'emailConfig.fieldSenderEmail': 'Sender email',
    'emailConfig.saving': 'Saving…',
    'emailConfig.save': 'Save',
    'emailConfig.testing': 'Sending…',
    'emailConfig.testConnection': 'Test connection',
    'emailConfig.disable': 'Disable',
    'emailConfig.loadError': 'Loading error (HTTP {{status}})',
    'emailConfig.saveSuccess': 'Configuration saved. You can now click "Test connection".',
    'emailConfig.saveErrorFallback': 'Save error',
    'emailConfig.testSuccess': 'Test email sent. Check your inbox.',
    'emailConfig.testErrorFallback': 'SMTP test failed. Check the Hostinger email password (different from the hPanel password).',
    'emailConfig.disableConfirm': 'Disable the custom configuration? The server will revert to the default .env configuration.',
    'emailConfig.disableSuccess': 'Custom configuration disabled.',
    'emailConfig.disableErrorFallback': 'Error while disabling',
    'promosCalendar.title': 'Promotions calendar',
    'promosCalendar.subtitle': 'Promotions scheduled by day',
    'promosCalendar.empty': 'No promotions scheduled for this month.',
    'adminIntegrations.supplierCredentials': 'Supplier credentials (Mobilax · Jens · LCD-Phone)',
    'adminIntegrations.generateStockPhotos': 'Generate stock photos (AI) — M1 / M2',
    'adminIntegrations.stockCategoryAudit': 'Stock category audit — phone / IMEI / accessories',
    'printerTokens.title': 'Printer agent tokens',
    'printerTokens.desc': 'Management of the tokens used by the Windows agent to authenticate with the backend. One token per machine (recommended) or a shared token for small setups.',
    'printerTokens.newBtn': 'New token',
    'printerTokens.includeRevoked': 'Include revoked tokens',
    'printerTokens.refresh': 'Refresh',
    'printerTokens.loading': 'Loading…',
    'printerTokens.emptyPre': 'No tokens. Click',
    'printerTokens.emptyPost': 'to create one.',
    'printerTokens.colLabel': 'Label',
    'printerTokens.colType': 'Type',
    'printerTokens.colPreview': 'Preview',
    'printerTokens.colCreated': 'Created',
    'printerTokens.colLastUsed': 'Last used',
    'printerTokens.colStatus': 'Status',
    'printerTokens.colActions': 'Actions',
    'printerTokens.typeShared': 'Shared',
    'printerTokens.typePersonal': 'Personal',
    'printerTokens.createdBy': 'by {{user}}',
    'printerTokens.statusRevoked': 'Revoked',
    'printerTokens.statusActive': 'Active',
    'printerTokens.revoke': 'Revoke',
    'printerTokens.securityTitle': 'Security',
    'printerTokens.securityHashPre': 'Tokens are stored as a hash (SHA-256). The full token is',
    'printerTokens.securityHashEmph': 'never shown again',
    'printerTokens.securityHashPost': 'after it is created. If you lose it, revoke it and create a new one.',
    'printerTokens.securityAudit': 'Every creation and revocation is logged in the administrator audit trail.',
    'printerTokens.createTitle': 'New agent token',
    'printerTokens.createLabelField': 'Label (e.g. Checkout PC, Carlos\'s laptop)',
    'printerTokens.createLabelPlaceholder': 'Checkout PC',
    'printerTokens.createSharedLabel': 'Shared token (usable by multiple machines)',
    'printerTokens.createSharedHint': 'Only one shared token active at a time. For security, prefer one token per machine.',
    'printerTokens.cancel': 'Cancel',
    'printerTokens.create': 'Create',
    'printerTokens.revealTitle': 'Token created — copy it now',
    'printerTokens.revealLabelPrefix': 'Label:',
    'printerTokens.revealConfigPre': 'Configure your Windows agent with this token in the header',
    'printerTokens.revealConfigPost': '.',
    'printerTokens.copied': 'Copied',
    'printerTokens.copy': 'Copy',
    'printerTokens.revealClose': 'I\'ve saved the token',
    'printerTokens.revokeTitle': 'Revoke this token?',
    'printerTokens.revokeMsgPre': 'The token',
    'printerTokens.revokeMsgPost': 'will no longer be able to authenticate any agent. This operation is kept in the log and does not delete the token (you can display it by checking “Include revoked tokens”).',
    'printerTokens.actionError': 'Error: {{detail}}',
    'servicePrices.pageTitle': 'Repair prices',
    'servicePrices.pageSubtitle': 'Manage prices and the public page content',
    'servicePrices.viewPublicPage': 'View public page',
    'servicePrices.add': 'Add',
    'servicePrices.tabPrices': 'Prices',
    'servicePrices.tabContent': 'Page content',
    'servicePrices.editPriceTitle': 'Edit price',
    'servicePrices.newPriceTitle': 'New price',
    'servicePrices.brand': 'Brand *',
    'servicePrices.choose': 'Choose...',
    'servicePrices.model': 'Model',
    'servicePrices.modelPlaceholder': 'e.g. iPhone 14 Pro',
    'servicePrices.repairType': 'Repair type *',
    'servicePrices.delay': 'Lead time',
    'servicePrices.delayPlaceholder': 'e.g. 30 min',
    'servicePrices.priceMin': 'Min price (EUR)',
    'servicePrices.priceMax': 'Max price (EUR)',
    'servicePrices.order': 'Order',
    'servicePrices.visiblePublic': 'Publicly visible',
    'servicePrices.btnUpdate': 'Update',
    'servicePrices.btnSave': 'Save',
    'servicePrices.loading': 'Loading...',
    'servicePrices.noPrices': 'No price recorded',
    'servicePrices.noPricesHint': 'Add your first prices to display them on the public page',
    'servicePrices.colRepair': 'Repair',
    'servicePrices.colPrice': 'Price',
    'servicePrices.colVisible': 'Visible',
    'servicePrices.colActions': 'Actions',
    'servicePrices.allModels': 'All models',
    'servicePrices.contentLoading': 'Loading content...',
    'servicePrices.contentBannerPre': 'Edit here the content shown on the public page',
    'servicePrices.contentBannerPost': '. Changes appear immediately after saving.',
    'servicePrices.headerSection': 'Page header',
    'servicePrices.mainTitle': 'Main title',
    'servicePrices.accentWord': 'Colored word (accent)',
    'servicePrices.seoDescription': 'SEO description',
    'servicePrices.contactInfo': 'Contact information',
    'servicePrices.phone': 'Phone',
    'servicePrices.phoneDisplay': 'Displayed phone',
    'servicePrices.whatsappLabel': 'WhatsApp (with country code)',
    'servicePrices.address': 'Address',
    'servicePrices.hours': 'Opening hours',
    'servicePrices.trustBadges': 'Trust badges',
    'servicePrices.addShort': '+ Add',
    'servicePrices.titleField': 'Title',
    'servicePrices.description': 'Description',
    'servicePrices.faqTitle': 'Frequently asked questions (FAQ)',
    'servicePrices.question': 'Question',
    'servicePrices.answer': 'Answer',
    'servicePrices.ctaSection': 'Call to action section (CTA)',
    'servicePrices.ctaTitle': 'CTA title',
    'servicePrices.ctaDescription': 'CTA description',
    'servicePrices.footer': 'Footer',
    'servicePrices.line1': 'Line 1',
    'servicePrices.line2': 'Line 2',
    'servicePrices.hidePreview': 'Hide preview',
    'servicePrices.livePreview': 'Live preview',
    'servicePrices.savedSuccess': 'Saved successfully!',
    'servicePrices.saving': 'Saving...',
    'servicePrices.saveContent': 'Save content',
    'servicePrices.previewLabel': 'Public page preview',
    'servicePrices.faqShort': 'FAQ',
    'servicePrices.confirmDelete': 'Delete this price?',
    'servicePrices.repairTypes.ecran': 'Screen',
    'servicePrices.repairTypes.batterie': 'Battery',
    'servicePrices.repairTypes.connecteurCharge': 'Charging port',
    'servicePrices.repairTypes.cameraArriere': 'Rear camera',
    'servicePrices.repairTypes.cameraAvant': 'Front camera',
    'servicePrices.repairTypes.hautParleur': 'Speaker',
    'servicePrices.repairTypes.micro': 'Microphone',
    'servicePrices.repairTypes.boutonPower': 'Power button',
    'servicePrices.repairTypes.boutonVolume': 'Volume button',
    'servicePrices.repairTypes.vitreArriere': 'Back glass',
    'servicePrices.repairTypes.nappeFaceId': 'Face ID flex cable',
    'servicePrices.repairTypes.carteMere': 'Motherboard',
    'servicePrices.repairTypes.diagnostique': 'Diagnostics',
    'servicePrices.repairTypes.desoxydation': 'Deoxidation',
    'servicePrices.repairTypes.autre': 'Other',
    'companySettings.toast.loadError': 'Error loading settings',
    'companySettings.toast.saveSuccess': 'Settings saved successfully',
    'companySettings.toast.saveError': 'Error while saving',
    'companySettings.toast.notImage': 'The file must be an image',
    'companySettings.toast.tooLarge': 'The file must not exceed 5 MB',
    'companySettings.toast.logoSuccess': 'Logo updated successfully',
    'companySettings.toast.logoError': 'Error uploading the logo',
    'companySettings.toast.previewError': 'Error generating the preview',
    'companySettings.tabs.info': 'Information',
    'companySettings.tabs.documents': 'Documents (Invoices, Quotes, POs)',
    'companySettings.tabs.payment': 'Payment',
    'companySettings.tabs.logo': 'Logo',
    'companySettings.tabs.preview': 'PDF preview',
    'companySettings.tabs.security': 'Security',
    'companySettings.title': 'Company settings',
    'companySettings.subtitle': 'Configure your company information and your documents',
    'companySettings.save': 'Save',
    'companySettings.info.sectionTitle': 'Company information',
    'companySettings.info.companyNameLabel': 'Company name',
    'companySettings.info.companyNamePlaceholder': 'e.g. My Company Ltd',
    'companySettings.info.legalFormLabel': 'Legal form',
    'companySettings.info.legalFormPlaceholder': 'e.g. LLC, Ltd, Sole trader...',
    'companySettings.info.capitalLabel': 'Share capital',
    'companySettings.info.capitalPlaceholder': 'e.g. 1,000 EUR',
    'companySettings.info.siretLabel': 'SIRET',
    'companySettings.info.siretPlaceholder': 'e.g. 123 456 789 00014',
    'companySettings.info.rcsLabel': 'RCS',
    'companySettings.info.rcsPlaceholder': 'e.g. Paris B 123 456 789',
    'companySettings.info.phoneLabel': 'Phone',
    'companySettings.info.phonePlaceholder': 'e.g. +594 694 XX XX XX',
    'companySettings.info.emailLabel': 'Email',
    'companySettings.info.emailPlaceholder': 'e.g. contact@mycompany.com',
    'companySettings.info.postalLabel': 'Postal code',
    'companySettings.info.postalPlaceholder': 'e.g. 97300',
    'companySettings.info.addressLabel': 'Address',
    'companySettings.info.addressPlaceholder': 'e.g. 10 Main Street',
    'companySettings.info.cityLabel': 'City',
    'companySettings.info.cityPlaceholder': 'e.g. Cayenne',
    'companySettings.info.tvaLabel': 'VAT notice',
    'companySettings.info.tvaPlaceholder': 'Tax notice shown on documents',
    'companySettings.documents.devisSectionTitle': 'Quote settings',
    'companySettings.documents.devisValidityLabel': 'Quote validity',
    'companySettings.documents.devisValidityPlaceholder': 'Validity period of the quote',
    'companySettings.documents.devisConditionsLabel': 'General terms (quote)',
    'companySettings.documents.devisConditionsPlaceholder': 'General terms shown on quotes',
    'companySettings.documents.bcSectionTitle': 'Purchase order settings',
    'companySettings.documents.bcConditionsLabel': 'Purchase order terms',
    'companySettings.documents.bcConditionsPlaceholder': 'Terms for carrying out the services',
    'companySettings.documents.factureSectionTitle': 'Invoice settings',
    'companySettings.documents.facturePaymentLabel': 'Payment terms',
    'companySettings.documents.facturePaymentPlaceholder': 'e.g. Payment on receipt...',
    'companySettings.documents.facturePenaltiesLabel': 'Late payment penalties',
    'companySettings.documents.facturePenaltiesPlaceholder': 'Late payment penalty clause',
    'companySettings.documents.factureRecoveryLabel': 'Recovery fee',
    'companySettings.documents.factureRecoveryPlaceholder': 'Fixed recovery fee clause',
    'companySettings.documents.factureReserveLabel': 'Retention of title',
    'companySettings.documents.factureReservePlaceholder': 'Retention of title clause',
    'companySettings.documents.warrantySectionTitle': 'Warranty',
    'companySettings.documents.warrantyLabel': 'Warranty notice',
    'companySettings.documents.warrantyPlaceholder': 'e.g. 6-month warranty on parts and labor from the repair date.',
    'companySettings.documents.warrantyHint': 'This notice will be shown at the bottom of invoices if filled in.',
    'companySettings.payment.sectionTitle': 'Online payment',
    'companySettings.payment.disableTitle': 'Disable online payment',
    'companySettings.payment.disableDesc': 'When enabled, online payment options (Stripe) are hidden on all quotes. Customers can only request a SumUp payment link.',
    'companySettings.payment.statusDisabled': 'Online payment DISABLED - Customers will only see the SumUp request form',
    'companySettings.payment.statusEnabled': 'Online payment ENABLED - Customers can pay directly online',
    'companySettings.payment.howTitle': 'How does it work?',
    'companySettings.payment.step1': '1. The customer receives the quote by email and accepts it',
    'companySettings.payment.step2': '2. Instead of paying online, they fill in a form with their email/phone',
    'companySettings.payment.step3': '3. You receive a notification with the payment request',
    'companySettings.payment.step4': '4. You manually send the SumUp payment link to the customer',
    'companySettings.logo.sectionTitle': 'Company logo',
    'companySettings.logo.description': 'This logo will be shown on your invoices, quotes and purchase orders (PNG, JPG formats, max 5 MB).',
    'companySettings.logo.alt': 'Logo',
    'companySettings.logo.none': 'No logo',
    'companySettings.logo.uploading': 'Uploading...',
    'companySettings.logo.choose': 'Choose a logo',
    'companySettings.logo.hint': 'The logo will be automatically resized on PDF documents.',
    'companySettings.preview.sectionTitle': 'Preview of your documents',
    'companySettings.preview.description': 'View a sample invoice or quote with your current settings (logo, information, legal notices).',
    'companySettings.preview.saveReminder': 'Remember to save your changes before generating the preview.',
    'companySettings.preview.facture': 'Invoice',
    'companySettings.preview.devis': 'Quote',
    'companySettings.preview.generating': 'Generating...',
    'companySettings.preview.generate': 'Generate preview',
    'companySettings.preview.iframeTitle': 'PDF preview',
    'companySettings.security.genericError': 'Error',
    'companySettings.security.invalidCode': 'Invalid code',
    'companySettings.security.enabledToast': '2FA enabled successfully!',
    'companySettings.security.disabledToast': '2FA disabled',
    'companySettings.security.sectionTitle': 'Account security',
    'companySettings.security.twoFaTitle': 'Two-factor authentication (2FA)',
    'companySettings.security.statusActive': 'Enabled',
    'companySettings.security.statusInactive': 'Disabled',
    'companySettings.security.intro': 'Protect your account with two-step verification. At each login, a 6-digit code will be required in addition to your password.',
    'companySettings.security.configureBtn': 'Set up 2FA',
    'companySettings.security.step1ScanPrefix': '1. Scan this QR code with',
    'companySettings.security.step1ScanSuffix': ':',
    'companySettings.security.qrAlt': '2FA QR Code',
    'companySettings.security.manualKeyLabel': 'Or enter this key manually:',
    'companySettings.security.step2Enter': '2. Enter the code shown in the app:',
    'companySettings.security.activate': 'Enable',
    'companySettings.security.protectedMsg': 'Your account is protected by 2FA',
    'companySettings.security.disablePrompt': 'To disable, enter your current code:',
    'companySettings.security.disable': 'Disable',
    'docTimezone.title': 'Document Times',
    'docTimezone.intro': 'Configure the time zone used for dates and times on your documents (tickets, invoices, quotes, purchase orders).',
    'docTimezone.sectionTimezone': 'Time Zone',
    'docTimezone.selectLabel': 'Select your time zone',
    'docTimezone.currentLabel': 'Current zone:',
    'docTimezone.selectHint': 'This time zone will be applied to all dates shown on your documents. The recording time of tickets will never change once saved.',
    'docTimezone.save': 'Save',
    'docTimezone.importantTitle': 'Important',
    'docTimezone.importantBody': 'By default, all documents use the French Guiana time zone (Cayenne, UTC-3). If you change this setting, future documents will use the new time zone. Documents already created will keep their original recording time.',
    'docTimezone.toastUpdated': 'Time zone updated',
    'docTimezone.errUpdate': 'Error during update',
    'docTimezone.errNetwork': 'Network error',
    'docTimezone.tzCayenne': 'French Guiana (Cayenne)',
    'docTimezone.tzMartinique': 'Martinique / Guadeloupe',
    'docTimezone.tzGuadeloupe': 'Guadeloupe',
    'docTimezone.tzParis': 'Metropolitan France (Paris)',
    'docTimezone.tzReunion': 'Réunion',
    'docTimezone.tzNoumea': 'New Caledonia',
    'docTimezone.tzTahiti': 'French Polynesia (Tahiti)',
    'flashOffers.confirmDelete': 'Delete this offer?',
    'flashOffers.emailsSentFallback': 'Emails sent',
    'flashOffers.pageTitle': 'Flash Offers & Promos',
    'flashOffers.pageSubtitle': 'Manage your temporary promotions and send them to loyal customers',
    'flashOffers.newOffer': 'New offer',
    'flashOffers.createTitle': 'Create a flash offer',
    'flashOffers.labelTitle': 'Title *',
    'flashOffers.placeholderTitle': 'E.g. Weekend Special',
    'flashOffers.labelDiscount': 'Discount (%)',
    'flashOffers.labelDescription': 'Description',
    'flashOffers.placeholderDescription': 'E.g. Screen repair at a reduced price',
    'flashOffers.labelEndDate': 'End date',
    'flashOffers.labelTargetLevels': 'Target levels',
    'flashOffers.levelBronze': 'Bronze',
    'flashOffers.levelSilver': 'Silver',
    'flashOffers.levelGold': 'Gold',
    'flashOffers.creating': 'Creating...',
    'flashOffers.createOffer': 'Create offer',
    'flashOffers.emptyTitle': 'No flash offer created',
    'flashOffers.emptyHint': 'Click "{{btn}}" to get started',
    'flashOffers.badgeExpired': 'Expired',
    'flashOffers.badgeDisabled': 'Disabled',
    'flashOffers.endLabel': 'Ends: {{date}}',
    'flashOffers.emailsCount': 'Emails: {{count}}',
    'flashOffers.lastSent': 'Last sent: {{date}}',
    'flashOffers.deactivate': 'Deactivate',
    'flashOffers.activate': 'Activate',
    'flashOffers.sendByEmail': 'Send by email',
    'flashOffers.delete': 'Delete',
    'mailsAi.oauthDenied': 'Google authorization denied.',
    'mailsAi.sessionExpired': 'Session expired, please try again.',
    'mailsAi.tokenExchangeFailed': 'Google connection error, please try again.',
    'mailsAi.missingParams': 'Missing parameters.',
    'mailsAi.googleConnectError': 'Google connection error.',
    'mailsAi.errorWith': 'Error: {{msg}}',
    'mailsAi.aiAnalysisError': 'AI analysis error: {{msg}}',
    'mailsAi.confirmDeleteAccount': 'Delete this email account and all its stored messages?',
    'mailsAi.confirmRefetch': 'This will delete all cached emails and re-download them with full HTML rendering. Continue?',
    'mailsAi.confirmBulkAnalyze': 'Analyze {{count}} unanalyzed emails? (Uses AI credits)',
    'mailsAi.fetchAnalyzedHeader': '{{count}} new emails retrieved and analyzed.',
    'mailsAi.alertsDetected': '{{count}} alert(s) detected:',
    'mailsAi.fetchAnalyzedNoThreat': '{{count}} new emails retrieved and analyzed automatically. No threats detected.',
    'mailsAi.fetchRetrieved': '{{count}} new emails retrieved.',
    'mailsAi.noNewEmail': 'No new emails.',
    'mailsAi.refetchDone': 'Re-synchronization complete! {{count}} emails retrieved with HTML rendering.',
    'mailsAi.allVisibleAnalyzed': 'All visible emails are already analyzed!',
    'mailsAi.bulkAnalyzeDone': 'Analysis complete! {{done}}/{{total}} emails analyzed.',
    'mailsAi.emailSent': 'Email sent successfully!',
    'mailsAi.subtitle': 'Smart management of your professional emails',
    'mailsAi.autoRefresh': 'Auto-refresh',
    'mailsAi.refresh': 'Refresh',
    'mailsAi.analyzeAll': 'Analyze all',
    'mailsAi.compose': 'New email',
    'mailsAi.addAccount': 'Add an account',
    'mailsAi.loadingAccounts': 'Loading accounts...',
    'mailsAi.noAccountTitle': 'No email account connected',
    'mailsAi.noAccountDesc': 'Connect your first email account to get started.',
    'mailsAi.fetchingAll': 'Retrieving all emails...',
    'mailsAi.fetchingAllHint': 'This may take a few minutes',
    'mailsAi.noEmail': 'No emails.',
    'mailsAi.noSubject': '(no subject)',
    'mailsAi.prev': 'Prev.',
    'mailsAi.next': 'Next',
    'mailsAi.pageOf': '{{page}} / {{total}}',
    'sumupTerminal.title': 'SumUp terminal (card reader)',
    'sumupTerminal.subtitle': 'One card reader per store — M1 and M2 are independent. POS V2 uses the card reader of the selected store.',
    'sumupTerminal.hintM1': 'Resurrection Mobile card reader (SOLO)',
    'sumupTerminal.hintM2': 'To configure once the 2nd card reader is paired with SumUp',
    'sumupTerminal.m2NotConfigured': 'M2 is not configured yet — normal if the 2nd card reader isn\'t paired yet. Once it is, fill in the fields below (separate SumUp M2 account).',
    'sumupTerminal.step1Lead': 'In SumUp Cloud → Terminals → copy the',
    'sumupTerminal.step1Merchant': 'merchant code',
    'sumupTerminal.step1And': ' and the ',
    'sumupTerminal.step1Reader': 'reader ID',
    'sumupTerminal.step2Lead': 'Paste the',
    'sumupTerminal.step2Secret': 'SECRET key',
    'sumupTerminal.step2Mid': '(sup_sk_…) —',
    'sumupTerminal.step2Public': 'not the public key sup_pk_',
    'sumupTerminal.step3Lead': 'Click',
    'sumupTerminal.step3Verify': 'Verify API key',
    'sumupTerminal.step3Rest': '→ the merchant code fills in automatically',
    'sumupTerminal.step4Lead': 'Select the card reader from the list, then',
    'sumupTerminal.step4Save': 'Save',
    'sumupTerminal.labelName': 'Card reader name (optional)',
    'sumupTerminal.namePlaceholder': 'E.g.: MY READER M1',
    'sumupTerminal.labelApiKey': 'SumUp secret API key (sup_sk_…) *',
    'sumupTerminal.savedKeyPlaceholder': 'Saved: {{masked}}',
    'sumupTerminal.apiKeyHint': 'sup_sk_ secret key only. SumUp shows it only once, at creation.',
    'sumupTerminal.verifyKeyBtn': '1. Verify API key',
    'sumupTerminal.keyConfirmed': '✓ Key confirmed by SumUp',
    'sumupTerminal.labelMerchantCode': 'Merchant code *',
    'sumupTerminal.labelReaderId': 'Reader ID (reader) *',
    'sumupTerminal.discoverBtn': 'Find my card readers',
    'sumupTerminal.readerFallback': 'SumUp card reader',
    'sumupTerminal.labelDeviceId': 'Device ID (optional)',
    'sumupTerminal.saveBtn': 'Save {{mag}}',
    'sumupTerminal.testBtn': 'Test {{amount}} on card reader',
    'sumupTerminal.checklistTitle': 'Card reader checklist',
    'sumupTerminal.checklistWifi': 'Terminal powered on and connected to Wi‑Fi',
    'sumupTerminal.checklistPaired': '"Paired" status in SumUp Cloud',
    'sumupTerminal.checklistSolo': 'Solo software ≥ 3.3.24',
    'sumupTerminal.checklistBluetooth': 'Bluetooth and API don\'t work together — turn off Bluetooth on the SOLO if you use the POS',
    'sumupTerminal.checklistCancel': 'If the amount appears then cancels on its own: reconnect API on the card reader (not a POS bug)',
    'sumupTerminal.openCloud': 'Open SumUp Cloud',
    'sumupTerminal.errLoad': 'Unable to load the configuration',
    'sumupTerminal.msgMerchantChanged': 'Merchant account changed — verify the API key, then select the card reader.',
    'sumupTerminal.errPasteSecret': 'First paste the SumUp secret key (sup_sk_…), not the public key sup_pk_.',
    'sumupTerminal.keyOkReaders': 'Key OK — account {{mc}} · {{count}} card reader(s) found.',
    'sumupTerminal.keyOkNone': 'Key OK — account {{mc}} · no card reader paired in SumUp Cloud.',
    'sumupTerminal.errKeyRejected': 'API key rejected by SumUp',
    'sumupTerminal.msgNoReaders': 'No card reader found — check that the terminal is paired in SumUp Cloud.',
    'sumupTerminal.errDiscover': 'Card reader search error',
    'sumupTerminal.readerSelected': 'Card reader selected: {{name}}',
    'sumupTerminal.errMerchantChangeKey': 'SumUp account change: enter the new API key (sup_sk_…) before saving.',
    'sumupTerminal.errVerifyFirst': 'First click "Verify API key" — SumUp must confirm the key before saving.',
    'sumupTerminal.errReaderRequired': 'Reader ID required — click "Find my card readers" and select the terminal.',
    'sumupTerminal.savedWithNotice': 'Configuration {{mag}} saved. {{notice}}',
    'sumupTerminal.saved': 'Configuration {{mag}} saved.',
    'sumupTerminal.errSave': 'Save error',
    'sumupTerminal.testOk': 'Test OK — check the card reader',
    'sumupTerminal.errTest': 'Test failed',
    'adminB2B.accessDenied': 'Access denied',
    'adminB2B.reservedAdmins': 'Restricted to administrators.',
    'adminB2B.backToDashboard': 'Back to dashboard',
    'adminB2B.back': 'Back',
    'adminB2B.title': 'B2B clients',
    'adminB2B.accountsSingular': 'Companies registered on the B2B portal — {{count}} account',
    'adminB2B.accountsPlural': 'Companies registered on the B2B portal — {{count}} accounts',
    'adminB2B.colCompany': 'Company',
    'adminB2B.colManager': 'Manager',
    'adminB2B.colEmail': 'Email',
    'adminB2B.colPhone': 'Phone',
    'adminB2B.colStatus': 'Status',
    'adminB2B.colRegistered': 'Registered',
    'adminB2B.empty': 'No B2B clients',
    'adminB2B.statusValide': 'Approved',
    'adminB2B.statusEnAttente': 'Pending',
    'adminB2B.statusRefuse': 'Refused',
    'adminCache.statusCompleted': 'Completed',
    'adminCache.statusRunning': 'Running...',
    'adminCache.statusUpdating': 'Updating',
    'adminCache.statusError': 'Error',
    'adminCache.never': 'Never',
    'adminCache.title': 'Supplier Data',
    'adminCache.refreshing': 'Refreshing...',
    'adminCache.refreshData': 'Refresh data',
    'adminCache.step1Title': 'Step 1 — Supplier credentials.',
    'adminCache.step1Intro': 'Enter the email and password for Mobilax, JensMobiles and LCD-Phone on the page',
    'adminCache.step1LinkText': 'Supplier credentials',
    'adminCache.step1Outro': 'Then come back here and click « {{action}} » to feed the AI Auto-Quote.',
    'adminCache.configurePasswords': 'Set up passwords',
    'adminCache.totalCached': 'Total products in cache',
    'adminCache.spareParts': 'Spare parts',
    'adminCache.accessories': 'Accessories',
    'adminCache.phones': 'Phones',
    'adminCache.syncState': 'Synchronization status',
    'adminCache.noSync': 'No synchronization performed',
    'adminCache.exploreCache': 'Explore the cache',
    'adminCache.searchPlaceholder': 'Search (e.g. iPhone 14 case, Galaxy A06 new)...',
    'adminCache.allTypes': 'All types',
    'adminCache.filterParts': 'Parts',
    'adminCache.filterAccessories': 'Accessories',
    'adminCache.filterPhones': 'Phones',
    'adminCache.colType': 'Type',
    'adminCache.colSupplier': 'Supplier',
    'adminCache.colPart': 'Part',
    'adminCache.colBrand': 'Brand',
    'adminCache.colPrice': 'Price',
    'adminCache.colStock': 'Stock',
    'adminCache.colRef': 'Ref.',
    'adminCache.catPart': 'Part',
    'adminCache.catAccessory': 'Accessory',
    'adminCache.catPhone': 'Phone',
    'adminCache.inStock': 'In stock',
    'adminCache.outOfStock': 'Out of stock',
    'adminCache.noResults': 'No results for "{{query}}"',
    'adminDownloads.artifactDesktopLabel': 'Windows staff app',
    'adminDownloads.artifactDesktopDesc': 'ZIP archive distributed to Windows users.',
    'adminDownloads.artifactPackLabel': 'Printer agent pack',
    'adminDownloads.artifactPackDesc': 'Source ZIP archive to rebuild the printing agent.',
    'adminDownloads.artifactExeLabel': 'Windows agent',
    'adminDownloads.artifactExeDesc': 'Executable ready to run on the technician\'s workstation.',
    'adminDownloads.available': 'Available',
    'adminDownloads.missing': 'Missing',
    'adminDownloads.download': 'Download',
    'adminDownloads.activeFile': 'Active file',
    'adminDownloads.size': 'Size',
    'adminDownloads.lastUpdate': 'Last update',
    'adminDownloads.uploadedBy': 'Uploaded by',
    'adminDownloads.replaceLiveFile': 'Replace the live file',
    'adminDownloads.uploading': 'Uploading...',
    'adminDownloads.replace': 'Replace',
    'adminDownloads.replaceHint': 'The chosen file directly replaces the one served to users on remobiles.com.',
    'adminDownloads.selectedFile': 'Selected file: {{name}}',
    'adminDownloads.loadError': 'Error loading files',
    'adminDownloads.downloadLinkUnavailable': 'Download link unavailable',
    'adminDownloads.downloadFailed': 'Download failed',
    'adminDownloads.selectFilePrompt': 'Select a file for {{label}}.',
    'adminDownloads.confirmReplace': 'Replace {{label}} with {{name}} now?',
    'adminDownloads.replaceSuccess': '{{label}} replaced successfully.',
    'adminDownloads.uploadError': 'Error during upload',
    'adminDownloads.title': 'Installers & downloads',
    'adminDownloads.subtitle': 'Direct downloads of Windows packages and live replacement for super admin.',
    'adminDownloads.printerConfig': 'Printer configuration',
    'adminDownloads.refresh': 'Refresh',
    'adminDownloads.availableArtifacts': 'Available artifacts',
    'adminDownloads.totalSize': 'Total size',
    'adminDownloads.alert': 'Alert',
    'adminDownloads.alertText': 'Replacements overwrite the live file. No separate deletion.',
    'adminDownloads.accessTitle': 'Admin and super admin access',
    'adminDownloads.accessText': 'This page centralizes the downloads visible from remobiles.com. Live file replacement only appears for the super admin.',
    'adminDownloads.signedLinksNote': 'Download links stay signed by the backend to avoid browser-side blobs.',
    'adminCachePurge.accessDenied': 'Restricted to Carlos only.',
    'adminCachePurge.title': 'Purge commercial documents',
    'adminCachePurge.descIntro': 'Hidden page — Carlos only. Deletes sales, registers, orders, deposits and quotes/invoices',
    'adminCachePurge.descBefore': 'before',
    'adminCachePurge.descOutro': 'the chosen date. Repairs are not affected.',
    'adminCachePurge.warnBackupBefore': 'Destructive and irreversible action. Make a backup export from',
    'adminCachePurge.warnBackupLink': 'Database',
    'adminCachePurge.warnBackupAfter': 'before any real purge.',
    'adminCachePurge.resultDryRunLine': 'Simulation complete — {{count}} document(s) would be deleted before {{before}}.',
    'adminCachePurge.resultPurgeLine': 'Purge executed — {{count}} document(s) deleted before {{before}}.',
    'adminCachePurge.sectionParams': 'Settings',
    'adminCachePurge.labelBeforeDate': 'Delete everything before',
    'adminCachePurge.hintStrictlyBefore': 'Strictly before 00:00 on that day.',
    'adminCachePurge.labelConfirm': 'Confirmation (required)',
    'adminCachePurge.hintTypeToken': 'Type: {{token}}',
    'adminCachePurge.dryRunLabel': 'Simulation mode (dry-run) — deletes nothing',
    'adminCachePurge.previewBtn': 'Preview',
    'adminCachePurge.simulateBtn': 'Simulate purge',
    'adminCachePurge.executeBtn': 'Run purge',
    'adminCachePurge.previewHeading': 'Preview — {{count}} document(s)',
    'adminCachePurge.beforeLabel': 'before {{before}}',
    'adminCachePurge.previewEmpty': 'No data to display.',
    'adminCachePurge.colCollection': 'Collection',
    'adminCachePurge.colCount': 'Count',
    'adminCachePurge.colExamples': 'Examples',
    'adminCachePurge.sectionExcluded': 'Not deleted',
    'adminCachePurge.excludedReparations': 'Repairs (devices)',
    'adminCachePurge.excludedStock': 'Stock',
    'adminCachePurge.excludedClients': 'Clients',
    'adminCachePurge.excludedUtilisateurs': 'Users',
    'adminCachePurge.confirmDryRun': 'Simulate purge before {{before}} ({{count}} documents)?',
    'adminCachePurge.confirmDelete': '⚠️ IRREVERSIBLE — Delete {{count}} commercial documents before {{before}}?',
    'adminCachePurge.errorPreview': 'Preview error',
    'adminCachePurge.errorLoad': 'Loading error',
    'adminCachePurge.errorPurge': 'Purge error',
    'adminSupplierCreds.title': 'Supplier credentials',
    'adminSupplierCreds.subtitle': '{{providers}} — for Auto-Devis and the catalogue cache',
    'adminSupplierCreds.supplierData': 'Supplier data',
    'adminMagasins.statusActive': 'Active',
    'adminMagasins.statusArchived': 'Archived',
    'adminMagasins.newStore': 'New store',
    'adminMagasins.fieldCode': 'Code (auto-generated, editable)',
    'adminMagasins.fieldName': 'Name *',
    'adminMagasins.namePlaceholder': 'e.g. Cayenne Central Store',
    'adminMagasins.fieldAddress': 'Address',
    'adminMagasins.fieldPhone': 'Phone',
    'adminMagasins.fieldPrinterIp': 'Printer (IP)',
    'adminMagasins.printerIpPlaceholder': 'e.g. 192.168.1.50  — leave empty if no dedicated printer',
    'adminMagasins.printerIpHint': 'If empty → falls back to the POS session printer.',
    'adminMagasins.fieldBadgeColor': 'Badge color',
    'adminMagasins.setAsDefault': 'Set as default store',
    'adminMagasins.defaultWillBeDemoted': 'Store {{code}} ({{name}}) is currently the default. It will be demoted automatically.',
    'adminMagasins.cancel': 'Cancel',
    'adminMagasins.createStore': 'Create store',
    'adminMagasins.nameRequired': 'Name required',
    'adminMagasins.createError': 'Creation error',
    'adminMagasins.confirmOverrideDefault': 'The store "{{code}} — {{name}}" is currently the default store.\n\nBy checking "Set as default", it will be demoted automatically.\n\nConfirm?',
    'adminMagasins.loadError': 'Loading error',
    'adminMagasins.confirmArchive': 'Archive store {{code}}? Items and sales will NOT be deleted.',
    'adminMagasins.genericError': 'Error',
    'adminMagasins.back': 'Back',
    'adminMagasins.title': 'Stores',
    'adminMagasins.subtitle': 'Manage stores (physical shops)',
    'adminMagasins.filterActive': 'Active',
    'adminMagasins.filterArchived': 'Archived',
    'adminMagasins.filterAll': 'All',
    'adminMagasins.colCode': 'Code',
    'adminMagasins.colName': 'Name',
    'adminMagasins.colAddress': 'Address',
    'adminMagasins.colPhone': 'Phone',
    'adminMagasins.colPrinterIp': 'Printer IP',
    'adminMagasins.colColor': 'Color',
    'adminMagasins.colStatus': 'Status',
    'adminMagasins.colActions': 'Actions',
    'adminMagasins.loading': 'Loading…',
    'adminMagasins.emptyArchived': 'No archived store.',
    'adminMagasins.emptyActive': 'No active store.',
    'adminMagasins.defaultBadge': 'DEFAULT',
    'adminMagasins.edit': 'Edit',
    'adminMagasins.cannotArchiveDefault': 'Not possible — default store',
    'adminMagasins.archive': 'Archive',
    'adminMagasins.restore': 'Restore',
    'adminMagasins.footerNote': 'Archived stores keep their items and sales (R1 — soft delete only). The store marked "{{badge}}" cannot be archived.',
    'adminPromos.title': 'Automated promotions',
    'adminPromos.subtitle': 'Active promotions, calendar and settings',
    'adminPromos.tabCurrent': 'Active promotions',
    'adminPromos.tabCalendar': 'Monthly calendar',
    'adminPromos.tabSettings': 'Settings',
    'adminPromos.forceDailyDraw': 'Force a new daily draw',
    'adminPromos.ref': 'Ref: {{ref}}',
    'adminPromos.statusActive': '🟢 Active',
    'adminPromos.statusInactive': '⚫ Inactive',
    'adminPromos.endLabel': 'ends: {{date}}',
    'adminPromos.emptyPromos': 'No promotion',
    'adminPromos.regenThisMonth': 'Regenerate this month',
    'adminPromos.productsCount': '{{count}} products',
    'adminPromos.emptyCalendar': 'No calendar — Regenerate?',
    'adminPromos.configDaily': 'Daily auto-bot',
    'adminPromos.excludedCategories': 'Excluded categories (comma-separated)',
    'adminPromos.excludedKeywords': 'Excluded keywords (regex OR, optional — empty = use defaults)',
    'adminPromos.save': 'Save',
    'adminPromos.minPct': 'Min %',
    'adminPromos.maxPct': 'Max %',
    'adminPromos.confirmRegenDaily': 'Draw a new daily promo now?',
    'adminPromos.drawResult': 'New draw: {{name}}',
    'adminPromos.statusResult': 'Status: {{status}}',
    'adminPromos.confirmRegenCalendar': 'Regenerate the calendar for {{month}}? This overwrites the existing one.',
    'adminPromos.calendarRegenResult': '{{status}} — {{count}} products used',
    'adminPromos.settingsSaved': 'Settings saved',
    'adminCadbotPrix.source.ventePos': 'POS sale',
    'adminCadbotPrix.source.reparation': 'Repair',
    'adminCadbotPrix.source.devisValide': 'Approved quote',
    'adminCadbotPrix.refSource.prixValide': 'validated price',
    'adminCadbotPrix.refSource.tarifPublic': 'public price',
    'adminCadbotPrix.refSource.calculFournisseur': 'supplier calculation',
    'adminCadbotPrix.refSource.aucune': 'no reference',
    'adminCadbotPrix.loadError': 'Loading error',
    'adminCadbotPrix.genericError': 'Error',
    'adminCadbotPrix.toastCollected': '{{ventes}} sales + {{reparations}} repairs recorded',
    'adminCadbotPrix.toastAnalyzed': '{{creees}} new proposal(s), {{maj}} update(s)',
    'adminCadbotPrix.priceInvalid': 'Invalid price',
    'adminCadbotPrix.toastApproved': 'Price validated: {{price}} — {{detail}}',
    'adminCadbotPrix.toastApprovedLocked': 'manual price locked, proposal pending',
    'adminCadbotPrix.toastApprovedPublished': 'Pricing page updated',
    'adminCadbotPrix.rejectReasonPrompt': 'Reason for rejection (optional):',
    'adminCadbotPrix.proposalRejected': 'Proposal rejected',
    'adminCadbotPrix.settingsSaved': 'Settings saved',
    'adminCadbotPrix.confirmRemoveValidated': 'Remove the validated price {{model}} · {{part}} · {{quality}}?',
    'adminCadbotPrix.validatedRemoved': 'Validated price removed',
    'adminCadbotPrix.pageTitle': 'CADBOT price validation',
    'adminCadbotPrix.pageSubtitle': 'CADBOT records the prices actually charged and suggests adjustments. Each validated price feeds the Pricing page and takes priority for quotes.',
    'adminCadbotPrix.rules': 'Rules',
    'adminCadbotPrix.collecting': 'Collecting…',
    'adminCadbotPrix.memorizeSales': 'Record sales',
    'adminCadbotPrix.analyzing': 'Analyzing…',
    'adminCadbotPrix.analyze': 'Analyze',
    'adminCadbotPrix.minSales': 'Minimum sales',
    'adminCadbotPrix.tolerancePct': 'Minimum gap (%)',
    'adminCadbotPrix.toleranceEur': 'Minimum gap (€)',
    'adminCadbotPrix.windowDays': 'Window (days)',
    'adminCadbotPrix.publishOnApprove': 'Publish to the Pricing page on validation',
    'adminCadbotPrix.countDevisValides': 'Also count approved AI quotes (in addition to invoiced sales)',
    'adminCadbotPrix.filterPending': 'To validate',
    'adminCadbotPrix.filterApproved': 'Validated',
    'adminCadbotPrix.filterRejected': 'Rejected',
    'adminCadbotPrix.filterAll': 'All',
    'adminCadbotPrix.refresh': 'Refresh',
    'adminCadbotPrix.loading': 'Loading…',
    'adminCadbotPrix.emptyProposals': 'No proposal {{scope}}. Click “{{collect}}” then “{{analyze}}”.',
    'adminCadbotPrix.emptyScopePending': 'to validate',
    'adminCadbotPrix.tier': 'Grade',
    'adminCadbotPrix.realSales': '{{count}} actual sale(s) (from {{min}} to {{max}})',
    'adminCadbotPrix.lastSaleOn': 'last on {{date}}',
    'adminCadbotPrix.statusBadgePending': 'TO VALIDATE',
    'adminCadbotPrix.statusBadgeApproved': 'VALIDATED',
    'adminCadbotPrix.statusBadgeRejected': 'REJECTED',
    'adminCadbotPrix.referencePrice': 'Reference price',
    'adminCadbotPrix.medianRealSales': 'Median of actual sales',
    'adminCadbotPrix.priceToValidate': 'Price to validate (editable)',
    'adminCadbotPrix.priceRetained': 'Retained price',
    'adminCadbotPrix.evidenceSales': 'Supporting sales ({{count}})',
    'adminCadbotPrix.thDate': 'Date',
    'adminCadbotPrix.thSource': 'Source',
    'adminCadbotPrix.thRef': 'Ref.',
    'adminCadbotPrix.thDesignation': 'Description',
    'adminCadbotPrix.thPriceTtc': 'Price incl. tax',
    'adminCadbotPrix.validate': 'Validate',
    'adminCadbotPrix.validateAt': 'at {{price}} €',
    'adminCadbotPrix.reject': 'Reject',
    'adminCadbotPrix.reviewApproved': 'Validated by {{by}} on {{date}}',
    'adminCadbotPrix.reviewRejected': 'Rejected by {{by}} on {{date}}',
    'adminCadbotPrix.lockedPendingNote': '(price edited manually: locked, price pending)',
    'adminCadbotPrix.validatedPrices': 'Validated prices ({{count}})',
    'adminCadbotPrix.noValidatedPrices': 'No validated price yet.',
    'adminCadbotPrix.thDevice': 'Device',
    'adminCadbotPrix.thPart': 'Part',
    'adminCadbotPrix.thTier': 'Grade',
    'adminCadbotPrix.thPrice': 'Price',
    'adminCadbotPrix.thValidated': 'Validated',
    'adminCadbotPrix.salesCountShort': '{{count}} sale(s)',
    'adminCadbotPrix.remove': 'Remove',
    'adminCommissions.typeVentes': 'Sales',
    'adminCommissions.typeCommandes': 'Orders',
    'adminCommissions.typeAcomptes': 'Deposits',
    'adminCommissions.typeReparations': 'Repairs',
    'adminCommissions.typeFactures': 'Invoices',
    'adminCommissions.typeDevis': 'Quotes',
    'adminCommissions.typeB2b': 'B2B',
    'adminCommissions.typeDeplacement': 'Callout',
    'adminCommissions.tagBackfill': 'Backfill',
    'adminCommissions.tagDoublonPotentiel': 'Potential duplicate',
    'adminCommissions.tagSuspectReparation': 'Suspicious repair',
    'adminCommissions.tagSuspectCommande': 'Suspicious order',
    'adminCommissions.confirmCancel': 'Cancel this commission?',
    'adminCommissions.noSelection': 'No line selected',
    'adminCommissions.confirmBulkMarkPaid': 'Mark {{count}} commission(s) as paid?',
    'adminCommissions.confirmRecompute30d': 'Recompute commissions for the last 30 days for existing sales?\nIdempotent: does not create duplicates.',
    'adminCommissions.recomputeResult': 'Scan: {{scanned}} sales — {{created}} commissions created',
    'adminCommissions.error': 'Error: {{detail}}',
    'adminCommissions.title': 'Commissions',
    'adminCommissions.totalToPay': 'Total to pay',
    'adminCommissions.alreadyPaid': 'Already paid',
    'adminCommissions.recompute30d': 'Recompute last 30 days',
    'adminCommissions.recompute30dHint': 'Retroactive backfill of existing sales',
    'adminCommissions.configPerStaff': 'Configuration per staff',
    'adminCommissions.configure': 'Configure',
    'adminCommissions.noStaffFound': 'No staff found',
    'adminCommissions.filters': 'Filters',
    'adminCommissions.allStatuses': 'All statuses',
    'adminCommissions.statusToPay': 'To pay',
    'adminCommissions.statusPaid': 'Paid',
    'adminCommissions.statusCancelled': 'Cancelled',
    'adminCommissions.allStaff': 'All staff',
    'adminCommissions.allTypes': 'All types',
    'adminCommissions.auditHeuristic': 'Heuristic audit',
    'adminCommissions.auditAdvanced': 'Advanced multi-signal audit',
    'adminCommissions.metierAuditReadOnly': 'Advanced audit — read-only · Mongo ledger untouched · multi-signal analyzer only',
    'adminCommissions.metierAuditLoading': 'Business analysis in progress…',
    'adminCommissions.ledgerCommissionStored': 'Ledger commission (stored)',
    'adminCommissions.metierCommissionTheoretical': 'Theoretical business commission',
    'adminCommissions.totalGapPeriod': 'Total period gap',
    'adminCommissions.rowsAnalyzed': 'Lines analyzed',
    'adminCommissions.typeMismatchDetected': 'Type mismatches detected',
    'adminCommissions.auditHeuristicLegend': 'Heuristic audit: classification by transaction reference. No database writes.',
    'adminCommissions.legendRecompute30d': '30-day recompute',
    'adminCommissions.combinedAuditNote': 'Ledger columns = values stored in Mongo (type, rate snapshot, commission_amount). Métier columns = multi-signal analysis + current staff config for the detected type.',
    'adminCommissions.bulkMarkPaid': 'Mark as paid ({{count}})',
    'adminCommissions.clearSelection': 'Clear selection',
    'adminCommissions.colDate': 'Date',
    'adminCommissions.colStaff': 'Staff',
    'adminCommissions.colType': 'Type',
    'adminCommissions.colTransaction': 'Transaction',
    'adminCommissions.colAmount': 'Amount',
    'adminCommissions.colRateApplied': 'Applied rate',
    'adminCommissions.colCommission': 'Commission',
    'adminCommissions.colStatus': 'Status',
    'adminCommissions.colLedgerType': 'L. type',
    'adminCommissions.colLedgerRate': 'L. rate',
    'adminCommissions.colLedgerCommission': 'L. commission',
    'adminCommissions.colMetierType': 'M. type',
    'adminCommissions.colMetierRate': 'M. rate',
    'adminCommissions.colMetierCommission': 'M. commission',
    'adminCommissions.colGap': 'Gap',
    'adminCommissions.colAuditSignals': 'Audit signals',
    'adminCommissions.colRealType': 'Real type (audit)',
    'adminCommissions.colAppliedType': 'Applied type',
    'adminCommissions.colSource': 'Source',
    'adminCommissions.loading': 'Loading…',
    'adminCommissions.mixed': 'mixed',
    'adminCommissions.pairLabel': 'Pair: {{id}}',
    'adminCommissions.expectedLabel': 'Expected: {{type}}',
    'adminCommissions.markPaidShort': 'Paid',
    'adminCommissions.noCommissionInFilter': 'No commission in this filter',
    'adminCommissions.noCommissionHint': 'If a commission was just activated, use the "Recompute last 30 days" button above.',
    'adminCommissions.modalTitle': '{{name}}\'s commissions',
    'adminCommissions.cancel': 'Cancel',
    'adminCommissions.save': 'Save',
    'adminCloud.status.ok': 'OK',
    'adminCloud.status.ko': 'Failed',
    'adminCloud.status.skipped': 'Skipped',
    'adminCloud.docType.ticket': 'Repair ticket',
    'adminCloud.docType.facture': 'Invoice',
    'adminCloud.docType.acompte': 'Deposit',
    'adminCloud.docType.devis': 'Quote',
    'adminCloud.docType.bonCommande': 'Purchase order',
    'adminCloud.errors.load': 'Loading error',
    'adminCloud.errors.save': 'Save error',
    'adminCloud.errors.test': 'Test error',
    'adminCloud.errors.rebuild': 'Rebuild error',
    'adminCloud.errors.syncToggle': 'Sync toggle error.',
    'adminCloud.save.success': 'Settings saved (the plaintext key is never returned).',
    'adminCloud.test.ok': '✓ Connection OK — {{name}} (owner: {{owner}}, expires: {{expires}})',
    'adminCloud.test.ko': 'Connection failed: {{error}}',
    'adminCloud.test.unknownError': 'unknown',
    'adminCloud.hierarchy.ok': '✓ Hierarchy OK — {{path}} (folder_id: {{folderId}}...)',
    'adminCloud.hierarchy.ko': 'Hierarchy failed — {{message}}',
    'adminCloud.access.adminRequired': 'Admin access required.',
    'adminCloud.sync.resumed': 'Cloud sync RESUMED.',
    'adminCloud.sync.paused': 'Cloud sync PAUSED.',
    'adminCloud.title': 'Cloud Sync — remobiles.fr',
    'adminCloud.subtitlePre': 'Your PDFs (tickets, invoices, quotes, deposits) are automatically archived in your private space',
    'adminCloud.refresh': 'Refresh',
    'adminCloud.sync.active': 'Cloud sync ACTIVE',
    'adminCloud.sync.pausedLabel': 'Cloud sync PAUSED',
    'adminCloud.sync.pausedAt': 'Paused on {{date}}',
    'adminCloud.sync.pausedBy': ' by {{by}}',
    'adminCloud.sync.activeHint': 'All new PDF documents are automatically uploaded to remobiles.fr.',
    'adminCloud.sync.pauseBtn': 'Pause',
    'adminCloud.sync.resumeBtn': 'Resume',
    'adminCloud.confirm.resumeTitle': 'Resume synchronization?',
    'adminCloud.confirm.pauseTitle': 'Pause synchronization?',
    'adminCloud.confirm.resumeBody': 'New documents will again be automatically uploaded to remobiles.fr.',
    'adminCloud.confirm.pauseBody': 'No new document will be uploaded until you resume the sync. Existing documents are not affected.',
    'adminCloud.cancel': 'Cancel',
    'adminCloud.stats.globalStatus': 'Global status',
    'adminCloud.stats.enabled': 'Enabled',
    'adminCloud.stats.disabled': 'Disabled',
    'adminCloud.stats.uploadsOk': 'Uploads OK',
    'adminCloud.stats.uploadsKo': 'Uploads failed',
    'adminCloud.stats.total': 'Total',
    'adminCloud.structure.title': 'Target cloud structure (real hierarchy)',
    'adminCloud.structure.cachedTotal': '{{count}} folders cached',
    'adminCloud.structure.createdThisMonth': '{{count}} created this month',
    'adminCloud.structure.retryHierarchy': 'Retry hierarchy creation',
    'adminCloud.structure.noUploadToday': '(no upload today)',
    'adminCloud.structure.flat': '(flat)',
    'adminCloud.structure.recentFolders': 'Recently created folders',
    'adminCloud.structure.noFolderCache': '(no folder cached)',
    'adminCloud.structure.policyLabel': 'Policy',
    'adminCloud.structure.policyBody': ': no folder or file deletion is ever sent to remobiles.fr. Test files stay visible on the cloud side.',
    'adminCloud.loading': 'Loading...',
    'adminCloud.connection.title': 'Connection settings',
    'adminCloud.connection.uploadUrl': 'Upload URL',
    'adminCloud.connection.status': 'Status',
    'adminCloud.connection.enableAuto': 'Enable automatic synchronization',
    'adminCloud.connection.currentKey': 'Current API key: {{masked}}',
    'adminCloud.connection.noKey': '<none>',
    'adminCloud.connection.keyPlaceholder': 'Paste a new key here to replace (rcsk_...)',
    'adminCloud.connection.keyHint': 'The key is encrypted (Fernet) in the database. Leave empty to keep it unchanged.',
    'adminCloud.save.btn': 'Save',
    'adminCloud.test.btn': 'Test connection (whoami)',
    'adminCloud.test.lastTest': 'Last test: {{mark}} {{date}}',
    'adminCloud.logs.title': 'Upload log',
    'adminCloud.logs.allStatuses': 'All statuses',
    'adminCloud.logs.filterOk': 'OK',
    'adminCloud.logs.filterKo': 'Failed',
    'adminCloud.logs.filterSkipped': 'Skipped',
    'adminCloud.logs.allTypes': 'All types',
    'adminCloud.logs.typeTickets': 'Tickets',
    'adminCloud.logs.typeFactures': 'Invoices',
    'adminCloud.logs.typeAcomptes': 'Deposits',
    'adminCloud.logs.typeDevis': 'Quotes',
    'adminCloud.logs.typeBonsCommande': 'Purchase orders',
    'adminCloud.logs.colDate': 'Date',
    'adminCloud.logs.colType': 'Type',
    'adminCloud.logs.colRef': 'Reference',
    'adminCloud.logs.colStatus': 'Status',
    'adminCloud.logs.colFolder': 'Folder',
    'adminCloud.logs.colError': 'Error',
    'adminCloud.logs.empty': 'No upload yet.',
    'size50x30': '50 x 30 mm (Bixolon standard)',
    'protocolZpl': 'ZPL (recommended for recent Bixolon)',
    'protocolBpl': 'BPL (legacy / SLP series)',
    'fieldClientName': 'Client name',
    'fieldClientPhone': 'Client phone',
    'fieldDeviceLock': 'Code / lock',
    'fieldModel': 'Model',
    'fieldParts': 'Parts / issue',
    'fieldDate': 'Date',
    'fieldPrice': 'Price',
    'fieldRef': 'Reference REM-XXX',
    'errLoad': 'Error loading configuration',
    'saved': 'Configuration saved.',
    'errSave': 'Save error',
    'previewNeedRef': 'Enter a REM-XXX reference for the preview.',
    'errPreview': 'Preview generation error',
    'testQueued': 'Test added to the queue. The local agent will process it as soon as it is connected.',
    'errTest': 'Printer test error',
    'confirmRotate': 'Regenerating the token will invalidate the old one. Continue?',
    'tokenGenerated': 'New token generated. Copy it and paste it into the local agent configuration.',
    'errRotate': 'Token regeneration error',
    'tokenCopied': 'Token copied to the clipboard.',
    'copyFailed': 'Copy failed.',
    'errDownloadPack': 'Download failed{{http}}: {{detail}}',
    'downloadLinkUnavailable': 'Download link unavailable',
    'downloadStartedHint': 'Download started. If nothing happens, allow downloads in your browser.',
    'errDownloadApp': 'Application download failed{{http}}: {{detail}}',
    'agentExeDownloaded': 'Windows agent downloaded successfully.',
    'errDownloadAgent': 'Agent download failed{{http}}: {{detail}}',
    'packDownloaded': 'Agent pack downloaded successfully.',
    'securityTitle': 'Network printer security',
    'securityBody': 'Remember to change the default admin password (admin/admin) and disable TELNET and FTP via the printer\'s web interface',
    'securityNoInternet': 'Never expose port 9100 to the Internet.',
    'downloadsTitle': 'Downloads & installers',
    'downloadsDesc': 'Direct access to the Windows ZIP files, the printer agent and the live replacement page.',
    'openInstallers': 'Open installers',
    'loading': 'Loading...',
    'bixolonSection': 'Bixolon - QR labels',
    'fieldPrinterName': 'Printer name',
    'fieldIp': 'IP address',
    'fieldPortRaw': 'Port (RAW socket)',
    'fieldIpMethod': 'IP method',
    'ipMethodManual': 'Manual (static IP)',
    'ipMethodDhcp': 'DHCP',
    'fieldSubnet': 'Subnet',
    'fieldGateway': 'Gateway',
    'fieldDns': 'DNS',
    'fieldProtocol': 'Printing protocol',
    'fieldDefaultLabelFormat': 'Default label format',
    'printerActive': 'Printer active',
    'testConnection': 'Test connection',
    'lastTest': 'Last test: {{date}}',
    'epsonSection': 'Epson - cash register receipts',
    'epsonDesc': 'These values are used for 80 mm receipts. The Windows agent reads this configuration and then sends the receipt to the store\'s Epson printer.',
    'fieldTicketIp': 'Epson IP address',
    'fieldTicketPort': 'Epson port',
    'fieldTicketProtocol': 'Receipt protocol',
    'ticketProtoEscpos': 'ESC/POS (Epson)',
    'ticketProtoZplFallback': 'ZPL (fallback)',
    'agentSection': 'Local agent',
    'agentDesc': 'The local agent runs on a LAN workstation, receives jobs via polling and sends Bixolon labels or Epson receipts to the configured printers. The API token is used to authenticate as the agent.',
    'tokenCopyNow': 'Token (copy it now - it will no longer be shown):',
    'agentTokenLabel': 'Agent token',
    'tokenCreated': '(created)',
    'tokenNotGenerated': '(not generated)',
    'noToken': '— no token —',
    'hide': 'Hide',
    'show': 'Show',
    'copy': 'Copy',
    'regenerateToken': 'Regenerate token',
    'generateToken': 'Generate token',
    'agentWinTitle': 'Local Windows agent',
    'agentWinDesc': 'Download the ready-to-run agent, or the zip pack if you need to rebuild the agent on a Windows workstation.',
    'directLinks': 'Direct links',
    'dlDesktopApp': 'Windows staff application',
    'dlAgentExe': 'Windows agent (.exe)',
    'dlAgentPack': 'Agent pack (.zip)',
    'tempLinksNote': 'Temporary links signed automatically. They expire after a few minutes.',
    'downloading': 'Downloading...',
    'dlAgentExeBtn': 'Download the Windows agent (.exe)',
    'dlAgentPackBtn': 'Download the agent pack (.zip)',
    'desktopAppDesc': 'Download the pre-built R.E.Mobiles desktop application. It launches the local frontend, the local backend and the included printing agent.',
    'dlDesktopAppBtn': 'Download the Windows application (.zip)',
    'printedFields': 'Printed fields',
    'fieldFontSize': 'Font size (6-16)',
    'fieldMargin': 'Margin (0-24 pt)',
    'previewPdf': 'PDF preview',
    'previewDesc': 'Generate a test PDF label for an existing repair.',
    'previewRefPlaceholder': 'Ref REM-XXX',
    'previewBtn': 'Preview',
    'save': 'Save',
    'reload': 'Reload',
    'errUnknown': 'Unknown error',
    'adminPertes.title': 'Losses',
    'adminPertes.subtitle': 'Off-stock sales charged below the catalog price and discounts beyond the authorized threshold, by seller.',
    'adminPertes.exportCsv': 'Export CSV',
    'adminPertes.recalcul': 'Recalculate on history',
    'adminPertes.typeHorsStock': 'Off-stock below price',
    'adminPertes.typeRemise': 'Excessive discount',
    'adminPertes.typeSousCatalogue': 'Price below catalog',
    'adminPertes.preset30j': '30 d',
    'adminPertes.preset3m': '3 mo',
    'adminPertes.preset12m': '12 mo',
    'adminPertes.presetCustom': 'Custom',
    'adminPertes.payCb': 'Bank card',
    'adminPertes.payCash': 'Cash',
    'adminPertes.payCheque': 'Check',
    'adminPertes.payVirement': 'Transfer',
    'adminPertes.payMixte': 'Mixed',
    'adminPertes.payAvoir': 'Store credit',
    'adminPertes.payAcompte': 'Deposit',
    'adminPertes.periode': 'Period: {{debut}} → {{fin}}',
    'adminPertes.du': 'From',
    'adminPertes.au': 'To',
    'adminPertes.vendeur': 'Seller',
    'adminPertes.type': 'Type',
    'adminPertes.magasin': 'Store',
    'adminPertes.tous': 'All',
    'adminPertes.tileTotal': 'Total loss',
    'adminPertes.calculeLe': 'Computed on {{date}}',
    'adminPertes.remisesExcessives': 'Excessive discounts',
    'adminPertes.auDelaDe': 'Beyond {{pct}}',
    'adminPertes.tileNb': 'Sales concerned',
    'adminPertes.parVendeur': 'By seller',
    'adminPertes.loading': 'Loading…',
    'adminPertes.aucunePerte': 'No loss for the period.',
    'adminPertes.colTotal': 'Total',
    'adminPertes.colNbVentes': 'No. of sales',
    'adminPertes.filtrerVendeur': 'Filter the detail on this seller',
    'adminPertes.detailTitle': 'Sales detail',
    'adminPertes.pageRange': '{{from}}–{{to}} of {{total}}',
    'adminPertes.pageN': 'Page {{page}}',
    'adminPertes.aucuneLigne': 'No rows for these filters.',
    'adminPertes.colDate': 'Date',
    'adminPertes.colTicket': 'Receipt',
    'adminPertes.colArticle': 'Item',
    'adminPertes.colQte': 'Qty',
    'adminPertes.colPrixVendu': 'Sold price',
    'adminPertes.colPrixRef': 'Ref. price',
    'adminPertes.colRemise': 'Discount',
    'adminPertes.colPerte': 'Loss',
    'adminPertes.trierPerte': 'Sort by loss',
    'adminPertes.colStatut': 'Status',
    'adminPertes.colActions': 'Actions',
    'adminPertes.ticket': 'Receipt',
    'adminPertes.ouvrirTicket': 'Open the cash receipt (PDF) in a new tab',
    'adminPertes.voirVente': 'View sale',
    'adminPertes.masquerVente': 'Hide the sale contents',
    'adminPertes.voirVenteTitle': 'See what was sold on this receipt',
    'adminPertes.venteLabel': 'Sale',
    'adminPertes.paiement': 'Payment:',
    'adminPertes.contenuIndispo': 'Sale contents unavailable for this receipt (open the PDF receipt).',
    'adminPertes.ligneEnPerte': '(loss line)',
    'adminPertes.totalVente': 'Sale total:',
    'adminPertes.precedent': 'Previous',
    'adminPertes.suivant': 'Next',
    'adminPertes.lignesParPage': '{{count}} rows per page',
    'adminPertes.legendeTitle': 'How losses are calculated',
    'adminPertes.legendeHorsStockText': '“Off-stock” sale charged below the catalog price although the item existed in the database at the time of sale. Loss =',
    'adminPertes.legendeHorsStockFormula': '(reference price − sold price) × quantity',
    'adminPertes.legendeRemiseText': 'Discount greater than {{seuil}} on a sale line. Only the part beyond {{seuil}} is counted:',
    'adminPertes.legendeRemiseFormula': '(discount − {{seuil}}) × reference price × quantity',
    'adminPertes.legendeSousCatalogue': 'In-stock item sold below the catalog price with no declared discount: same formula as “off-stock below price.”',
    'adminPertes.legendeFooter': 'The reference price is the item’s catalog price on the sale date. “Recalculate on history” re-reads all past sales; the current view is cached and refreshed automatically.',
    'adminPertes.confirmRecalcul': 'Recalculate losses over the entire sales history? This operation re-reads all past sales and may take a few moments.',
    'adminPertes.recalculDone': 'Recalculation done — {{count}} sale(s) analyzed',
    'adminPertes.recalculDoneGeneric': 'Recalculation done over the entire history',
    'adminPertes.recalculFail': 'Recalculation failed',
    'adminPertes.exportDone': 'CSV export downloaded',
    'adminPertes.exportUnavailable': 'Export unavailable (backend needs updating)',
    'adminPertes.exportFail': 'Export failed',
    'adminPertes.refManquante': 'Missing sale reference: receipt not found',
    'adminPertes.ticketFail': 'Unable to open the receipt',
    'adminPertes.endpointIndispo': '“Losses” endpoint unavailable (backend needs updating).',
    'adminPertes.errLoad': 'Loading error',
    'adminPertes.ticketTooltipRef': 'Receipt {{ref}}',
    'adminPertes.lignes_one': '{{count}} row',
    'adminPertes.lignes_other': '{{count}} rows',
    'adminPertes.articles_one': '{{count}} item',
    'adminPertes.articles_other': '{{count}} items',
    'adminPertes.autres_one': '(+{{count}} more)',
    'adminPertes.autres_other': '(+{{count}} more)',
    'adminTodo.cat.ventesHorsStock': 'Out-of-stock sales to confirm',
    'adminTodo.cat.cadbotPrix': 'CADBOT prices to approve',
    'adminTodo.cat.devisChat': 'Chat quotes to process',
    'adminTodo.cat.acomptesACommander': 'Deposits → parts to order',
    'adminTodo.cat.commandesSansSuivi': 'Orders without a tracking number',
    'adminTodo.cat.sumupAConfirmer': 'SumUp payments to confirm',
    'adminTodo.cat.factureRequests': 'Invoice requests',
    'adminTodo.groupFallback': 'Group',
    'adminTodo.time.now': 'just now',
    'adminTodo.time.minutesAgo': '{{n}} min ago',
    'adminTodo.time.hoursAgo': '{{n}} h ago',
    'adminTodo.error.endpointUnavailable': '"To-do" endpoint unavailable (backend needs updating).',
    'adminTodo.error.load': 'Loading error',
    'adminTodo.settings.unavailable': 'Settings unavailable (backend needs updating).',
    'adminTodo.settings.notLoaded': 'Settings not loaded',
    'adminTodo.settings.saved': 'Settings saved',
    'adminTodo.settings.saveError': 'Unable to save settings',
    'adminTodo.title': 'To-do',
    'adminTodo.subtitleUpdated': 'Updated at {{time}} · auto-refresh every 60 s',
    'adminTodo.subtitleDefault': 'Everything that needs action, in one place.',
    'adminTodo.notifications': 'Notifications',
    'adminTodo.refresh': 'Refresh',
    'adminTodo.settings.saving': 'Saving…',
    'adminTodo.settings.loading': 'Loading settings…',
    'adminTodo.settings.pushLabel': 'Push notification on the phone',
    'adminTodo.settings.pushHint': 'An alert as soon as a new action appears.',
    'adminTodo.settings.digestLabel': 'Daily summary at 9 AM',
    'adminTodo.settings.digestHint': 'A single message each morning with everything left to do.',
    'adminTodo.settings.categoriesTracked': 'Tracked categories',
    'adminTodo.allClear': 'Nothing pending. Everything is up to date.',
    'adminTodo.groupNothingPending': 'Nothing pending',
    'adminTodo.open': 'Open',
    'adminTodo.seeAll': 'See all {{count}} items',
    'adminTodo.openPage': 'Open the page',
    'adminTodo.pushOn': 'Push on',
    'adminTodo.pushOff': 'Push off',
    'adminTodo.digestOn': '9 AM summary on',
    'adminTodo.digestOff': '9 AM summary off',
    'adminUsers.role.super_admin.label': 'Super-admin',
    'adminUsers.role.super_admin.desc': 'Full access to the entire system (carlos only)',
    'adminUsers.role.admin_magasin.label': 'Store admin',
    'adminUsers.role.admin_magasin.desc': 'Manages one or more assigned stores',
    'adminUsers.role.technicien.label': 'Repair technician',
    'adminUsers.role.technicien.desc': 'After-sales tickets for both stores. No POS, no accounting.',
    'adminUsers.role.vendeur.label': 'Salesperson',
    'adminUsers.role.vendeur.desc': 'POS on all stores. No accounting, no admin.',
    'adminUsers.roleUnknown': 'unknown',
    'adminUsers.modal.editTitle': 'Edit {{username}}',
    'adminUsers.createUser': 'Create a user',
    'adminUsers.field.username': 'Username',
    'adminUsers.field.passwordEdit': 'New password (leave blank to keep current)',
    'adminUsers.field.passwordCreate': 'Password * (min. {{min}} chars)',
    'adminUsers.field.email': 'Email',
    'adminUsers.field.telephone': 'Phone',
    'adminUsers.field.role': 'Store role',
    'adminUsers.field.assignedMagasins': 'Assigned stores',
    'adminUsers.modal.minOneRequired': '(min. 1 required)',
    'adminUsers.modal.ignoredForRole': '— Stored but ignored for this role (scope = all stores)',
    'adminUsers.modal.loadingMagasins': 'Loading stores…',
    'adminUsers.modal.posOnlyTitle': 'Away / suspended — POS only',
    'adminUsers.modal.posOnlyDesc': 'Can log in and take payments at the POS, without access to other pages (repairs, inventory, customers, admin…).',
    'adminUsers.action.cancel': 'Cancel',
    'adminUsers.action.save': 'Save',
    'adminUsers.action.create': 'Create',
    'adminUsers.denied.title': 'Access denied',
    'adminUsers.denied.desc': 'This page is reserved for the super-administrator.',
    'adminUsers.denied.back': 'Back to dashboard',
    'adminUsers.error.load': 'Loading error',
    'adminUsers.error.passwordMin': 'The password must contain at least {{min}} characters.',
    'adminUsers.feedback.updated': 'User {{username}} updated.',
    'adminUsers.feedback.created': 'User {{username}} created.',
    'adminUsers.error.operation': 'Error during the operation',
    'adminUsers.error.needsMagasinPick': 'First choose a session store (window in the center of the screen), then create the user.',
    'adminUsers.feedback.disabled': '{{username}} disabled.',
    'adminUsers.feedback.enabled': '{{username}} re-enabled.',
    'adminUsers.error.generic': 'Error',
    'adminUsers.action.back': 'Back',
    'adminUsers.title': 'Internal users',
    'adminUsers.subtitle': 'Create / edit / disable (super-admin only)',
    'adminUsers.limitInfo': '{{current}}/{{max}} users · {{plan}} plan',
    'adminUsers.limitReachedTitle': 'Limit reached ({{max}} users max)',
    'adminUsers.limitReached': 'Limit reached ({{max}})',
    'adminUsers.includeDisabled': 'Include disabled users',
    'adminUsers.col.role': 'Role',
    'adminUsers.col.emailTel': 'Email / Phone',
    'adminUsers.col.status': 'Status',
    'adminUsers.col.actions': 'Actions',
    'adminUsers.empty': 'No users.',
    'adminUsers.allMagasins': 'all',
    'adminUsers.status.active': 'Active',
    'adminUsers.status.disabled': 'Disabled',
    'adminUsers.status.posOnly': 'Away · POS only',
    'adminUsers.action.edit': 'Edit',
    'adminUsers.commissions': 'Commissions',
    'adminUsers.action.disable': 'Disable',
    'adminUsers.action.enable': 'Re-enable',
    'adminHorsStock.stockUnknown': 'stock unknown',
    'adminHorsStock.stockCount': 'stock {{count}}',
    'adminHorsStock.selected': 'Selected',
    'adminHorsStock.lineDefaultDesignation': 'Item',
    'adminHorsStock.loadError': 'Loading error',
    'adminHorsStock.lineStillUnresolved': 'A line is still “To check” or has no reference attached.',
    'adminHorsStock.saleValidatedWithLoss': 'Sale {{ref}} confirmed — {{total}} in history. Loss recorded: {{loss}}.',
    'adminHorsStock.saleValidatedNoLoss': 'Sale {{ref}} confirmed — {{total}} in history, no loss.',
    'adminHorsStock.validationFailed': 'Validation failed',
    'adminHorsStock.catalogBadge': 'Catalog',
    'adminHorsStock.cashedLineInfo': 'collected {{qty}} × {{price}}',
    'adminHorsStock.horsStockBadge': 'Out of stock',
    'adminHorsStock.articleExistedQuestion': 'Did the item exist?',
    'adminHorsStock.optionLoss': 'Loss — the item existed, attach the reference',
    'adminHorsStock.optionNonExistent': 'Nonexistent item — accept as is',
    'adminHorsStock.optionToVerify': 'To check',
    'adminHorsStock.attachedArticle': 'Attached item',
    'adminHorsStock.refLabel': 'Ref. {{ref}}',
    'adminHorsStock.catalogPriceLabel': 'Catalog price',
    'adminHorsStock.unknown': 'unknown',
    'adminHorsStock.soldLabel': 'sold',
    'adminHorsStock.estimatedLoss': 'Estimated loss',
    'adminHorsStock.selectCatalogRef': 'Select the catalog reference matching this item.',
    'adminHorsStock.catalogSuggestions': 'Catalog suggestions',
    'adminHorsStock.noSuggestion': 'No suggestion for this line — use the search below.',
    'adminHorsStock.otherCatalogArticle': 'Another catalog item',
    'adminHorsStock.searchPlaceholder': 'Search reference / name / EAN…',
    'adminHorsStock.noArticleFound': 'No item found.',
    'adminHorsStock.freeArticleInfo': 'Free item: the line is kept as is, with no attachment or stock movement.',
    'adminHorsStock.toVerifyInfo': 'Blocks validation until the line is decided (Yes / No).',
    'adminHorsStock.toValidateBadge': 'To confirm',
    'adminHorsStock.cashedBadge': 'Collected',
    'adminHorsStock.cashedAmountLabel': 'Collected',
    'adminHorsStock.subtotal': 'Subtotal',
    'adminHorsStock.discountLabel': 'Discount',
    'adminHorsStock.historyTotal': 'History total',
    'adminHorsStock.amountLockedInfo': 'Amount actually collected: price, quantities and discount can’t be changed here.',
    'adminHorsStock.lossesPreview': 'Losses preview (visible to management only)',
    'adminHorsStock.remiseExcessiveLabel': 'Discount above {{seuil}}% ({{pct}} granted)',
    'adminHorsStock.lossRecorded': 'Recorded loss',
    'adminHorsStock.lossSavedInfo': 'Recorded on the Losses page upon confirmation.',
    'adminHorsStock.noLossYet': 'No loss recorded at this stage',
    'adminHorsStock.noLossYetSuffix': ' — the calculation completes once the references are attached.',
    'adminHorsStock.noteLabel': 'Note (optional)',
    'adminHorsStock.notePlaceholder': 'E.g. negotiated price, item received on…',
    'adminHorsStock.validateButton': 'Confirm and write to history',
    'adminHorsStock.blockedTitle': 'One or more out-of-stock lines still need a decision',
    'adminHorsStock.validationBlocked': 'Validation blocked:',
    'adminHorsStock.blockedVerifierCount': '{{n}} line(s) “To check”',
    'adminHorsStock.blockedNoRefCount': '{{n}} “Yes” line(s) without an attached reference',
    'adminHorsStock.legendTitle': 'What happens',
    'adminHorsStock.legendIntro': 'The sale is already collected: it can’t be canceled and stock isn’t changed. Confirmation attaches the right item, records the price gap or the excessive discount in the losses, then writes the sale to history.',
    'adminHorsStock.legendYesWord': 'Yes',
    'adminHorsStock.legendYesDesc': '— the item existed: select the catalog reference (suggestions or search).',
    'adminHorsStock.legendNonWord': 'No',
    'adminHorsStock.legendNonDesc': '— free item, kept as is.',
    'adminHorsStock.legendVerifierDesc': '— blocks validation until the line is decided.',
    'adminHorsStock.legendPertesWord': 'Losses',
    'adminHorsStock.legendPertesDesc': '— gap between catalog price and sold price, plus the share of discount above {{seuil}}% of the subtotal; visible only here and recorded on the Losses page.',
    'adminHorsStock.pageTitle': 'Out-of-stock sales to confirm',
    'adminHorsStock.pageSubtitle': 'Already collected; absent from history until confirmed by management.',
    'adminHorsStock.refresh': 'Refresh',
    'adminHorsStock.emptyState': 'No out-of-stock sale awaiting confirmation.',
    'adminHorsStock.processedThisSession': 'Processed in this session',
    'adminHorsStock.lossShortLabel': 'loss',
    'adminHorsStock.validatedBadge': 'Confirmed',
    'stockPhotoAi.title': 'Stock photos · AI',
    'stockPhotoAi.subtitle': 'Super-admin Carlos · OpenAI generation · isolated store M1/M2',
    'stockPhotoAi.apiKeysLink': 'OpenAI API keys',
    'stockPhotoAi.statsTotal': 'Items {{mag}}',
    'stockPhotoAi.statsWithPhoto': 'With photo',
    'stockPhotoAi.statsMissing': 'No photo',
    'stockPhotoAi.searchPlaceholder': 'Search ref or description…',
    'stockPhotoAi.filter': 'Filter',
    'stockPhotoAi.generateBatch': 'Generate batch (max 10)',
    'stockPhotoAi.batchResult': 'Batch {{mag}}: {{ok}} OK · {{skipped}} skipped · {{errors}} errors',
    'stockPhotoAi.loading': 'Loading…',
    'stockPhotoAi.stockLabel': 'Stock {{qty}}',
    'stockPhotoAi.generateOne': 'Generate AI',
    'stockPhotoAi.empty': 'No item without a photo for {{mag}}',
    'stockPhotoAi.errorLoad': 'Unable to load',
    'stockPhotoAi.errorGenerate': 'Generation failed',
    'stockPhotoAi.errorBatch': 'Batch failed',
    'stockPhotoAi.confirmBatch': 'Generate up to {{max}} AI images for {{mag}}? (OpenAI · API cost)',
    'stockCatAudit.title': 'Stock category audit',
    'stockCatAudit.subtitle': 'Full phone vs part/accessory analysis · reserved for Carlos',
    'stockCatAudit.backToIntegrations': 'Admin integrations',
    'stockCatAudit.magasin': 'Store',
    'stockCatAudit.allStores': 'All',
    'stockCatAudit.issuesOnly': 'Rows with issues only',
    'stockCatAudit.runAnalysis': 'Run analysis',
    'stockCatAudit.statTotal': 'Total',
    'stockCatAudit.statWithIssues': 'With issues',
    'stockCatAudit.statFalseImei': 'False IMEI',
    'stockCatAudit.statNeedsImei': 'IMEI required',
    'stockCatAudit.statCategorieMismatch': 'Diff. category',
    'stockCatAudit.statCategorieMissing': 'No category',
    'stockCatAudit.statAmbiguous': 'Ambiguous',
    'stockCatAudit.currentCategories': 'Current categories',
    'stockCatAudit.suggestedCategories': 'Suggested categories',
    'stockCatAudit.searchPlaceholder': 'Ref, designation, category…',
    'stockCatAudit.allFilters': 'All filters',
    'stockCatAudit.applySuggested': 'Apply suggested cat. ({{count}})',
    'stockCatAudit.colRef': 'Ref',
    'stockCatAudit.colDesignation': 'Designation',
    'stockCatAudit.colMag': 'Store',
    'stockCatAudit.colCurrentCat': 'Current cat.',
    'stockCatAudit.colSuggestedCat': 'Suggested cat.',
    'stockCatAudit.colType': 'Type',
    'stockCatAudit.colIssues': 'Issues',
    'stockCatAudit.typePhone': 'Phone',
    'stockCatAudit.typePiece': 'Part',
    'stockCatAudit.analyzing': 'Analyzing…',
    'stockCatAudit.emptyRows': 'No rows — run the analysis or widen the filters.',
    'stockCatAudit.hint': 'E.g. "Phone holder" is now classified as Accessory (no IMEI). Real complete phones still require an IMEI at inventory.',
    'stockCatAudit.errorAnalyze': 'Analysis failed',
    'stockCatAudit.errorApply': 'Apply failed',
    'stockCatAudit.confirmApply': 'Apply the suggested category to {{count}} item(s)?',
    'stockCatAudit.issueFalsePhoneImei': 'False phone (wrongly has IMEI)',
    'stockCatAudit.issueNeedsImei': 'Phone — IMEI required',
    'stockCatAudit.issueCategorieMismatch': 'Different category',
    'stockCatAudit.issueCategorieMissing': 'Missing category',
    'stockCatAudit.issueAmbiguous': 'Ambiguous',
    'stockHist.periodToday': 'Today',
    'stockHist.periodYesterday': 'Yesterday',
    'stockHist.periodWeek': 'This week',
    'stockHist.periodMonth': 'This month',
    'stockHist.title': 'Stock history',
    'stockHist.subtitle': 'Shop and warehouse movements',
    'stockHist.statMovements': 'Movements',
    'stockHist.statPieces': 'Pieces',
    'stockHist.locationShop': 'Shop',
    'stockHist.locationWarehouse': 'Warehouse',
    'stockHist.empty': 'No additions for this period',
    'stockHist.colDateTime': 'Date / Time',
    'stockHist.colDesignation': 'Item',
    'stockHist.colStore': 'Store',
    'stockHist.colLocation': 'Location',
    'stockHist.colQty': 'Qty',
    'stockHist.colSalePrice': 'Sale price',
    'stockHist.colBy': 'By',
    'stockHist.statusNew': 'New',
    'stockHist.statusRestock': 'Restock',
    'stockHist.selectedOne': 'selected',
    'stockHist.selectedMany': 'selected',
    'stockHist.labelOne': 'label',
    'stockHist.labelMany': 'labels',
    'stockHist.printCount': 'Print ({{count}})',
    'partsOrders.statusPending': 'Pending',
    'partsOrders.statusPartial': 'Partial',
    'partsOrders.statusReceived': 'Received',
    'partsOrders.statusCancelled': 'Cancelled',
    'partsOrders.filterAll': 'All',
    'partsOrders.filterReceived': 'Received',
    'partsOrders.filterCancelled': 'Cancelled',
    'partsOrders.partTypeStandard': 'Standard',
    'partsOrders.partTypeSpare': 'Spare part',
    'partsOrders.partTypeSerialized': 'Serialized (serial no./IMEI)',
    'partsOrders.createTitle': 'New supplier order',
    'partsOrders.supplier': 'Supplier',
    'partsOrders.supplierPlaceholder': 'Supplier name',
    'partsOrders.line': 'Line {{num}}',
    'partsOrders.designationPlaceholder': 'Description *',
    'partsOrders.referencePlaceholder': 'Reference (optional)',
    'partsOrders.type': 'Type',
    'partsOrders.qty': 'Qty',
    'partsOrders.purchasePriceUnit': 'Unit cost',
    'partsOrders.expectedSalePrice': 'Expected sale price',
    'partsOrders.category': 'Category',
    'partsOrders.categoryPlaceholder': 'E.g. Screen, Battery',
    'partsOrders.location': 'Location',
    'partsOrders.locationShop': 'Shop',
    'partsOrders.locationWarehouse': 'Warehouse',
    'partsOrders.addLine': 'Add a line',
    'partsOrders.notes': 'Notes',
    'partsOrders.errorNeedLine': 'Add at least one line with a description.',
    'partsOrders.errorCreate': 'Error while creating.',
    'partsOrders.cancel': 'Cancel',
    'partsOrders.creating': 'Creating…',
    'partsOrders.create': 'Create order',
    'partsOrders.receiveTitle': 'Receiving — {{ref}}',
    'partsOrders.allReceived': 'All lines have already been received.',
    'partsOrders.remaining': 'Remaining {{count}}',
    'partsOrders.receivedQty': 'Qty received',
    'partsOrders.serialsLabel': 'Serial no. / IMEI (one per line or comma-separated)',
    'partsOrders.errorNeedQty': 'Enter at least one received quantity.',
    'partsOrders.errorReceive': 'Error while receiving.',
    'partsOrders.close': 'Close',
    'partsOrders.validating': 'Validating…',
    'partsOrders.validateReceive': 'Confirm receipt',
    'partsOrders.linkTitle': 'Assign to a repair',
    'partsOrders.linkDescription': 'The part “{{designation}}” will be added to the repair price without being deducted from stock (not yet received).',
    'partsOrders.linkRefPlaceholder': 'Repair ref (e.g. REP-000123)',
    'partsOrders.errorNeedRef': 'Enter the repair reference.',
    'partsOrders.errorRepairNotFound': 'Error: repair not found?',
    'partsOrders.assign': 'Assign',
    'partsOrders.confirmCancel': 'Cancel this order? Parts linked to repairs will be detached.',
    'partsOrders.errorCancel': 'Cancellation error.',
    'partsOrders.errorGeneric': 'Error.',
    'partsOrders.supplierUnknown': 'Supplier?',
    'partsOrders.linesCount': '{{count}} line(s)',
    'partsOrders.receivedCount': '{{received}}/{{total}} received',
    'partsOrders.purchaseCost': 'purchase cost',
    'partsOrders.colDesignation': 'Description',
    'partsOrders.colReceivedQty': 'Received/Qty',
    'partsOrders.colPurchaseUnit': 'Unit cost',
    'partsOrders.colSalePlanned': 'Planned sale',
    'partsOrders.colRepair': 'Repair',
    'partsOrders.colAction': 'Action',
    'partsOrders.typeSerialized': 'Serialized',
    'partsOrders.typeSpareShort': 'Part',
    'partsOrders.typeStandardShort': 'Std',
    'partsOrders.detach': 'Detach',
    'partsOrders.receive': 'Receive',
    'partsOrders.pageTitle': 'Parts orders',
    'partsOrders.pageSubtitle': 'Supplier procurement — repair pre-assignment & receiving',
    'partsOrders.filterAllStores': 'All',
    'partsOrders.refresh': 'Refresh',
    'partsOrders.newOrder': 'New order',
    'partsOrders.kpiOpenOrders': 'Open orders',
    'partsOrders.kpiAssignedParts': 'Parts assigned to repair',
    'partsOrders.kpiCostToReceive': 'Cost to receive',
    'partsOrders.loading': 'Loading…',
    'partsOrders.empty': 'No parts orders.',
    'stockForm.editTitle': 'Edit item',
    'stockForm.addTitle': 'Add item',
    'stockForm.productSheet': 'Product sheet',
    'stockForm.newStockProduct': 'New stock product',
    'stockForm.analyzePhoto': 'Analyze photo',
    'stockForm.scan': 'Scan',
    'stockForm.supplierSearch': 'Supplier search',
    'stockForm.supplierSearchPlaceholder': 'Reference, EAN or part name…',
    'stockForm.refShort': 'Ref:',
    'stockForm.priceLabel': 'Price:',
    'stockForm.sectionArticle': 'Item section',
    'stockForm.reference': 'Reference',
    'stockForm.ean': 'EAN',
    'stockForm.eanPlaceholder': 'Barcode',
    'stockForm.category': 'Category',
    'stockForm.categoryPlaceholder': 'Screens, batteries…',
    'stockForm.designation': 'Description',
    'stockForm.supplier': 'Supplier',
    'stockForm.sectionStock': 'Stock section',
    'stockForm.location': 'Location',
    'stockForm.shop': 'Shop',
    'stockForm.depot': 'Warehouse',
    'stockForm.both': 'Both',
    'stockForm.qtyShop': 'Shop qty',
    'stockForm.qtyDepot': 'Warehouse qty',
    'stockForm.alertThreshold': 'Alert threshold',
    'stockForm.sectionPricing': 'Pricing section',
    'stockForm.purchasePrice': 'Purchase price (excl. tax)',
    'stockForm.salePrice': 'Sale price (€)',
    'stockForm.margin': 'Margin',
    'stockForm.sectionShop': 'Shop section',
    'stockForm.visibleOnline': 'Visible in online shop',
    'stockForm.visibleOnlineHint': 'Customers will be able to buy this item',
    'stockForm.cancel': 'Cancel',
    'stockForm.saving': 'Saving…',
    'stockForm.edit': 'Edit',
    'stockForm.addToStock': 'Add to stock',
    'stockForm.save': 'Save',
    'stockForm.reviewTitle': 'Item review',
    'stockForm.newArticle': 'New item',
    'stockForm.existingBanner': 'Existing — {{designation}} (S:{{qb}} W:{{qd}}). Quantity added to stock.',
    'stockForm.imeiRequired': 'IMEI required to register a phone in stock.',
    'stockForm.imeiInvalid': 'Invalid IMEI (14 to 20 digits).',
    'stockForm.articleNotFound': 'Item not found',
    'stockForm.imeiNotRegistered': 'IMEI not registered — check the number or Advanced stock > IMEI.',
    'stockForm.imeiFirstRegistered': 'First IMEI registered. {{count}} device(s) remaining — complete the IMEIs in Advanced stock > IMEI tab (ref. {{ref}}).',
    'stockForm.saveError': 'Error while saving',
    'clientChat.typeBoutiqueOrder': 'Shop order',
    'clientChat.typeRepair': 'Repair',
    'clientChat.typeClient': 'Client chat',
    'clientChat.title': 'Client Chat',
    'clientChat.convCount': '{{count}} conversation',
    'clientChat.convCountPlural': '{{count}} conversations',
    'clientChat.searchPlaceholder': 'Search for a client...',
    'clientChat.noConversations': 'No client conversations',
    'clientChat.clientFallback': 'Client',
    'clientChat.startConversation': 'Start the conversation',
    'clientChat.writePlaceholder': 'Write to the client...',
    'clientChat.selectConversation': 'Select a conversation',
    'stockInvImport.errorAiAnalysis': 'AI analysis error — check Admin > API Integrations (OpenAI)',
    'stockInvImport.confirmMissingImei': '{{count}} phone line(s) without a complete IMEI.\n\nContinue the import? You can complete them in Advanced stock > IMEI.',
    'stockInvImport.errorImport': 'Import error',
    'stockInvImport.locationDepot': 'Warehouse',
    'stockInvImport.locationBoutique': 'Store',
    'stockInvImport.pageTitle': 'AI invoice import',
    'stockInvImport.pageSubtitle': 'PDF analysis · calculations aligned with /calcul',
    'stockInvImport.visionHint': 'OpenAI Vision · price rounding identical to the Margin calculation module',
    'stockInvImport.invoiceLabel': 'Invoice (PDF or image)',
    'stockInvImport.fileSize': '{{size}} KB',
    'stockInvImport.clickToChoose': 'Click to choose a file',
    'stockInvImport.shippingTotalLabel': 'Total shipping cost (EUR)',
    'stockInvImport.autoIfEmpty': '— auto if empty',
    'stockInvImport.shippingPlaceholder': 'e.g. 29.90',
    'stockInvImport.customsPct': 'Customs %',
    'stockInvImport.marginPct': 'Margin %',
    'stockInvImport.analyzing': 'Analyzing… (15–30 s)',
    'stockInvImport.analyzeInvoice': 'Analyze invoice',
    'stockInvImport.kpiProducts': 'Products',
    'stockInvImport.kpiSupplier': 'Supplier',
    'stockInvImport.kpiShippingTotal': 'Total shipping',
    'stockInvImport.kpiShippingPerUnit': 'Shipping / unit',
    'stockInvImport.recalc': 'Recalculating…',
    'stockInvImport.phonesCompleteImei': '{{count}} phone(s) — complete the IMEI below (auto-extracted from the invoice if present).',
    'stockInvImport.colRef': 'Ref',
    'stockInvImport.colDesignation': 'Description',
    'stockInvImport.colQty': 'Qty',
    'stockInvImport.colPurchase': 'Cost',
    'stockInvImport.colPlusShipping': '+Shipping',
    'stockInvImport.colPlusCustoms': '+{{pct}}% Customs',
    'stockInvImport.colPlusMargin': '+{{pct}}% Margin',
    'stockInvImport.colLabor': 'Labor',
    'stockInvImport.colFinalPrice': 'Final Price',
    'stockInvImport.remove': 'Remove',
    'stockInvImport.generateEan': 'Generate EAN',
    'stockInvImport.imeiDevicePlaceholder': 'Device IMEI {{n}}',
    'stockInvImport.back': 'Back',
    'stockInvImport.importing': 'Importing…',
    'stockInvImport.confirm': 'Confirm',
    'stockInvImport.importDone': 'Import complete',
    'stockInvImport.created': 'Created',
    'stockInvImport.updated': 'Updated',
    'stockInvImport.imeiRegistered': 'IMEIs registered',
    'stockInvImport.errors': 'Errors',
    'stockInvImport.imeiMissingTitle': 'Missing IMEIs — complete in Advanced stock',
    'stockInvImport.missingOfTotal': '{{missing}} missing / {{total}}',
    'stockInvImport.newImport': 'New import',
    'stockInvImport.backToStock': 'Back to stock',
    'clientPwd.pinGenerated': 'PIN generated for {{nom}}: {{pin}}',
    'clientPwd.error': 'Error',
    'clientPwd.errorSendEmail': 'Error sending email',
    'clientPwd.errorSendBulk': 'Error sending bulk emails',
    'clientPwd.bulkResult': '{{sent}} emails sent, {{errors}} errors',
    'clientPwd.totalClients': '{{total}} clients in total',
    'clientPwd.sending': 'Sending...',
    'clientPwd.sendToClients': 'Send to {{count}} clients',
    'clientPwd.searchPlaceholder': 'Search by name, phone, email...',
    'clientPwd.filterAll': 'All',
    'clientPwd.filterSent': 'Password sent',
    'clientPwd.filterNotSent': 'Password not sent',
    'clientPwd.colName': 'Name',
    'clientPwd.colPhone': 'Phone',
    'clientPwd.colEmail': 'Email',
    'clientPwd.colPin': 'PIN',
    'clientPwd.colStatus': 'Status',
    'clientPwd.colActions': 'Actions',
    'clientPwd.loading': 'Loading...',
    'clientPwd.noEmail': 'No email',
    'clientPwd.statusSent': 'Sent',
    'clientPwd.statusPending': 'Pending',
    'clientPwd.statusNotGenerated': 'Not generated',
    'clientPwd.genPinTitle': 'Generate PIN',
    'clientPwd.resend': 'Resend',
    'clientPwd.pageOf': 'Page {{page}} / {{total}}',
    'stockInv.error.pickMagasin': 'First choose a store for this inventory.',
    'stockInv.error.analyzeFailed': 'Analysis failed — check the OpenAI key or try again.',
    'stockInv.error.server': 'Server error',
    'stockInv.dropdown.refLabel': 'Ref:',
    'stockInv.short.boutique': 'S',
    'stockInv.short.depot': 'W',
    'stockInv.summary.title': 'Inventory summary',
    'stockInv.summary.subtitle': '{{count}} item(s) saved',
    'stockInv.summary.statusNew': 'New',
    'stockInv.summary.statusUpdated': 'Updated',
    'stockInv.summary.errorsTitle': 'Errors',
    'stockInv.summary.created': '{{count}} created',
    'stockInv.summary.updated': '{{count}} updated',
    'stockInv.summary.pieces': '{{count}} pcs',
    'stockInv.btn.printLabels': 'Print labels',
    'stockInv.btn.newInventory': 'New inventory',
    'stockInv.btn.printCount': 'Print ({{count}})',
    'stockInv.btn.addRow': 'Row',
    'stockInv.btn.scan': 'Scan',
    'stockInv.btn.csvImport': 'Import CSV',
    'stockInv.btn.csvExport': 'Export',
    'stockInv.btn.saving': 'Saving…',
    'stockInv.btn.saveAll': 'Save all ({{count}})',
    'stockInv.col.status': 'Status',
    'stockInv.col.reference': 'Reference',
    'stockInv.col.designation': 'Description',
    'stockInv.col.pAchat': 'Buy price',
    'stockInv.col.pVente': 'Sell price',
    'stockInv.col.lieu': 'Place',
    'stockInv.col.qteAjoutee': 'Added qty',
    'stockInv.col.stockTotal': 'Total stock',
    'stockInv.col.magasin': 'Store',
    'stockInv.col.prixAchat': 'Buy price (€)',
    'stockInv.col.prixVente': 'Sell price (€)',
    'stockInv.col.emplacement': 'Location',
    'stockInv.col.qte': 'Qty',
    'stockInv.col.fournisseur': 'Supplier',
    'stockInv.location.boutique': 'Shop',
    'stockInv.location.depot': 'Warehouse',
    'stockInv.header.title': 'Stock inventory',
    'stockInv.header.subtitleMagasin': 'Quick entry · {{magasin}}',
    'stockInv.header.subtitleNoMagasin': 'Quick entry · choose a store',
    'stockInv.warn.pickMagasin': 'Choose a store before saving the inventory.',
    'stockInv.cross.title': '{{count}} reference(s) already exist(s) in another store',
    'stockInv.cross.explain': 'You created a new line in your target store. If this is intentional (stock dedicated per store), ignore this message. If you meant to transfer, go to',
    'stockInv.cross.explainTransfer': '→ Transfer.',
    'stockInv.cross.createdIn': 'created in {{magasin}}',
    'stockInv.cross.existedIn': 'existed in',
    'stockInv.cross.noMagasin': '— no store —',
    'stockInv.cross.qty': 'qty',
    'stockInv.badge.existing': 'existing',
    'stockInv.badge.new': 'new',
    'stockInv.placeholder.refEan': 'Ref / EAN',
    'stockInv.placeholder.ean13': 'EAN13 code',
    'stockInv.placeholder.productName': 'Product name',
    'stockInv.placeholder.fournisseur': 'Supplier',
    'stockInv.footer.rows': 'rows',
    'stockInv.footer.toSave': 'to save',
    'stockInv.footer.existingCount': '({{count}} existing)',
    'stockInv.footer.newCount': '({{count}} new)',
    'stockInv.footer.piecesAndValue': '{{count}} pcs · {{value}} purchase',
    'stockInv.hint.enterBefore': 'Press',
    'stockInv.hint.enterKey': 'Enter',
    'stockInv.hint.enterAfter': 'to move to the next row',
    'stockInv.review.title': 'Inventory pre-analysis',
    'stockInv.review.subtitle': '{{count}} line(s) · store {{magasin}}',
    'staffChat.statusOnline': 'Online',
    'staffChat.statusBusy': 'Busy',
    'staffChat.statusAway': 'Away',
    'staffChat.statusOffline': 'Offline',
    'staffChat.colorYellow': 'Yellow',
    'staffChat.colorBlue': 'Blue',
    'staffChat.colorGreen': 'Green',
    'staffChat.colorOrange': 'Orange',
    'staffChat.colorPurple': 'Purple',
    'staffChat.colorCyan': 'Cyan',
    'staffChat.colorRed': 'Red',
    'staffChat.quickRepliesTitle': 'Quick replies',
    'staffChat.quickRepliesSubtitle': 'Customize the chat replies',
    'staffChat.qrLabelPlaceholder': 'Label (e.g. Ready!)',
    'staffChat.qrTextPlaceholder': 'Message text...',
    'staffChat.qrSaveEdit': 'Save',
    'staffChat.cancel': 'Cancel',
    'staffChat.add': 'Add',
    'staffChat.filterAll': 'All',
    'staffChat.filterTeam': 'Team',
    'staffChat.filterClients': 'Clients',
    'staffChat.filterTickets': 'Tickets',
    'staffChat.filterQuick': 'Quick',
    'staffChat.messaging': 'Messaging',
    'staffChat.newConversation': 'New conversation',
    'staffChat.searchPlaceholder': 'Search a conversation...',
    'staffChat.noStaffAvailable': 'No member available',
    'staffChat.labelTeam': 'Team',
    'staffChat.labelOrder': 'Order',
    'staffChat.labelRepair': 'Repair',
    'staffChat.labelClient': 'Client',
    'staffChat.priorityUrgent': 'Urgent',
    'staffChat.priorityMedium': 'Medium',
    'staffChat.priorityNormal': 'Normal',
    'staffChat.ticketsNone': 'No pending ticket',
    'staffChat.ticketsAllHandled': 'All messages have been handled',
    'staffChat.timeAgoLessThanHour': 'less than 1 h ago',
    'staffChat.timeAgoHours': '{{h}} h ago',
    'staffChat.viewConversation': 'View conversation',
    'staffChat.close': 'Close',
    'staffChat.recentlyClosed': 'Recently closed',
    'staffChat.closedBy': 'by {{name}}',
    'staffChat.noConversations': 'No conversation',
    'staffChat.conversation': 'Conversation',
    'staffChat.startConversation': 'Start the conversation',
    'staffChat.endToEndEncrypted': 'Messages are end-to-end encrypted',
    'staffChat.aiAssistant': 'AI assistant',
    'staffChat.autoBadge': 'auto',
    'staffChat.nudgeTitle': 'Send a nudge!',
    'staffChat.sending': 'Sending...',
    'staffChat.messagePlaceholder': 'Write a message...',
    'staffChat.selectConversation': 'Select a conversation',
    'staffChat.chooseFromList': 'Choose from the list on the left',
    'warnDuplicateReference': 'Already in stock — +1 on save',
    'warnDuplicateEan': 'EAN already in stock — +1 on save',
    'warnCrossMagasin': 'Reference in another store',
    'warnLowVision': 'Uncertain photo reading',
    'warnPrixAchatManual': 'Purchase price to enter manually',
    'warnLlmUnavailable': 'AI vision unavailable (API keys)',
    'alertAddPhotoOrText': 'Add a photo or paste the label text.',
    'errAnalyzePhoto': 'Photo analysis error',
    'alertEnterPrixAchat': 'Enter a purchase price to recalculate the sale price.',
    'errCalcPrice': 'Price calculation error',
    'alertRefDesignationRequired': 'Reference and designation required.',
    'alertPrixVenteRequired': 'Sale price required.',
    'noticeAddedToList': '+{{qty}} to the list: {{designation}} (total +{{total}})',
    'noticeStockUpdate': 'Stock update: {{designation}} (+{{qty}})',
    'noticeAdded': 'Added: {{designation}} (×{{qty}})',
    'errServer': 'Server error',
    'alertChooseMagasin': 'Choose a store.',
    'errAnalyzeImpossible': 'Analysis failed',
    'summaryTitle': 'Saved items',
    'summarySubtitle': '{{created}} created · {{updated}} updated · {{labels}} label(s) to print',
    'printLabels': 'Print labels ({{count}})',
    'newSession': 'New session',
    'colStatut': 'Status',
    'colReference': 'Reference',
    'colDesignation': 'Designation',
    'colPrixAchat': 'Purch. price',
    'colPrixVente': 'Sale price',
    'colQtyAdded': 'Qty added',
    'badgeNew': 'New',
    'badgeAddStock': '+stock',
    'pageTitle': 'Analyze a product',
    'pageSubtitle': 'Scan several items · validate each line · save all at once',
    'pendingList': 'Pending list — {{count}} item(s) · {{pieces}} piece(s)',
    'saveAll': 'Save all ({{count}})',
    'badgeUpdate': 'Update',
    'depot': 'Warehouse',
    'boutique': 'Shop',
    'stockAbbrev': 'stock S:{{boutique}} W:{{depot}}',
    'remove': 'Remove',
    'photoSectionTitle': 'Product photo',
    'productAlt': 'Product',
    'photoHint': 'Gallery or camera — packaging or label (EAN visible)',
    'gallery': 'Gallery',
    'camera': 'Camera',
    'analyzing': 'Analyzing…',
    'analyze': 'Analyze',
    'aiVisionOption': 'AI vision if label unreadable (OpenAI / Gemini)',
    'labelTextLabel': 'Label text (optional — if the barcode is unreadable)',
    'labelTextPlaceholder': 'iPhone 8 OLED screen\nEAN 3701234567890\nRef IP8-LCD-001',
    'emptyHint': 'Run the analysis to pre-fill the stock sheet.',
    'analyzingHint': 'Reading label and searching supplier…',
    'alreadyInStockPrefix': 'Already in stock ({{magasin}}) — save =',
    'alreadyInStockSuffix': '(shop {{boutique}} · warehouse {{depot}})',
    'alreadyInListPrefix': 'Already in the list (×{{qty}}) — accept =',
    'alreadyInListSuffix': 'to the list',
    'currentStockBoutique': '(current shop stock: {{qty}})',
    'resultTitle': 'Analysis result',
    'readConfidence': 'Reading confidence: {{pct}}%',
    'aiVision': 'AI vision',
    'matchLabel': 'match',
    'fieldDesignation': 'Designation *',
    'fieldReference': 'Reference *',
    'fieldCategorie': 'Category',
    'fieldFournisseur': 'Supplier',
    'otherSupplierParts': 'Other supplier parts',
    'tarifsTitle': 'Pricing',
    'fieldPrixAchat': 'Purchase price (€)',
    'autoSupplierCache': 'Auto supplier cache',
    'fieldPrixVente': 'Sale price (€)',
    'recalcVente': 'Recalculate sale',
    'laborLabel': 'Labor: {{amount}}',
    'detailTitle': 'Auto-Quote calculation detail',
    'detailAchat': 'Purchase:',
    'detailPort': 'Shipping:',
    'detailDouane': 'Customs:',
    'detailCoutPiece': 'Unit cost:',
    'detailFinal': 'Final:',
    'qtyLocationTitle': 'Quantity & location',
    'quantite': 'Quantity',
    'quit': 'Exit',
    'acceptPlusOne': 'Accept (+1)',
    'acceptLine': 'Accept the line',
    'acceptHelp': 'List or stock duplicate = automatic +1 · then "Save all" · labels at the end.',
    'reviewTitleAccept': 'Is this line correct?',
    'reviewTitleBulk': 'Check before saving',
    'reviewSubtitleAccept': 'Confirm to add to the list, then scan the next item',
    'reviewBulkSubtitle': '{{count}} item(s) to save to stock',
    'avoirs.title': 'Store credits',
    'avoirs.subtitle': 'Customer credit from a receipt or invoice — usable at the POS',
    'avoirs.refresh': 'Refresh',
    'avoirs.errorLoad': 'Error loading store credits',
    'avoirs.searchPlaceholder': 'Credit ref., customer, source receipt…',
    'avoirs.allStatuses': 'All statuses',
    'avoirs.empty': 'No store credit',
    'avoirs.colRef': 'Reference',
    'avoirs.colClient': 'Customer',
    'avoirs.colOrigin': 'Source',
    'avoirs.colInitial': 'Initial',
    'avoirs.colSolde': 'Balance',
    'avoirs.colStatut': 'Status',
    'avoirs.colDate': 'Date',
    'avoirs.createdBy': 'Created by',
    'avoirs.originLabel': 'Source:',
    'avoirs.motifLabel': 'Reason:',
    'avoirs.clientLabel': 'Customer:',
    'avoirs.printTicket': 'Print credit ticket',
    'avoirs.downloadPdf': 'Download PDF',
    'avoirs.historyTitle': 'Movement history',
    'avoirs.cancelRemaining': 'Cancel remaining balance',
    'avoirs.confirmCancel': 'Cancel the remaining balance of {{ref}}?',
    'avoirs.close': 'Close',
    'avoirs.statutDisponible': 'Available',
    'avoirs.statutPartiel': 'Partially used',
    'avoirs.statutUtilise': 'Used',
    'avoirs.statutAnnule': 'Cancelled',
    'stockMov.tab.dashboard': 'Dashboard',
    'stockMov.tab.movements': 'Movements',
    'stockMov.tab.imei': 'IMEI / Serials',
    'stockMov.tab.inventory': 'Inventory',
    'stockMov.header.title': 'Advanced stock',
    'stockMov.header.subtitle': 'Movements · IMEI · inventory sessions · dashboard',
    'stockMov.cancel': 'Cancel',
    'stockMov.save': 'Save',
    'stockMov.saving': 'Saving...',
    'stockMov.loadError': 'Loading error',
    'stockMov.error': 'Error: {{detail}}',
    'stockMov.loading': 'Loading…',
    'stockMov.pageOf': 'Page {{page}} / {{total}}',
    'stockMov.kpi.totalArticles': 'Total items',
    'stockMov.kpi.qteBoutique': 'Shop qty',
    'stockMov.kpi.qteDepot': 'Warehouse qty',
    'stockMov.kpi.ruptures': 'Stockouts',
    'stockMov.kpi.imeiEnStock': 'IMEI in stock',
    'stockMov.boutique': 'Shop',
    'stockMov.depot': 'Warehouse',
    'stockMov.total': 'Total',
    'stockMov.valeurAchat': 'Purchase value',
    'stockMov.valeurVente': 'Sale value',
    'stockMov.marge': 'Margin',
    'stockMov.margeTotale': 'Total margin',
    'stockMov.stocksNegatifs': 'Negative stock ({{count}})',
    'stockMov.aucunStockNegatif': 'No negative stock',
    'stockMov.articlesSousSeuil': 'Items below threshold ({{count}})',
    'stockMov.tousAuDessusSeuil': 'All items are above their alert threshold',
    'stockMov.filter.all': 'All',
    'stockMov.filter.entrees': 'Inflows',
    'stockMov.filter.sorties': 'Outflows',
    'stockMov.magasinLabel': 'Store:',
    'stockMov.nouveauMouvement': 'New movement',
    'stockMov.col.date': 'Date',
    'stockMov.col.type': 'Type',
    'stockMov.col.motif': 'Reason',
    'stockMov.col.article': 'Item',
    'stockMov.col.magasin': 'Store',
    'stockMov.col.qte': 'Qty',
    'stockMov.col.stockAvant': 'Stock before',
    'stockMov.col.stockApres': 'Stock after',
    'stockMov.col.imei': 'IMEI',
    'stockMov.col.par': 'By',
    'stockMov.aucunMouvement': 'No movement recorded',
    'stockMov.type.transfert': 'Transfer',
    'stockMov.type.entree': 'Inflow',
    'stockMov.type.sortie': 'Outflow',
    'stockMov.modalNewMovement': 'New stock movement',
    'stockMov.field.motif': 'Reason',
    'stockMov.field.article': 'Item',
    'stockMov.searchArticlePlaceholder': 'Search for an item...',
    'stockMov.refStock': '({{ref}}) Stock: {{qty}}',
    'stockMov.refShort': 'Ref: {{ref}}',
    'stockMov.field.quantite': 'Quantity',
    'stockMov.field.prixUnitaire': 'Unit price',
    'stockMov.field.imeiOptional': 'IMEI / Serial no. (optional)',
    'stockMov.imeiPlaceholder': 'e.g. 353012345678901',
    'stockMov.field.noteOptional': 'Note (optional)',
    'stockMov.commentPlaceholder': 'Comment...',
    'stockMov.imeiRefRequired': 'IMEI and reference required',
    'stockMov.refQtyRequired': 'Reference and quantity required',
    'stockMov.registreTitle': 'IMEI register — phone traceability',
    'stockMov.registreDesc': 'Each device in stock must have a unique IMEI. Lets you trace its history (purchase, POS sale, repair).',
    'stockMov.nouveauTelephone': 'New phone',
    'stockMov.searchImeiPlaceholder': 'Search IMEI, item...',
    'stockMov.tousLesStatuts': 'All statuses',
    'stockMov.enregistrerImei': 'Register IMEI',
    'stockMov.col.imeiSerie': 'IMEI / Serial no.',
    'stockMov.col.refDot': 'Ref.',
    'stockMov.col.magShort': 'Store',
    'stockMov.col.etat': 'Condition',
    'stockMov.col.statut': 'Status',
    'stockMov.col.origine': 'Origin',
    'stockMov.aucunImei': 'No IMEI — add a phone to stock, then register its number here.',
    'stockMov.historique': 'History',
    'stockMov.historiqueImei': 'History · {{imei}}',
    'stockMov.byUser': 'by {{user}}',
    'stockMov.aucunMouvementImei': 'No movement linked to this IMEI.',
    'stockMov.modalRegisterImei': 'Register an IMEI / serial no.',
    'stockMov.field.articleStockRef': 'Stock item (reference)',
    'stockMov.searchPlaceholder': 'Search...',
    'stockMov.field.etat': 'Condition',
    'stockMov.field.origine': 'Origin',
    'stockMov.origine.achat': 'Purchase',
    'stockMov.origine.reprise_client': 'Customer trade-in',
    'stockMov.origine.transfert': 'Transfer',
    'stockMov.etat.neuf': 'New',
    'stockMov.etat.occasion': 'Used',
    'stockMov.etat.reconditionne': 'Refurbished',
    'stockMov.etat.hs': 'Faulty',
    'stockMov.statut.en_stock': 'In stock',
    'stockMov.statut.vendu': 'Sold',
    'stockMov.statut.reserve': 'Reserved',
    'stockMov.statut.en_reparation': 'Under repair',
    'stockMov.motif.achat_fournisseur': 'Supplier purchase',
    'stockMov.motif.retour_client': 'Customer return',
    'stockMov.motif.correction_inventaire': 'Inventory correction',
    'stockMov.motif.transfert_entrant': 'Incoming transfer',
    'stockMov.motif.reception_commande': 'Order receipt',
    'stockMov.motif.reintegration_reparation': 'Repair reinstatement',
    'stockMov.motif.vente_pos': 'POS sale',
    'stockMov.motif.consommation_reparation': 'Repair consumption',
    'stockMov.motif.perte_casse': 'Loss / breakage',
    'stockMov.motif.retour_fournisseur': 'Supplier return',
    'stockMov.motif.transfert_sortant': 'Outgoing transfer',
    'stockMov.motif.ajustement_inventaire': 'Inventory adjustment',
    'stockMov.sessionsInventaire': 'Inventory sessions',
    'stockMov.nouvelInventaire': 'New inventory',
    'stockMov.aucuneSession': 'No inventory session',
    'stockMov.parUser': 'By {{user}}',
    'stockMov.articlesEcarts': '{{articles}} items, {{ecarts}} variances',
    'stockMov.status.enCours': 'In progress',
    'stockMov.status.valide': 'Validated',
    'stockMov.retourSessions': 'Back to sessions',
    'stockMov.statutColon': 'Status:',
    'stockMov.validePar': 'Validated by {{user}}',
    'stockMov.validerSansCorrection': 'Validate without correction',
    'stockMov.validerCorriger': 'Validate + correct stock',
    'stockMov.comptagePhysique': 'Physical count',
    'stockMov.searchArticleShort': 'Search item...',
    'stockMov.inv.bdShort': 'S:{{b}} W:{{d}}',
    'stockMov.stockSelectionne': 'Selected stock:',
    'stockMov.dotBoutique': '· shop {{q}}',
    'stockMov.dotDepot': '· warehouse {{q}}',
    'stockMov.qteComptee': 'Counted qty',
    'stockMov.col.stockTheorique': 'Theoretical stock',
    'stockMov.col.comptagePhysique': 'Physical count',
    'stockMov.col.ecart': 'Variance',
    'stockMov.col.comptePar': 'Counted by',
    'stockMov.aucunArticleCompte': 'No item counted. Start counting above.',
    'stockMov.modalNewSession': 'New inventory session',
    'stockMov.field.titreOptional': 'Title (optional)',
    'stockMov.titrePlaceholder': 'e.g. Monthly inventory March 2026',
    'stockMov.creating': 'Creating...',
    'stockMov.creer': 'Create',
    'stockMov.confirmValidateApply': 'Validate AND apply stock corrections?',
    'stockMov.confirmValidateNoApply': 'Validate WITHOUT applying corrections?',
    'stockMov.sessionValidee': 'Session validated!',
    'stockMov.countSaved': 'Count saved: Theoretical stock {{theorique}}, Physical {{physique}}, Variance {{ecart}}',
    'stock.err.templateDownload': 'Error while downloading the template',
    'stock.err.missingId': 'Error: item ID missing',
    'stock.deleteSuccess': 'Item deleted successfully',
    'stock.err.delete': 'Error during deletion',
    'stock.confirmDeleteMany': 'Delete {{count}} item(s)?',
    'stock.err.update': 'Error during update',
    'stock.err.transfer': 'Transfer error',
    'stock.err.bulkTransfer': 'Bulk transfer error',
    'stock.depotOnlyM1': 'The warehouse is only available on M1 for now.',
    'stock.sameSourceDest': 'The source and destination are identical.',
    'stock.noLineToTransfer': 'No line to transfer (zero quantities or source store = destination).',
    'stock.confirmBulkPublish': 'Put {{count}} item(s) on sale online?',
    'stock.confirmBulkUnpublish': 'Remove {{count}} item(s) from online sale?',
    'stock.confirmPublishOne': 'Put "{{name}}" on sale online?',
    'stock.confirmUnpublishOne': 'Remove "{{name}}" from online sale?',
    'stock.importDone': 'Import complete',
    'stock.importCreated': 'created',
    'stock.importUpdated': 'updated',
    'stock.importSkipped': 'skipped',
    'stock.importErrors': 'error(s)',
    'stock.importRetryHint': '{{count}} item(s) already existed — re-run in "Update" mode.',
    'stock.importRetryBtn': 'Re-run as update',
    'stock.importViewErrors': 'View the {{count}} error(s)',
    'stock.transferTitle': 'Stock transfer',
    'stock.boutique': 'Shop',
    'stock.depot': 'Warehouse',
    'stock.sourceStore': 'Source store',
    'stock.sourceLocation': 'Source location',
    'stock.destStore': 'Destination store',
    'stock.destLocation': 'Destination location',
    'stock.quantity': 'Quantity',
    'stock.availableAtSource': 'Available at source: {{count}}',
    'stock.cancel': 'Cancel',
    'stock.transferring': 'Transferring…',
    'stock.transfer': 'Transfer',
    'stock.bulkTransferTitle': 'Change the store for {{count}} item(s)',
    'stock.location': 'Location',
    'stock.bulkTransferR1Note': 'The transfer follows rule R1: the source document keeps a quantity of 0 if emptied, and a new document is created in the destination store.',
    'stock.colArticle': 'Item',
    'stock.colCurrentStore': 'Current store',
    'stock.colStock': 'Stock',
    'stock.colQtyToTransfer': 'Quantity to transfer',
    'stock.runTransfer': 'Start transfer',
    'stock.resultSucceeded': 'succeeded',
    'stock.resultFailed': 'failed',
    'stock.resultUnitsTransferred': 'units transferred',
    'stock.failuresLabel': 'Failures:',
    'stock.done': 'Done',
    'stock.storeN': 'Store {{n}}',
    'stock.tab.view': 'Overview',
    'stock.tab.inventory': 'Inventory',
    'stock.tab.analyze': 'Analyze product',
    'stock.tab.history': 'History',
    'stock.tab.supplierOrders': 'Supplier restock',
    'stock.tab.invoiceImport': 'AI invoice import',
    'stock.tab.labels': 'Labels',
    'stock.tab.advanced': 'Advanced stock',
    'stock.tab.reconciliation': 'Reconciliation',
    'stock.tab.config': 'Settings',
    'posV2.remisePlafonneeMsg': 'Discount capped at {{pct}}%. Beyond that, management approval is required.',
    'posV2.venteNonEnregRemiseRamenee': 'The sale was NOT recorded — the discount was brought back to the cap; check the total then collect again.',
    'posV2.remiseRameneeVerif': 'The discount was brought back to the cap — check the total then collect.',
    'posV2.catalogUnavailable': 'Catalog unavailable',
    'posV2.paymentRefusedTpe': 'Payment refused or cancelled on the card terminal — please try again.',
    'posV2.caisseClosedOpenFirst': 'Cash register {{mag}} is closed — open it before collecting',
    'posV2.sumupCheckoutDesc': 'POS V2 · {{count}} line(s)',
    'posV2.sumupTerminalNotConnected': 'SumUp terminal not connected',
    'posV2.sumupSaleNotSaved': '{{msg}}. The sale was NOT recorded (stock unchanged). Make sure the card terminal is on and connected.',
    'posV2.cartEmpty': 'Cart empty',
    'posV2.lookupValidAvoir': 'Look up a valid credit note before collecting',
    'posV2.printError': 'Print error',
    'posV2.caisseClosedBanner': 'Cash register {{mag}} closed.',
    'posV2.open': 'Open',
    'posV2.oneEncaissementMultiStock': '1 checkout {{mag}} · multi-store stock',
    'posV2.catalog': 'Catalog',
    'posV2.ficheButtonHint': '\'Details\' button → photo gallery',
    'posV2.all': 'All',
    'posV2.stockMag': 'Stock {{mag}}',
    'posV2.catalogPlaceholder': 'Catalog…',
    'posV2.go': 'Go',
    'posV2.catalogMeta': '{{total}} refs · {{scope}} · p.{{page}}/{{pages}}',
    'posV2.enterAvoirRefOrClient': 'Enter a credit note reference or a client name',
    'posV2.avoirNotFound': 'Credit note not found',
    'posV2.productSheet': 'Product sheet',
    'posV2.productSheetSub': 'Gallery · stock · add to cart',
    'posV2.ticketCenter': 'Receipt center',
    'posV2.ticketCenterSub': 'Recent receipts · reprint',
    'posV2.savStation': 'After-sales / repair desk',
    'posV2.savStationSub': 'Find case · collect balance · deposit · cart',
    'posV2.horsStock': 'Out of stock',
    'posV2.horsStockSub': 'Ad-hoc item sale · OUT OF STOCK badge · direct checkout',
    'posV2.clientCenter': 'Client center',
    'posV2.clientCenterSub': 'History · loyalty · attach to the sale',
    'posV2.orders': 'Orders',
    'posV2.ordersSub': 'Client request · order · deposit · cart',
    'openCaisse.denomBill': 'Banknote',
    'openCaisse.denomCoin': 'Coin',
    'openCaisse.cardTotal': 'Total',
    'openCaisse.successOpen': 'Register {{magasin}} opened successfully.',
    'openCaisse.errorOpen': 'Error while opening the register',
    'openCaisse.backToDashboard': 'Back to dashboard',
    'openCaisse.title': 'Opening register {{magasin}}',
    'openCaisse.titleForce': 'Force open register {{magasin}}',
    'openCaisse.openingFund': 'Opening float',
    'openCaisse.openingFundHint': 'Enter the banknotes and coins for register {{magasin}}.',
    'openCaisse.totalOpening': 'Opening total',
    'openCaisse.forceWarning': 'This action will close the target store\'s open register, then create a new register with this amount.',
    'openCaisse.cancel': 'Cancel',
    'openCaisse.opening': 'Opening...',
    'openCaisse.validateOpening': 'Confirm opening',
    'calcul.title': 'Price / quote calculation tool',
    'calcul.subtitle': 'Same interface as the PHP calculator + 80mm and A4 PDF generation.',
    'calcul.clientSection': 'Client information',
    'calcul.clientName': 'Client name',
    'calcul.phone': 'Phone',
    'calcul.email': 'Email',
    'calcul.saveClient': 'Save client',
    'calcul.deviceSection': 'Device selection',
    'calcul.brand': 'Brand',
    'calcul.model': 'Model',
    'calcul.itemsSection': 'Items',
    'calcul.itemDescription': 'Part / Description',
    'calcul.itemReference': 'Part ref.',
    'calcul.itemPurchasePrice': 'Purchase price',
    'calcul.addLine': 'Add a line',
    'calcul.paramsSection': 'Parameters',
    'calcul.quantity': 'Quantity',
    'calcul.labor': 'Labor (€)',
    'calcul.partReference': 'Part reference',
    'calcul.supplier': 'Supplier',
    'calcul.docType': 'Document type',
    'calcul.docTypeDevis': 'QUOTE',
    'calcul.docTypeFacture': 'INVOICE',
    'calcul.docTypeProforma': 'PROFORMA',
    'calcul.acceptOnlinePayment': 'Accept online payment (SumUp)',
    'calcul.acceptOnlinePaymentHint': 'The client will be able to request a SumUp payment link',
    'calcul.saveTicket': '✅ Save ticket',
    'calcul.saving': 'Saving...',
    'calcul.preview': '👁️ Preview',
    'calcul.previewSection': 'Preview',
    'calcul.previewIframeTitle': 'Ticket preview',
    'calcul.previewEmpty': 'Run a calculation to display the ticket.',
    'calcul.printTicket': 'Print ticket',
    'calcul.transformA4': 'Convert to A4 quote',
    'calcul.totalArticles': 'Items total',
    'calcul.totalPurchase': 'Purchase total',
    'calcul.shippingFees': 'Shipping fees',
    'calcul.customsFees': 'Customs fees',
    'calcul.costPerPiece': 'Cost per unit',
    'calcul.finalPrice': 'Final price',
    'calcul.alertAllowPopups': 'Please allow pop-ups to print.',
    'calcul.alertAddItem': 'Add at least one item with a purchase price.',
    'calcul.ticketSaved': '✅ Ticket saved.',
    'calcul.errorGenerateTicket': 'Error generating the ticket',
    'calcul.errorPrintTicket': 'Ticket printing error',
    'calcul.errorGenerateA4': 'Error generating the A4 quote',
    'caisseHist.errPrint': 'Cash register printing error',
    'caisseHist.errPrintGeneric': 'Printing error',
    'caisseHist.errLoadMonthly': 'Error loading monthly history',
    'caisseHist.errExport': 'Accounting export error',
    'caisseHist.confirmForceClose': 'Force close the cash register for {{date}}? This action is irreversible.',
    'caisseHist.errForceClose': 'Error during force close',
    'caisseHist.title': 'Cash register opening / closing history',
    'caisseHist.month': 'Month',
    'caisseHist.store': 'Store',
    'caisseHist.allStores': 'All stores',
    'caisseHist.exportAccounting': 'Accounting export',
    'caisseHist.totalSales': 'Total sales',
    'caisseHist.totalCash': 'Total cash',
    'caisseHist.totalCard': 'Total card',
    'caisseHist.withdrawals': 'Withdrawals',
    'caisseHist.totalTheoretical': 'Theoretical total',
    'caisseHist.totalAccounting': 'Accounting total',
    'caisseHist.discrepancy': 'Discrepancy',
    'caisseHist.validatedBy': 'Validated by',
    'caisseHist.validationDate': 'Validation date',
    'caisseHist.noValidatedCaisse': 'No validated cash register.',
    'caisseHist.opening': 'Opening',
    'caisseHist.closing': 'Closing',
    'caisseHist.caisse': 'Cash register',
    'caisseHist.daySales': 'Daily sales',
    'caisseHist.dateStart': 'Start date',
    'caisseHist.dateEnd': 'End date',
    'caisseHist.reset': 'Reset',
    'caisseHist.cashFloat': 'Cash float',
    'caisseHist.openedBy': 'Opened by',
    'caisseHist.closedBy': 'Closed by',
    'caisseHist.noHistory': 'No history available',
    'caisseHist.closingProgress': 'Closing...',
    'caisseHist.forceClose': 'Force close',
    'caisseHist.forced': 'Forced',
    'caisseHist.showMore': 'Show more ({{count}} previous openings)',
    'caisseHist.showLess': 'Show less',
    'repairDetail.popupBlocked': 'Please allow pop-ups to print.',
    'repairDetail.downloadError': 'Download error',
    'repairDetail.statusUpdateError': 'Update error',
    'repairDetail.invalidAmount': 'Invalid amount',
    'repairDetail.genericError': 'Error',
    'repairDetail.filesAttached': '{{count}} file(s) attached',
    'repairDetail.uploadProgress': 'Uploading {{current}}/{{total}}…',
    'repairDetail.addNoteError': 'Error while adding the note',
    'repairDetail.confirmDeleteNote': 'Delete this note?',
    'repairDetail.notFound': 'Repair not found',
    'repairDetail.backToRepairs': 'Back to repairs',
    'repairDetail.photosTitle': 'Photos ({{count}})',
    'repairDetail.photoAlt': 'Photo {{index}}',
    'repairDetail.notesTitle': 'Notes ({{count}})',
    'repairDetail.notePlaceholder': 'Add a note...',
    'repairDetail.visibilityPublic': 'Public',
    'repairDetail.visibilityInternal': 'Internal',
    'repairDetail.filesBtn': 'Files',
    'repairDetail.sending': 'Sending...',
    'repairDetail.add': 'Add',
    'repairDetail.noNotes': 'No notes',
    'repairDetail.staffDefault': 'Staff',
    'repairDetail.printAcompteError': 'Error printing deposit receipt',
    'repairDetail.printAvoirError': 'Error printing credit-note receipt',
    'repairDetail.downloadPdfError': 'PDF download error',
    'repairDetail.changeStatus': 'Change status',
    'repairDetail.noStatusChange': 'No change allowed',
    'repairDetail.addDeposit': 'Add a deposit',
    'repairDetail.amountLabel': 'Amount (€)',
    'repairDetail.paymentMode': 'Payment method',
    'repairDetail.paymentCash': 'Cash',
    'repairDetail.paymentCard': 'Card',
    'repairDetail.paymentTransfer': 'Transfer',
    'repairDetail.paymentCheck': 'Cheque',
    'repairDetail.cancel': 'Cancel',
    'repairDetail.statusRecu': 'Received',
    'repairDetail.statusEnCours': 'In progress',
    'repairDetail.statusAttentePieces': 'Awaiting parts',
    'repairDetail.statusPieceArrivee': 'Part arrived',
    'repairDetail.statusNonReparable': 'Not repairable',
    'repairDetail.statusTermine': 'Completed',
    'repairDetail.statusLivre': 'Delivered',
    'repairDetail.statusAttenteDepot': 'Awaiting drop-off',
    'closeCaisse.denomBillet': 'Note',
    'closeCaisse.denomPiece': 'Coin',
    'closeCaisse.countBadge': '× {{count}}',
    'closeCaisse.total': 'Total',
    'closeCaisse.errLoad': 'Error while loading the register',
    'closeCaisse.errPdf': 'Error while generating the PDF',
    'closeCaisse.errConfirmCb': 'Please confirm the card payments before closing the register',
    'closeCaisse.confirmEcart': 'Warning: a discrepancy of {{ecart}} was detected.\n\nTheoretical total: {{theorique}}\nCounted total: {{compte}}\n\nDo you want to continue?',
    'closeCaisse.closeSuccess': 'Register {{magasin}} closed successfully.',
    'closeCaisse.errClose': 'Error while closing the register',
    'closeCaisse.backToDashboard': 'Back to dashboard',
    'closeCaisse.journee': 'Day {{date}}',
    'closeCaisse.openedBy': 'opened by {{name}}',
    'closeCaisse.refresh': 'Refresh',
    'closeCaisse.summaryTitle': 'Register summary',
    'closeCaisse.activitySummary': '{{magasin}} store activity — {{ops}} operation(s) ({{pos}} POS sales, {{acomptes}} deposits).',
    'closeCaisse.fondOuverture': 'Opening float',
    'closeCaisse.ventesEspeces': 'Cash sales',
    'closeCaisse.ventesCb': 'Card sales',
    'closeCaisse.paiementsStripe': 'Stripe payments',
    'closeCaisse.acomptes': 'Deposits',
    'closeCaisse.retraits': 'Withdrawals',
    'closeCaisse.totalTheorique': 'Theoretical total',
    'closeCaisse.totalVentes': 'Total sales: {{montant}}',
    'closeCaisse.activiteVendeur': 'Activity by seller',
    'closeCaisse.colVendeur': 'Seller',
    'closeCaisse.colOps': 'Ops',
    'closeCaisse.colEspeces': 'Cash',
    'closeCaisse.colCb': 'Card',
    'closeCaisse.comptageEspeces': 'Cash count',
    'closeCaisse.comptageSubtitle': 'Notes and coins with a visual breakdown for the closing.',
    'closeCaisse.totalCompte': 'Counted total',
    'closeCaisse.ecart': 'Discrepancy',
    'closeCaisse.ecartImportant': 'Significant discrepancy detected',
    'closeCaisse.infosComplementaires': 'Additional information',
    'closeCaisse.montantCoffreLabel': 'Amount deposited in the safe (EUR)',
    'closeCaisse.montantCoffreHint': 'Cash amount deposited in the safe.',
    'closeCaisse.cbConfirmLabel': 'I have confirmed the card payments',
    'closeCaisse.cbConfirmHint': 'Check that all card payments have been collected on the terminal.',
    'closeCaisse.imprimerRapport': 'Print the report',
    'closeCaisse.validerCaisse': 'Validate the register',
    'closeCaisse.onlyAdmin': 'Only an administrator can validate the register closing',
    'paiements.title': 'Online payments',
    'paiements.proofsToValidate': '{{count}} proof(s) to validate',
    'paiements.pendingCount': '{{count}} pending',
    'paiements.tabSumup': 'SumUp payments ({{count}})',
    'paiements.tabProofs': 'Payment proofs ({{count}})',
    'paiements.noProof': 'No payment proof',
    'paiements.orderDefault': 'Order',
    'paiements.proofValidated': 'Validated',
    'paiements.proofPendingValidation': 'Pending validation',
    'paiements.totalLabel': 'Total: ',
    'paiements.sentLabel': 'Sent: ',
    'paiements.byLabel': 'By: ',
    'paiements.validatedByLabel': 'Validated by: ',
    'paiements.viewCapture': 'View screenshot',
    'paiements.validatePayment': 'Validate payment',
    'paiements.reject': 'Reject',
    'paiements.confirmOrder': 'Confirm order',
    'paiements.filterAll': 'All',
    'paiements.filterPending': 'Pending',
    'paiements.filterConfirmed': 'Confirmed',
    'paiements.filterCancelled': 'Cancelled',
    'paiements.noPayment': 'No payment',
    'paiements.amountLabel': 'Amount: ',
    'paiements.refLabel': 'Ref: ',
    'paiements.dateLabel': 'Date: ',
    'paiements.ticketPdf': 'PDF receipt',
    'paiements.validate': 'Validate',
    'paiements.cancel': 'Cancel',
    'paiements.statusPaidApplied': 'Confirmed',
    'paiements.statusPaidPending': 'Pending',
    'paiements.statusPending': 'In progress',
    'paiements.statusCancelled': 'Cancelled',
    'paiements.orderRepair': 'Repair {{ref}}',
    'paiements.orderBoutique': 'Shop order',
    'paiements.alertConfirmed': 'Payment confirmed and applied!',
    'paiements.errorConfirm': 'Error during confirmation',
    'paiements.confirmCancel': 'Cancel this payment?',
    'paiements.error': 'Error',
    'paiements.errorTicket': 'Error downloading the receipt',
    'paiements.confirmValidateProof': 'Validate this payment proof?',
    'paiements.alertProofValidated': 'Payment validated!',
    'paiements.confirmRejectProof': 'Reject this payment proof?',
    'paiements.confirmConfirmOrder': 'Confirm this order?',
    'paiements.alertOrderConfirmed': 'Order confirmed!',
    'repairForm.deviceNotFound': 'Device not found',
    'repairForm.selectMagasinFirst': 'First choose the store handling this repair.',
    'repairForm.saveError': 'Error while saving',
    'repairForm.conversionFromCommande': 'Conversion from order',
    'repairForm.prefillNotice': 'Prefilled information · deposits ({{amount}}) transferred upon finalization.',
    'repairForm.sectionMagasin': 'Store',
    'repairForm.magasinLabel': 'Handling store *',
    'repairForm.selectMagasinOption': '— Select a store —',
    'repairForm.sectionForcedEntry': 'Forced entry',
    'repairForm.forcedEntryHint': 'For a forgotten drop-off: record the repair with the actual drop-off date (not today\'s date).',
    'repairForm.useBackdateLabel': 'Use an earlier drop-off date',
    'repairForm.realDepotDateTime': 'Actual drop-off date and time',
    'repairForm.sectionClient': 'Customer',
    'repairForm.clientName': 'Customer name *',
    'repairForm.phone': 'Phone *',
    'repairForm.email': 'Email',
    'repairForm.address': 'Address',
    'repairForm.sectionDevice': 'Device',
    'repairForm.brand': 'Brand *',
    'repairForm.model': 'Model *',
    'repairForm.problem': 'Problem',
    'repairForm.technician': 'Technician',
    'repairForm.selectOption': '— Select —',
    'repairForm.imeiSerial': 'IMEI / Serial No.',
    'repairForm.deviceLock': 'Lock code',
    'repairForm.sectionParts': 'Parts',
    'repairForm.defectivePartsHint': 'Non-working parts at intake',
    'repairForm.phoneDoesntTurnOn': 'Phone won\'t turn on',
    'repairForm.sectionStockParts': 'Stock parts (optional)',
    'repairForm.stockPartsHint': 'If the part is in the store\'s stock, it will be deducted on creation and the repair price recalculated from catalog prices. Otherwise, enter a manual price below (theoretical quote).',
    'repairForm.stockPartsTotal': 'Stock parts total: {{amount}} — applied on creation if available.',
    'repairForm.sectionPricing': 'Pricing',
    'repairForm.priceRepair': 'Repair price (€)',
    'repairForm.theoreticalQuote': '— theoretical quote',
    'repairForm.priceDiagnostic': 'Diagnostic price (€)',
    'repairForm.receptionNotes': 'Intake notes',
    'repairForm.sectionPhotos': 'Photos',
    'repairForm.addPhoto': 'Add',
    'repairForm.cancel': 'Cancel',
    'repairForm.save': 'Save',
    'repairForm.createRepair': 'Create repair',
    'repairForm.parts.speaker': 'Loudspeaker',
    'repairForm.parts.lcd': 'Screen',
    'repairForm.parts.front_cam': 'Front camera',
    'repairForm.parts.back_cam': 'Rear camera',
    'repairForm.parts.microphone': 'Microphone',
    'repairForm.parts.fingerprint': 'Fingerprint',
    'repairForm.parts.home_button': 'Home button',
    'repairForm.parts.volume_button': 'Volume',
    'repairForm.parts.power_button': 'Power',
    'repairForm.parts.signal_carrier': 'Signal',
    'repairForm.parts.battery': 'Battery',
    'repairForm.parts.wifi_bt': 'Wi-Fi/Bluetooth',
    'repairForm.parts.ear_speaker': 'Earpiece',
    'repairForm.parts.charging_port': 'Charging port',
    'labels.barcodeAuto': 'EAN13 will be auto-generated',
    'labels.allowPopups': 'Please allow pop-ups to print.',
    'labels.selectAtLeastOne': 'Select at least one product',
    'labels.errorGenerate': 'Error generating labels',
    'labels.infoNoEan': 'Info: {{count}} item(s) without EAN — internal EAN13 auto-generated. Total: {{total}} label(s).',
    'labels.jobCreated': 'Print job created ({{count}} labels).\nID: {{id}}...\nThe Bixolon agent will pick up this batch.',
    'labels.jobNoEan': '\nNote: {{count}} without EAN (auto-generated).',
    'labels.errorBatch': 'Batch printing error',
    'labels.generating': 'Generating...',
    'labels.generatePdf': 'Generate PDF ({{count}})',
    'labels.previewPdf': 'PDF preview ({{count}})',
    'labels.printBixolon': 'Print Bixolon ({{count}})',
    'labels.clear': 'Clear',
    'labels.format': 'Format',
    'labels.formatBixolon': 'Bixolon 50 × 30 mm (thermal)',
    'labels.formatA4': 'A4 sheet (legacy)',
    'labels.pageTitle': 'Product labels',
    'labels.pageSubtitle': 'Configurable product labels',
    'labels.config': 'Config',
    'labels.searchPlaceholder': 'Search for a product...',
    'labels.boutique': 'Shop',
    'labels.depot': 'Warehouse',
    'labels.deselectAll': 'Deselect all',
    'labels.colProduct': 'Product',
    'labels.colPrice': 'Price',
    'labels.colBoutiqueShort': 'Shop',
    'labels.colQtyToPrint': 'Qty to print',
    'labels.noProduct': 'No product',
    'labels.autoShort': 'auto',
    'labels.previewTitle': 'Label preview',
    'labels.refLabel': 'Ref:',
    'labels.selectedProducts': 'Selected products',
    'labels.totalLabels': 'Total labels',
    'labels.autoGenAtPdf': 'Auto-generated in the PDF',
    'labels.selectToPreview': 'Select a product to preview',
    'labels.batchVeryLarge': 'Very large batch',
    'labels.batchConfirmTitle': 'Confirm large batch',
    'labels.confirmBodyPrefix': 'You are about to generate',
    'labels.confirmBodySuffix': 'labels.',
    'labels.estRoll': '≈ {{meters}} m of roll (50×30mm)',
    'labels.estTime': '≈ {{minutes}} min of printing (~1.5 s/label)',
    'labels.cancel': 'Cancel',
    'labels.confirmAnyway': 'Confirm anyway',
    'labels.continue': 'Continue',
    'rep.status.awaitingDeposit': 'Awaiting drop-off',
    'rep.status.received': 'Received',
    'rep.status.inProgress': 'In progress',
    'rep.status.awaitingParts': 'Awaiting parts',
    'rep.status.completed': 'Completed',
    'rep.status.notRepairable': 'Not repairable',
    'rep.status.delivered': 'Delivered',
    'rep.status.refused': 'Refused',
    'rep.payCash': 'Cash',
    'rep.payCard': 'Card',
    'rep.payTransfer': 'Transfer',
    'rep.payCheck': 'Cheque',
    'rep.accept': 'Accept',
    'rep.addError': 'Error while adding',
    'rep.adminOnlyStatus': 'Only an administrator can change this status.',
    'rep.allowPopups': 'Please allow pop-ups to print.',
    'rep.chatTitle': 'Repair chat {{ref}}',
    'rep.confirmArrivalAsk': 'Confirm receipt of device {{ref}} in store?',
    'rep.confirmArrivalDone': 'Device confirmed! The repair is now active.',
    'rep.confirmArrivalError': 'Error during confirmation',
    'rep.created': 'Created',
    'rep.currentStatus': 'Current status:',
    'rep.deleteError': 'Error while deleting',
    'rep.deleteRecordAsk': 'Delete this record?',
    'rep.deleteStatusAsk': 'Delete the status "{{name}}"?',
    'rep.depositAmountEuro': 'Deposit amount (€)',
    'rep.diagnosticPaid': 'Diagnosis paid',
    'rep.diagnosticRemaining': 'Diagnosis: {{amount}} remaining',
    'rep.downloadError': 'Error during download',
    'rep.error': 'Error',
    'rep.invalidAmount': 'Invalid amount',
    'rep.newStatus': 'New status',
    'rep.noDeposits': 'No deposit paid',
    'rep.noOnlineRequests': 'No pending online requests',
    'rep.onlineRequests': 'Online requests ({{count}})',
    'rep.or': 'or',
    'rep.pointAtTicketQr': 'Point at the QR code on the ticket',
    'rep.printAcompteError': 'Error printing deposit ticket',
    'rep.qrPrintHint': 'Scan to track your repair',
    'rep.qrSearchPlaceholder': 'e.g. REM0094',
    'rep.qrTrackingHint': 'The customer scans this QR code to track their repair in real time',
    'rep.qrTrackingTitle': 'Tracking QR code',
    'rep.reference': 'Reference:',
    'rep.repair': 'Repair',
    'rep.scanOrEnterRef': 'Scan a QR code or enter the reference',
    'rep.scanWithCamera': 'Scan with the camera',
    'rep.searchRepair': 'Search for a repair',
    'rep.statusManagement': 'Status management',
    'rep.ticket': 'Ticket',
    'rep.updateError': 'Error during update',
    'rep.bulkNoteSentSingular': 'Note sent to {{count}} file{{skip}}.',
    'rep.bulkNoteSentPlural': 'Note sent to {{count}} files{{skip}}.',
    'rep.bulkNoteSkippedSingular': '({{count}} skipped)',
    'rep.bulkNoteSkippedPlural': '({{count}} skipped)',
    'devisDepl.title': 'On-Site Quotes',
    'devisDepl.subtitle': 'Manage quotes for at-home repairs',
    'devisDepl.newDevis': 'New quote',
    'devisDepl.exportCsv': 'Export CSV',
    'devisDepl.remindBtn': 'Follow up ({{count}})',
    'devisDepl.sending': 'Sending...',
    'devisDepl.send': 'Send',
    'devisDepl.cancel': 'Cancel',
    'devisDepl.errGeneric': 'Error',
    'devisDepl.confirmSendReminders': 'Send a reminder to {{count}} client(s) with quotes pending for more than 3 days?',
    'devisDepl.remindersSent': '{{count}} reminder(s) sent!',
    'devisDepl.sentByEmail': 'Quote sent by email!',
    'devisDepl.errSend': 'Sending error',
    'devisDepl.confirmDelete': 'Delete this quote?',
    'devisDepl.searchPlaceholder': 'Search by ref, name, email...',
    'devisDepl.noResults': 'No results',
    'devisDepl.empty': 'No quotes created',
    'devisDepl.travelFeeLabel': 'Travel fee',
    'devisDepl.invalidAmount': 'Invalid amount',
    'devisDepl.errPayment': 'Payment error',
    'devisDepl.confirmStaffAccept': 'Validate this quote? A purchase order and an invoice will be created.',
    'devisDepl.errValidation': 'Validation error',
    'devisDepl.reminderSent': 'Reminder sent',
    'devisDepl.errSendReminder': 'Error sending reminder',
    'devisDepl.confirmValidateBon': 'Validate the purchase order?',
    'devisDepl.errSendFacture': 'Error sending invoice',
    'devisDepl.confirmDetach': 'Detach this quote from repair {{ref}}?',
    'devisDepl.status.pending': 'Pending',
    'devisDepl.status.accepted': 'Accepted',
    'devisDepl.status.refused': 'Refused',
    'devisDepl.status.depositPaid': 'Deposit paid',
    'devisDepl.status.paid': 'Paid',
    'devisDepl.stats.total': 'Total',
    'devisDepl.stats.pending': 'Pending',
    'devisDepl.stats.accepted': 'Accepted',
    'devisDepl.stats.refused': 'Refused',
    'devisDepl.stats.revenue': 'Revenue',
    'devisDepl.filter.all': 'All statuses',
    'devisDepl.requests.title': 'Incoming quote requests',
    'devisDepl.requests.newCountSingular': '{{count}} new',
    'devisDepl.requests.newCountPlural': '{{count}} new',
    'devisDepl.requests.defaultTitle': 'Quote request',
    'devisDepl.requests.statusNew': 'New',
    'devisDepl.requests.statusInProgress': 'In progress',
    'devisDepl.requests.statusRefused': 'Refused',
    'devisDepl.requests.statusTreated': 'Handled',
    'devisDepl.requests.client': 'Client',
    'devisDepl.requests.addressLabel': 'Address',
    'devisDepl.requests.createDevis': 'Create quote',
    'devisDepl.requests.markTreated': 'Handled',
    'devisDepl.requests.refuse': 'Refuse',
    'devisDepl.requests.refuseMotifLabel': 'Reason for refusal',
    'devisDepl.requests.refuseMotifPlaceholder': 'Reason for refusal (optional)...',
    'devisDepl.requests.confirmRefuse': 'Confirm refusal',
    'devisDepl.requests.refuseMotifShownLabel': 'Reason for refusal:',
    'devisDepl.sumup.title': 'SumUp link requests',
    'devisDepl.sumup.pendingCount': '{{count}} pending',
    'devisDepl.sumup.enterLinkAlert': 'Please enter the SumUp link',
    'devisDepl.sumup.linkSentAlert': 'SumUp link sent to the client by email!',
    'devisDepl.sumup.linkPlaceholder': 'Paste the SumUp link here...',
    'devisDepl.chart.title': 'Activity over the last 30 days',
    'devisDepl.chart.accepted': 'Accepted',
    'devisDepl.chart.pending': 'Pending',
    'devisDepl.chart.refused': 'Refused',
    'devisDepl.chart.noData': 'No data for this period',
    'devisDepl.form.editTitle': 'Edit quote',
    'devisDepl.form.newTitle': 'New quote',
    'devisDepl.form.clientName': 'Client name *',
    'devisDepl.form.searchPlaceholder': 'Type to search...',
    'devisDepl.form.phone': 'Phone',
    'devisDepl.form.email': 'Email *',
    'devisDepl.form.emailPlaceholder': 'email@example.com',
    'devisDepl.form.address': 'Address',
    'devisDepl.form.addressPlaceholder': 'Client address',
    'devisDepl.form.descriptionLabel': 'Repair description',
    'devisDepl.form.descriptionPlaceholder': 'Description of the work to be done...',
    'devisDepl.form.lines': 'Quote lines',
    'devisDepl.form.addLine': 'Add',
    'devisDepl.form.designation': 'Description',
    'devisDepl.form.price': 'Price',
    'devisDepl.form.travelFee': 'Travel fee ({{amount}})',
    'devisDepl.form.acceptOnline': 'Accept online payment (SumUp)',
    'devisDepl.form.acceptOnlineHint': 'The client will be able to request a SumUp payment link',
    'devisDepl.form.total': 'TOTAL',
    'devisDepl.form.submitEdit': 'Update',
    'devisDepl.form.submitCreate': 'Create quote',
    'devisDepl.form.nameEmailRequired': 'Client name and email are required',
    'devisDepl.form.atLeastOneLine': 'Add at least one line with a description and price',
    'devisDepl.detail.phone': 'Phone:',
    'devisDepl.detail.address': 'Address:',
    'devisDepl.detail.purchaseOrder': 'Purchase order:',
    'devisDepl.detail.invoice': 'Invoice:',
    'devisDepl.detail.emailSentOn': 'Email sent on {{date}}',
    'devisDepl.detail.reminderSentOn': 'Reminder sent on {{date}}',
    'devisDepl.table.designation': 'Description',
    'devisDepl.table.qty': 'Qty',
    'devisDepl.table.price': 'Price',
    'devisDepl.table.total': 'Total',
    'devisDepl.actions.validateDevis': 'Validate quote',
    'devisDepl.actions.sendByEmail': 'Send quote by email',
    'devisDepl.actions.remindAcceptance': 'Follow up on acceptance',
    'devisDepl.actions.edit': 'Edit',
    'devisDepl.actions.validateBon': 'Validate purchase order',
    'devisDepl.actions.bonValidated': 'Order validated',
    'devisDepl.actions.remindPayment': 'Follow up on payment',
    'devisDepl.actions.pdfDevis': 'Quote PDF',
    'devisDepl.actions.pdfBon': 'Purchase order PDF',
    'devisDepl.actions.pdfFacture': 'Invoice PDF',
    'devisDepl.actions.sendFactureEmail': 'Send invoice by email',
    'devisDepl.actions.registerPayment': 'Record payment',
    'devisDepl.actions.delete': 'Delete',
    'devisDepl.actions.linkedTo': 'Linked to {{ref}}',
    'devisDepl.actions.attachToRepair': 'Attach to repair',
    'devisDepl.payment.title': 'Record a payment',
    'devisDepl.payment.devisLabel': 'Quote:',
    'devisDepl.payment.totalLabel': 'Total:',
    'devisDepl.payment.methodLabel': 'Payment method',
    'devisDepl.payment.cash': 'Cash',
    'devisDepl.payment.card': 'Card',
    'devisDepl.payment.transfer': 'Transfer',
    'devisDepl.payment.mixed': 'Mixed',
    'devisDepl.payment.amount': 'Amount',
    'devisDepl.payment.noteLabel': 'Note (optional)',
    'devisDepl.payment.notePlaceholder': 'E.g. deposit, balance...',
    'devisDepl.payment.submit': 'Confirm payment',
    'reviews.ratingFallback': 'Our customers review us on Google',
    'reviews.subtitle': 'Read what our customers say on Google, and share your experience.',
    'reviews.readCta': 'Read our Google reviews',
    'reviews.writeCta': 'Leave a review',
    'acompteStart.title': 'Deposit for your quote',
    'acompteStart.subtitle': 'Resurrection Mobile · secure SumUp payment',
    'acompteStart.loading': 'Preparing payment…',
    'acompteStart.redirecting': 'Redirecting to the payment page',
    'acompteStart.clickHere': 'Click here if nothing happens.',
    'acompteStart.paid': 'This deposit has already been paid. Thank you! Your order is being prepared.',
    'acompteStart.orderRef': 'Order {{ref}}',
    'acompteStart.errTitle': 'Online payment temporarily unavailable',
    'acompteStart.retry': 'Try again',
    'acompteStart.whatsappPay': 'Pay via WhatsApp / contact us',
    'acompteStart.inStore': 'The deposit can also be paid directly in store.',
    'acompteStart.footer': 'After payment, your parts order is recorded automatically and a receipt is sent to you by e-mail.',
    'acompteStart.backToSite': 'Back to the site',
    'acompteStart.errLinkUnavailable': 'Payment link unavailable.',
    'acompteStart.errOnlineUnavailable': 'Online payment is temporarily unavailable.',
    'acompteStart.waMessage': 'Hello, I would like to pay the deposit for my quote ({{id}}).',
    'emailVerif.loadingTitle': 'Verifying...',
    'emailVerif.loadingSub': 'Please wait',
    'emailVerif.successTitle': 'Account activated!',
    'emailVerif.successDefault': 'Email verified successfully!',
    'emailVerif.login': 'Log in',
    'emailVerif.errorTitle': 'Verification error',
    'emailVerif.errorDefault': 'Verification error',
    'emailVerif.invalidLink': 'Invalid verification link.',
    'emailVerif.backLogin': 'Back to login',
    'emailVerif.expiredTitle': 'Link expired',
    'emailVerif.expiredDefault': 'This link has expired.',
    'emailVerif.backLoginResend': 'Back to login (resend email)',
    'paySuccess.noPaymentToVerify': 'No payment to verify',
    'paySuccess.statusCheckFailed': 'Unable to verify the status. The payment will be processed automatically.',
    'paySuccess.verificationError': 'Error while verifying the payment',
    'paySuccess.completedTitle': 'Payment successful!',
    'paySuccess.completedDesc': 'Your payment has been confirmed and applied to your file.',
    'paySuccess.failedTitle': 'Payment failed',
    'paySuccess.failedDesc': 'The payment could not be processed. Please try again.',
    'paySuccess.pendingTitle': 'Payment being processed',
    'paySuccess.pendingDesc': 'Your payment is being verified. It will be applied automatically.',
    'paySuccess.verifying': 'Verifying payment...',
    'paySuccess.errorTitle': 'Error',
    'paySuccess.amountLabel': 'Amount:',
    'paySuccess.repairLabel': 'Repair:',
    'paySuccess.orderLabel': 'Order:',
    'paySuccess.referenceLabel': 'Reference:',
    'paySuccess.noInfo': 'No payment information available.',
    'paySuccess.backToSpace': 'Back to my space',
    'devisChat.errStart': 'Unable to start the chat. Please try again.',
    'devisChat.errSend': 'Send failed',
    'devisChat.errNetwork': 'Network error',
    'devisChat.hint': 'Request your quote by email',
    'devisChat.fabAria': 'Request a quote',
    'devisChat.fabLabel': 'Free quote',
    'devisChat.panelTitle': 'R.E.Mobiles Quote',
    'devisChat.panelSubtitle': 'Sent by email after approval',
    'devisChat.close': 'Close',
    'devisChat.connecting': 'Connecting…',
    'devisChat.inputPlaceholder': 'e.g. iPhone 13 screen…',
    'register.emailRequired': 'Email is required to create an account.',
    'register.passwordMinLength': 'The password must contain at least 4 characters.',
    'register.passwordMismatch': 'The passwords do not match.',
    'register.registerError': 'Error during registration',
    'register.verifyEmailTitle': 'Check your email!',
    'register.confirmationSentTo': 'A confirmation email has been sent to:',
    'register.activateHint': 'Click the link in the email to activate your account. Also check your spam if you don\'t see it.',
    'register.goToLogin': 'Go to login',
    'register.clientSubtitle': 'Access the tracking of your repairs',
    'register.namePlaceholder': 'John Smith',
    'register.emailPlaceholder': 'email@example.com',
    'register.emailHint': 'A confirmation email will be sent to activate your account',
    'register.addressPlaceholder': '123 Example Street',
    'register.password': 'Password',
    'register.confirmPassword': 'Confirm password',
    'register.referralCode': 'Referral code (optional)',
    'register.referredBy': 'Referred by {{nom}}',
    'register.invalidReferral': 'Invalid referral code',
    'register.termsNotice': 'By creating an account, you accept our terms of use',
    'login.googleDisabled': 'Google sign-in has been disabled. Use your username and password.',
    'login.invalid2FA': 'Invalid 2FA code',
    'login.tabStaff': 'Staff',
    'login.tabClient': 'Client',
    'login.tabBusiness': 'Business',
    'login.frenchGuiana': 'French Guiana',
    'login.emailNotVerifiedTitle': 'Email not verified',
    'login.emailNotVerifiedDesc': 'You must confirm your email before signing in.',
    'login.emailResent': 'Email resent! Check your inbox.',
    'login.sending': 'Sending...',
    'login.resendVerification': 'Resend confirmation email',
    'login.back': 'Back',
    'login.twoFATitle': '2FA verification',
    'login.twoFASubtitle': 'Enter the code from your app',
    'login.verifying': 'Verifying...',
    'login.verify': 'Verify',
    'login.passwordPlaceholder': 'Your password',
    'login.allRightsReserved': 'All rights reserved.',
    'acompteSuccess.errorIncompleteLink': 'Incomplete payment link.',
    'acompteSuccess.errorCannotConfirm': 'Unable to confirm the payment at the moment.',
    'acompteSuccess.whatsappMessage': 'Hello, I have paid the deposit for my quote (ref. {{ref}}). Can you confirm my order?',
    'acompteSuccess.whatsappDefault': 'Message us on WhatsApp',
    'acompteSuccess.errorHint': 'If your payment was actually charged, your order will be recorded automatically within the next few minutes and you will receive a confirmation email.',
    'acompteSuccess.appliedTitle': 'Deposit received',
    'acompteSuccess.orderRegisteredLead': 'Thank you. Your part order',
    'acompteSuccess.orderRegisteredTail': 'is registered. A receipt has been sent to you by email; you will receive the tracking number as soon as it ships.',
    'acompteSuccess.staffPendingTitle': 'Payment received',
    'acompteSuccess.staffPendingBody': 'Your deposit has been properly recorded with SumUp. Our team is finalizing your order manually and will confirm it by email very soon.',
    'acompteSuccess.whatsappQuestion': 'A question? WhatsApp',
    'acompteSuccess.sumupFailedTitle': 'Payment not completed',
    'acompteSuccess.sumupFailedBody': 'SumUp did not confirm the payment ({{status}}). You can try again from the link in your quote email, or contact us.',
    'acompteSuccess.timedOutTitle': 'Confirmation in progress',
    'acompteSuccess.timedOutBody': 'SumUp has not confirmed your payment yet. No worries: if the charge went through, your order will be created automatically within the next few minutes and you will receive a confirmation email. You can close this page.',
    'acompteSuccess.recheckNow': 'Check again now',
    'acompteSuccess.whatsappProof': 'Send the proof of payment on WhatsApp',
    'acompteSuccess.verifyingTitle': 'Verifying payment…',
    'acompteSuccess.verifyingBody': 'Please wait a few seconds.',
    'acompteSuccess.backHome': 'Back to home',
    'b2bDashboard.acceptRefuse': 'Accept / Refuse',
    'b2bDashboard.actions': 'Actions',
    'b2bDashboard.addNotePlaceholder': 'Add a note about this repair...',
    'b2bDashboard.addPhoto': '+ Add',
    'b2bDashboard.additionalInfoPlaceholder': 'Additional information...',
    'b2bDashboard.additionalNotes': 'Additional notes',
    'b2bDashboard.addressOptional': 'Address (optional)',
    'b2bDashboard.addressPlaceholder': 'Address for on-site visit if needed',
    'b2bDashboard.alertDescribeRequest': 'Please describe your request',
    'b2bDashboard.amount': 'Amount',
    'b2bDashboard.awaitingReceptionStore': 'Awaiting reception in store',
    'b2bDashboard.back': 'Back',
    'b2bDashboard.backGlass': 'Back glass',
    'b2bDashboard.backGlassBroken': 'Back glass broken',
    'b2bDashboard.backGlassIntact': 'Back glass intact',
    'b2bDashboard.brandModelRequired': 'Brand and model are required',
    'b2bDashboard.broken': 'Broken',
    'b2bDashboard.changePassword': 'Change password',
    'b2bDashboard.chat': 'Chat',
    'b2bDashboard.clear': 'Clear',
    'b2bDashboard.clickNewRequestHint': 'Click "New request" to create one',
    'b2bDashboard.clickToAddPhotos': 'Click to add photos',
    'b2bDashboard.code': 'Code',
    'b2bDashboard.code6Digits': '6-digit code',
    'b2bDashboard.codeDigitsLetters': 'Code (digits/letters)',
    'b2bDashboard.codeValidatedSuccess': 'Code validated successfully!',
    'b2bDashboard.confirmOrderEmailPre': 'A purchase order with a confirmation code has been sent to your email. Enter this code in the ',
    'b2bDashboard.confirmOrderEmailPost': ' section to validate your order.',
    'b2bDashboard.createdOn': 'Created on',
    'b2bDashboard.customerProvidesPart': 'I provide the part',
    'b2bDashboard.date': 'Date',
    'b2bDashboard.delivery': 'Delivery',
    'b2bDashboard.delivery.pickup': 'Pickup',
    'b2bDashboard.delivery.postal': 'Postal shipping',
    'b2bDashboard.delivery.store': 'In store',
    'b2bDashboard.describeProblemPlaceholder': 'Describe the problem...',
    'b2bDashboard.designation': 'Item',
    'b2bDashboard.device': 'Device',
    'b2bDashboard.devisStatus.accepted': 'Accepted',
    'b2bDashboard.devisStatus.depositPaid': 'Deposit paid',
    'b2bDashboard.devisStatus.paid': 'Paid',
    'b2bDashboard.devisStatus.pending': 'Pending',
    'b2bDashboard.devisStatus.refused': 'Refused',
    'b2bDashboard.diagRef': 'Diag. ref:',
    'b2bDashboard.documentsWord': 'Documents',
    'b2bDashboard.downloadError': 'Download error',
    'b2bDashboard.downloadPdf': 'Download PDF',
    'b2bDashboard.enter6DigitCode': 'Enter the 6-digit code',
    'b2bDashboard.enterCodePerOrder': 'Enter the code received by email to validate each purchase order.',
    'b2bDashboard.enterCodeToValidate': 'Enter the code received by email to validate your order.',
    'b2bDashboard.enterPinPlaceholder': 'Enter the PIN code, password...',
    'b2bDashboard.enterValidationCode': 'Please enter the validation code',
    'b2bDashboard.error': 'Error',
    'b2bDashboard.filter.all': 'All',
    'b2bDashboard.history': 'History',
    'b2bDashboard.imeiSerial': 'IMEI / Serial No.',
    'b2bDashboard.imeiSerialShort': 'IMEI / Serial',
    'b2bDashboard.incorrectCode': 'Incorrect code',
    'b2bDashboard.invoiceLabel': 'Invoice:',
    'b2bDashboard.invoiceType.combined': 'Comb.',
    'b2bDashboard.invoiceType.diag': 'Diag',
    'b2bDashboard.invoiceType.repair': 'Repair',
    'b2bDashboard.invoices': 'Invoices',
    'b2bDashboard.invoicesAppearWhenPriced': 'Invoices appear as soon as the price is set by R.E.Mobiles',
    'b2bDashboard.latePayment': 'LATE PAYMENT - {{days}} days',
    'b2bDashboard.lock': 'Lock',
    'b2bDashboard.lockCode': 'Lock code',
    'b2bDashboard.mostRecent': 'Most recent',
    'b2bDashboard.nav.documents': 'Quotes / Invoices',
    'b2bDashboard.nav.quoteRequest': 'Request a quote',
    'b2bDashboard.newQuoteRequest': 'New quote request',
    'b2bDashboard.newRequest': 'New request',
    'b2bDashboard.noInvoiceAvailable': 'No invoice available',
    'b2bDashboard.noPhoto': 'No photo',
    'b2bDashboard.noPosInvoice': 'No purchase invoice',
    'b2bDashboard.noQuoteRequest': 'No quote request',
    'b2bDashboard.noTravelQuote': 'No travel quote',
    'b2bDashboard.nonFunctionalParts': 'Non-functional parts',
    'b2bDashboard.noteSaveError': 'Error saving the note',
    'b2bDashboard.notes': 'Notes',
    'b2bDashboard.oldest': 'Oldest',
    'b2bDashboard.optional': 'Optional',
    'b2bDashboard.orderValidated': 'Purchase order validated',
    'b2bDashboard.orderValidatedSuccess': 'Purchase order validated!',
    'b2bDashboard.orderValidationCode': 'Purchase order validation code',
    'b2bDashboard.paid': 'Paid',
    'b2bDashboard.paidLabel': 'Paid',
    'b2bDashboard.partProvidedByStore': 'The part will be provided by R.E.Mobiles',
    'b2bDashboard.parts.backCam': 'Rear camera',
    'b2bDashboard.parts.backGlass': 'Back glass',
    'b2bDashboard.parts.battery': 'Battery',
    'b2bDashboard.parts.chargingPort': 'Charging port',
    'b2bDashboard.parts.earSpeaker': 'Earpiece',
    'b2bDashboard.parts.fingerprint': 'Fingerprint',
    'b2bDashboard.parts.frontCam': 'Front camera',
    'b2bDashboard.parts.homeButton': 'Home button',
    'b2bDashboard.parts.lcd': 'Screen',
    'b2bDashboard.parts.microphone': 'Microphone',
    'b2bDashboard.parts.powerButton': 'Power button',
    'b2bDashboard.parts.signal': 'Signal',
    'b2bDashboard.parts.speaker': 'Speaker',
    'b2bDashboard.parts.volumeButton': 'Volume',
    'b2bDashboard.parts.wifiBt': 'Wi-Fi/BT',
    'b2bDashboard.pattern': 'Pattern',
    'b2bDashboard.pay': 'Pay',
    'b2bDashboard.payRemaining': 'Pay the balance ({{amount}})',
    'b2bDashboard.paymentCreateError': 'Error creating the payment',
    'b2bDashboard.paymentLinkUnavailable': 'Payment link unavailable. Contact R.E.Mobiles.',
    'b2bDashboard.pdfDownloadError': 'Error downloading the PDF',
    'b2bDashboard.pdfInvoice': 'Invoice PDF',
    'b2bDashboard.pdfPurchaseOrder': 'Purchase order PDF',
    'b2bDashboard.pdfQuote': 'Quote PDF',
    'b2bDashboard.penaltiesLine': 'Penalties: {{penalty}} + Flat fee: {{indemnity}}',
    'b2bDashboard.photos': 'Photos',
    'b2bDashboard.pickupAddress': 'Pickup address',
    'b2bDashboard.pickupAddressPlaceholder': 'Full address where to pick up the phone...',
    'b2bDashboard.pickupAddressRequired': 'Please enter the pickup address',
    'b2bDashboard.pickupRequested': 'Pickup requested - we will come to collect the device',
    'b2bDashboard.posInvoices': 'Purchase invoices (POS)',
    'b2bDashboard.price': 'Price',
    'b2bDashboard.priceCol': 'Price',
    'b2bDashboard.priceDiagnostic': 'Diagnostic price',
    'b2bDashboard.pricePending': 'Pending - will be set by R.E.Mobiles',
    'b2bDashboard.priceRepair': 'Repair price',
    'b2bDashboard.problem': 'Problem',
    'b2bDashboard.problemDescription': 'Problem / Description',
    'b2bDashboard.purchaseOrderLabel': 'Purchase order:',
    'b2bDashboard.quoteRequestTitle': 'Quote request',
    'b2bDashboard.refusalReason': 'Reason for refusal:',
    'b2bDashboard.remaining': 'Remaining',
    'b2bDashboard.repairAcceptedByStaff': 'Repair accepted by staff',
    'b2bDashboard.repairRefusedByStaff': 'Repair refused by staff',
    'b2bDashboard.repairTitle': 'Repair {{ref}}',
    'b2bDashboard.requestDescription': 'Description of your request',
    'b2bDashboard.requestDescriptionPlaceholder': 'Describe what you need: type of repair, quantity, issues, etc.',
    'b2bDashboard.requestStatus.inProgress': 'In progress',
    'b2bDashboard.requestStatus.new': 'New',
    'b2bDashboard.requestStatus.processed': 'Processed',
    'b2bDashboard.requestStatus.refused': 'Refused',
    'b2bDashboard.retentionInvoices': 'Invoices are kept on our servers for a period of 18 months.',
    'b2bDashboard.retentionQuotes': 'Quotes are kept on our servers for a period of 1 month.',
    'b2bDashboard.saveNote': 'Save note',
    'b2bDashboard.saving': 'Saving...',
    'b2bDashboard.searchPlaceholder': 'Search...',
    'b2bDashboard.sendRequest': 'Send my request',
    'b2bDashboard.sending': 'Sending...',
    'b2bDashboard.status.awaitingParts': 'Awaiting parts',
    'b2bDashboard.status.awaitingPickup': 'Awaiting pickup',
    'b2bDashboard.status.awaitingReception': 'Awaiting reception',
    'b2bDashboard.status.completed': 'Completed',
    'b2bDashboard.status.delivered': 'Delivered',
    'b2bDashboard.status.inProgress': 'In progress',
    'b2bDashboard.status.received': 'Received',
    'b2bDashboard.status.refused': 'Refused',
    'b2bDashboard.statusCol': 'Status',
    'b2bDashboard.submitError': 'Error during submission',
    'b2bDashboard.teamResponse': 'Team response:',
    'b2bDashboard.titleOptional': 'Title (optional)',
    'b2bDashboard.titlePlaceholder': 'e.g. Samsung screen batch repair',
    'b2bDashboard.total': 'Total',
    'b2bDashboard.totalDue': 'Total due: {{amount}}',
    'b2bDashboard.trackingBadge': 'Tracking:',
    'b2bDashboard.trackingNumber': 'Tracking number',
    'b2bDashboard.trackingPlaceholder': 'e.g. 1Z999AA10123456784',
    'b2bDashboard.trackingRequired': 'Please enter the tracking number for postal shipping',
    'b2bDashboard.trackingShort': 'Tracking no.',
    'b2bDashboard.travelFee': 'Travel fee',
    'b2bDashboard.travelQuotes': 'Travel quotes',
    'b2bDashboard.uploadError': 'Upload error',
    'b2bDashboard.uploading': 'Uploading...',
    'b2bDashboard.validate': 'Validate',
    'b2bDashboard.validationCodeConfirmed': 'Validation code confirmed',
    'client.mySpace': 'My Space',
    'client.invoiceDownloadError': 'Error downloading the invoice',
    'client.invoiceViewError': 'Error displaying the invoice',
    'client.invoicePrintError': 'Error printing the invoice',
    'client.pinMustBe4': 'The PIN code must contain 4 digits',
    'client.pinMismatch': 'The PIN codes do not match',
    'client.pinChanged': 'PIN code changed successfully!',
    'client.pinChangeError': 'Error changing the PIN',
    'client.describeRequest': 'Please describe your request',
    'client.error': 'Error',
    'client.enterValidationCode': 'Please enter the validation code',
    'client.codeValidated': 'Code validated successfully!',
    'client.codeIncorrect': 'Incorrect code',
    'client.sumupUrlUnavailable': 'Error: SumUp payment URL unavailable',
    'client.sumupCreateError': 'Error creating the SumUp payment',
    'client.fillRequired': 'Please fill in all required fields',
    'client.invalidEmail': 'Invalid email address',
    'client.requestError': 'Error during the request',
    'client.trackingSaved': 'Tracking number saved!',
    'client.statusText.recu': 'Device received at the workshop',
    'client.statusText.enCours': 'Repair in progress',
    'client.statusText.attentePieces': 'Waiting for parts',
    'client.statusText.termine': 'Repair completed - Ready for pickup',
    'client.statusText.livre': 'Device picked up',
    'client.statusText.demandeEnLigne': 'Awaiting receipt of the device',
    'client.statusText.nonReparable': 'Device not repairable',
    'client.statusLabel.recu': 'Received',
    'client.statusLabel.enCours': 'In progress',
    'client.statusLabel.attentePieces': 'Waiting for parts',
    'client.statusLabel.termine': 'Completed',
    'client.statusLabel.livre': 'Delivered',
    'client.statusLabel.recupere': 'Picked up',
    'client.statusLabel.demandeEnLigne': 'Online request',
    'client.statusLabel.nonReparable': 'Not repairable',
    'client.created': 'Created',
    'client.technicianNotes': 'Technician notes',
    'client.noNotes': 'No notes yet',
    'client.file': 'file',
    'client.files': 'files',
    'client.navigation': 'Navigation',
    'client.devisFactures': 'Quotes / Invoices',
    'client.myAddresses': 'My addresses',
    'client.myAccount': 'My account',
    'client.needHelp': 'Need help?',
    'client.helpHours': 'Our team is available from Monday to Saturday, 9 a.m. to 7 p.m.',
    'client.contactUs': 'Contact us',
    'client.contactSupport': 'Contact support',
    'client.guideMe': 'Guide me',
    'client.logout': 'Log out',
    'client.changePassword': 'Change password',
    'client.addresses': 'Addresses',
    'client.requestRepair': 'Request a repair',
    'client.showDelivered': 'Show delivered',
    'client.hideDelivered': 'Hide delivered',
    'client.noRepairsInProgress': 'No repairs in progress',
    'client.onlineRepairRequest': 'Online repair request',
    'client.diagFeeFormPre': 'Fill in the form below. A diagnostic fee of',
    'client.diagFeeFormPost': 'must be paid online.',
    'client.repairReason': 'Repair reason',
    'client.repairReasonPlaceholder': 'E.g.: Broken screen, battery...',
    'client.fullName': 'Full name',
    'client.fullNamePlaceholder': 'Your full name',
    'client.postalAddress': 'Postal address',
    'client.addressPlaceholder': 'Your address',
    'client.emailAddress': 'Email address',
    'client.emailPlaceholder': 'email@example.com',
    'client.describeIssue': 'Describe the issue in detail',
    'client.describeIssuePlaceholder': 'Tell us how the phone/tablet broke down and the symptoms you noticed...',
    'client.devicePhotos': 'Photos of the device',
    'client.addPhotos': 'Add photos',
    'client.cancel': 'Cancel',
    'client.sending': 'Sending...',
    'client.sendRequest': 'Send request',
    'client.requestSaved': 'Request saved: {{ref}}',
    'client.redirecting': 'Redirecting...',
    'client.payDiagnosticSumup': 'Pay {{amount}} with SumUp (diagnostic)',
    'client.diagFeePending': 'Your request is pending. To start the diagnostic, please pay the fee of',
    'client.depositOrSend': 'Drop off your device at the store or send it by post with proof of receipt:',
    'client.trackingPlaceholder': 'Postal tracking number',
    'client.save': 'Save',
    'client.postalDelayNotice': 'If sending by post: the deadline extends to 20 days before the request expires (40 days before deletion)',
    'client.close': 'Close',
    'client.progress': 'Progress',
    'client.deposits': 'Deposits',
    'client.rest': 'Remaining',
    'client.payWithSumup': 'Pay {{amount}} with SumUp',
    'client.detailedTracking': 'Detailed tracking',
    'client.chatRepair': 'Repair chat {{ref}}',
    'client.contact': 'Contact',
    'client.photosCount': 'Photos ({{count}})',
    'client.level': '{{name}} level',
    'client.tierOr': 'Gold',
    'client.tierArgent': 'Silver',
    'client.tierBronze': 'Bronze',
    'client.totalPurchases': '{{count}} purchase(s) in total',
    'client.nextLevel': 'Next level:',
    'client.purchasesToNext': '{{count}} purchase(s) remaining',
    'client.rewardAvailable': 'Reward available!',
    'client.reward10Reached': 'Congratulations, you have reached {{count}} purchases',
    'client.rewardPosDesc': 'on your next in-store purchase',
    'client.rewardRepairDesc': 'on your next repair',
    'client.loyaltyPoints': 'Loyalty points',
    'client.purchasesUntilReward': 'Only {{count}} purchase(s) left until the reward',
    'client.rewardReached': 'Reward reached!',
    'client.rewardsHistory': 'Rewards history',
    'client.reward15Pos': '-15% in-store',
    'client.reward10Repair': '-10% Repair',
    'client.referralProgram': 'Referral Program',
    'client.referralSubtitle': 'Share your code and earn bonus points',
    'client.yourReferralCode': 'Your referral code',
    'client.copied': 'Copied!',
    'client.copy': 'Copy',
    'client.referralShare1': 'Share this code with your friends. When they sign up with it, you earn',
    'client.referralBonusPoints': '+2 points',
    'client.referralShare2': 'in loyalty rewards!',
    'client.copyReferralLink': 'Copy the sign-up link',
    'client.referrals': 'Referral(s)',
    'client.bonusPoints': 'Bonus points',
    'client.yourReferrals': 'Your referrals',
    'client.referralFallback': 'Referral',
    'client.myDevis': 'My Quotes',
    'client.newRequest': 'New request',
    'client.newDevisRequest': 'New quote request',
    'client.titleOptional': 'Title (optional)',
    'client.devisTitlePlaceholder': 'E.g.: iPhone 15 screen repair',
    'client.requestDescription': 'Description of your request',
    'client.devisDescPlaceholder': 'Describe what you need: type of repair, problem, etc.',
    'client.addressOptional': 'Address (optional, for on-site visit)',
    'client.devisAddressPlaceholder': 'Your address if you would like an on-site visit',
    'client.sendMyRequest': 'Send my request',
    'client.myDevisRequests': 'My quote requests',
    'client.devisRequestTitle': 'Quote request',
    'client.devisReqNouveau': 'New',
    'client.devisReqEnCours': 'In progress',
    'client.devisReqRefuse': 'Refused',
    'client.devisReqTraite': 'Processed',
    'client.teamResponse': 'Team response:',
    'client.refusalReason': 'Reason for refusal:',
    'client.clickNewRequest': 'Click "New request" to create one',
    'client.designation': 'Item',
    'client.price': 'Price',
    'client.travelFees': 'Travel fees',
    'client.totalUpper': 'TOTAL',
    'client.paid': 'Paid',
    'client.purchaseOrder': 'Purchase order',
    'client.invoice': 'Invoice',
    'client.latePayment': 'LATE PAYMENT - {{days}} days',
    'client.latePenaltyLabel': 'Late payment penalties ({{rate}}% annual)',
    'client.recoveryIndemnity': 'Fixed recovery indemnity',
    'client.totalWithPenalties': 'Total due with penalties',
    'client.validationCodeTitle': 'Purchase order validation code',
    'client.validationCodeDesc': 'Enter the code received by email to validate your order.',
    'client.code6digits': '6-digit code',
    'client.validate': 'Validate',
    'client.codeConfirmed': 'Validation code confirmed',
    'client.pdfDevis': 'Quote PDF',
    'client.pdfPurchaseOrder': 'Purchase order PDF',
    'client.pdfInvoice': 'Invoice PDF',
    'client.payRest': 'Pay the balance ({{amount}})',
    'client.deposit50': '50% deposit',
    'client.fullPayment': 'Full payment',
    'client.myInvoices': 'My Invoices',
    'client.mostRecent': 'Most recent',
    'client.oldest': 'Oldest',
    'client.noInvoices': 'No invoices available',
    'client.view': 'View',
    'client.print': 'Print',
    'client.seeLess': 'See less',
    'client.seeMoreInvoices': 'See more ({{count}} invoices)',
    'client.invoiceRetention': 'Invoices are kept on our servers for a period of 18 months.',
    'client.devisRetention': 'Quotes are kept on our servers for a period of 1 month.',
    'client.createCaricature': 'Create my caricature',
    'client.copyrightBy': 'Copyright by',
    'client.notifications': 'Notifications',
    'client.markAllRead': 'Mark all as read',
    'client.noNotifications': 'No notifications',
    'client.pinChangeTitle': 'Change PIN code',
    'client.pinChangeDesc': 'For your security, please choose a new 4-digit PIN code.',
    'client.newPin': 'New PIN code',
    'client.confirmPin': 'Confirm PIN',
    'client.modifying': 'Changing...',
    'client.changePin': 'Change my PIN code',
    'client.proofSent': 'Proof of payment sent! The staff will review it.',
    'client.sendError': 'Error while sending',
    'client.orderStatusEnAttente': 'Pending',
    'client.orderStatusPayee': 'Paid',
    'client.orderStatusProofUploaded': 'Proof sent',
    'client.orderStatusConfirmee': 'Confirmed',
    'client.orderStatusPreparee': 'Prepared',
    'client.orderStatusExpediee': 'Shipped',
    'client.orderStatusLivree': 'Delivered',
    'client.orderStatusAnnulee': 'Cancelled',
    'client.trackingNumber': 'Tracking number:',
    'client.trackingHint': 'Use this number to track your parcel',
    'client.stepCommande': 'Order',
    'client.proofSentLabel': 'Proof of payment sent',
    'client.sentOn': 'Sent on',
    'client.validatedByStaff': 'Validated by the staff',
    'client.payWithSumupPlain': 'Pay with SumUp',
    'client.sendProof': 'Send proof of payment (screenshot)',
    'client.history': 'History',
    'client.chatOrder': 'Order chat {{ref}}',
    'client.homeLabel': 'Home',
    'client.enterFullAddress': 'Please enter your full address.',
    'client.saveError': 'Error while saving',
    'client.addressLabelField': 'Label',
    'client.labelPlaceholder': 'Home, Office...',
    'client.phone': 'Phone',
    'client.phonePlaceholder': '06 94 ...',
    'client.recipient': 'Recipient',
    'client.recipientPlaceholder': 'Recipient\'s name',
    'client.deliveryAddress': 'Delivery address',
    'client.addressInputPlaceholder': 'Enter your full address',
    'client.freeAddressHint': 'Free entry: select a suggestion if it appears, otherwise simply type your address.',
    'client.searching': 'Searching...',
    'client.addressValidated': 'Address validated',
    'client.saving': 'Saving...',
    'client.confirmDeleteAddress': 'Delete this address?',
    'client.manageAddressesSubtitle': 'Manage your delivery addresses',
    'client.addAddress': 'Add an address',
    'client.newAddress': 'New address',
    'client.editAddress': 'Edit the address',
    'client.default': 'Default',
    'client.edit': 'Edit',
    'client.delete': 'Delete',
    'client.setDefault': 'Set as default',
    'client.selectAddress': 'Please select or add a delivery address.',
    'client.orderSuccess': 'Order placed successfully!',
    'client.orderError': 'Error during the order',
    'client.ourAccessories': 'Our accessories',
    'client.expertSelection': 'Selection tested by our experts',
    'client.allCategories': 'All categories',
    'client.cart': 'Cart',
    'client.noArticles': 'No items available',
    'client.inStock': 'In stock',
    'client.unavailable': 'Unavailable',
    'client.add': 'Add',
    'client.myCart': 'My cart',
    'client.articleSingular': 'item',
    'client.articlesPlural': 'items',
    'client.cartEmpty': 'Your cart is empty',
    'client.manage': 'Manage',
    'client.processing': 'Processing...',
    'client.payOnDelivery': 'Cash on delivery',
    'publicShop.status.en_attente': 'Pending',
    'publicShop.status.en_cours': 'In progress',
    'publicShop.status.termine': 'Completed',
    'publicShop.status.pret': 'Ready',
    'publicShop.status.livre': 'Delivered',
    'publicShop.status.annule': 'Cancelled',
    'publicShop.repairNotFound': 'Repair not found',
    'publicShop.shopNotFound': 'Shop not found',
    'publicShop.trackTitle': 'Track my repair',
    'publicShop.trackSubtitle': 'Enter your serial number or tracking code',
    'publicShop.trackPlaceholder': 'Serial number or tracking code...',
    'publicShop.trackButton': 'Track',
    'publicShop.labelDateEntree': 'Drop-off date:',
    'publicShop.labelSortiePrevue': 'Expected ready date:',
    'publicShop.labelProbleme': 'Issue:',
    'publicShop.labelRemarques': 'Notes:',
    'publicShop.poweredBy': 'Powered by {{brand}}',
    'invoiceRequest.subtitle': 'Invoice request',
    'invoiceRequest.search.title': 'Find your purchase',
    'invoiceRequest.search.hint': 'Enter the exact amount and the approximate time.',
    'invoiceRequest.search.amountLabel': 'Amount paid (EUR)',
    'invoiceRequest.search.amountPlaceholder': 'e.g. 25.00',
    'invoiceRequest.search.timeLabel': 'Time',
    'invoiceRequest.search.dateLabel': 'Date',
    'invoiceRequest.search.loading': 'Searching…',
    'invoiceRequest.search.submit': 'Search',
    'invoiceRequest.results.title': 'Select your purchase',
    'invoiceRequest.results.paidLabel': 'Paid:',
    'invoiceRequest.itemsCount': '{{count}} item(s)',
    'invoiceRequest.back': 'Back',
    'invoiceRequest.form.title': 'Your information',
    'invoiceRequest.form.purchase': 'Purchase',
    'invoiceRequest.form.alreadyPaid': 'Already paid',
    'invoiceRequest.form.payment': 'Payment',
    'invoiceRequest.form.remaining': 'Remaining',
    'invoiceRequest.form.nameLabel': 'Full name',
    'invoiceRequest.form.namePlaceholder': 'John Doe',
    'invoiceRequest.form.emailLabel': 'Email address',
    'invoiceRequest.form.emailPlaceholder': 'john@example.com',
    'invoiceRequest.form.phoneLabel': 'Phone',
    'invoiceRequest.form.phonePlaceholder': '0694XXXXXX',
    'invoiceRequest.form.sending': 'Sending…',
    'invoiceRequest.form.submit': 'Send the invoice',
    'invoiceRequest.pending.title': 'Request pending',
    'invoiceRequest.pending.desc': 'This invoice has already been sent to another address.',
    'invoiceRequest.pending.validationRequired': 'Validation required',
    'invoiceRequest.pending.info': 'Your request has been forwarded to our team. You will receive the invoice at {{email}} once it is approved.',
    'invoiceRequest.newRequest': 'New request',
    'invoiceRequest.success.title': 'Invoice sent!',
    'invoiceRequest.success.desc': 'Your invoice has been sent to {{email}}.',
    'invoiceRequest.success.accountCreated': 'Customer account created!',
    'invoiceRequest.success.newAccountDesc': 'Your login credentials have been sent to {{email}}.',
    'invoiceRequest.success.sendingCredentials': 'Sending…',
    'invoiceRequest.success.resendCredentials': 'Get my credentials by email',
    'invoiceRequest.success.credentialsSent': 'Credentials sent to {{email}}',
    'invoiceRequest.success.trackRepairs': 'Track my repairs',
    'invoiceRequest.footer': 'R.E.Mobiles — 102 Avenue Général de Gaulle, Porte 2, 97300 Cayenne',
    'invoiceRequest.errors.search': 'Search error',
    'invoiceRequest.errors.notFound': 'No sale found for this amount and time. Please check the information.',
    'invoiceRequest.errors.send': 'Error while sending',
    'invoiceRequest.errors.generic': 'Error',
    'storefront.notfound.title': 'Company not found',
    'storefront.notfound.desc': 'This company doesn\'t exist or is no longer active.',
    'storefront.notfound.back': 'Back to home',
    'storefront.tab.track': 'Track my repair',
    'storefront.tab.login': 'Client area',
    'storefront.track.title': 'Repair tracking',
    'storefront.track.subtitle': 'Enter your reference to track the progress of your repair',
    'storefront.track.format': 'Reference format:',
    'storefront.track.submit': 'Track',
    'storefront.track.not_found': 'Repair not found',
    'storefront.track.ref': 'Reference',
    'storefront.track.device': 'Device',
    'storefront.track.problem': 'Issue',
    'storefront.track.date_in': 'Drop-off date',
    'storefront.track.date_out': 'Estimated ready date',
    'storefront.status.waiting': 'Pending',
    'storefront.status.in_progress': 'In progress',
    'storefront.status.done': 'Completed',
    'storefront.status.delivered': 'Delivered',
    'storefront.status.cancelled': 'Cancelled',
    'storefront.status.unknown': 'Unknown',
    'storefront.login.title': 'Client login',
    'storefront.login.subtitle': 'Log in to your client area at {{name}}',
    'storefront.login.phone': 'Phone',
    'storefront.login.pin': 'PIN code',
    'storefront.login.error_fields': 'Enter your phone number and PIN code (4 or 6 digits)',
    'storefront.login.error_invalid': 'Incorrect credentials',
    'storefront.login.loading': 'Signing in...',
    'storefront.login.submit': 'Sign in',
    'storefront.login.create_account': 'No account yet? Create an account',
    'storefront.register.title': 'Create an account',
    'storefront.register.subtitle': 'Sign up at {{name}}',
    'storefront.register.name': 'Full name',
    'storefront.register.name_ph': 'John Smith',
    'storefront.register.phone': 'Phone',
    'storefront.register.email': 'Email (optional)',
    'storefront.register.email_ph': 'email@example.com',
    'storefront.register.pin': 'PIN code',
    'storefront.register.pin_confirm': 'Confirm PIN',
    'storefront.register.error_required': 'Name and phone are required',
    'storefront.register.error_pin_short': 'The PIN must contain at least 4 digits',
    'storefront.register.error_pin_mismatch': 'The PINs do not match',
    'storefront.register.error_generic': 'Error while creating the account',
    'storefront.register.loading': 'Creating...',
    'storefront.register.submit': 'Create my account',
    'storefront.register.back_to_login': 'Already have an account? Sign in',
    'landing.svcScreenTitle': 'Broken screen',
    'landing.svcScreenDesc': 'iPhone, Samsung, Huawei screen replacement',
    'landing.svcBatteryTitle': 'Battery',
    'landing.svcBatteryDesc': 'Battery replacement, all brands',
    'landing.svcConnectorTitle': 'Connector',
    'landing.svcConnectorDesc': 'Charging port, audio jack',
    'landing.svcCameraTitle': 'Camera',
    'landing.svcCameraDesc': 'Front and rear camera',
    'landing.svcOxidationTitle': 'Water damage repair',
    'landing.svcOxidationDesc': 'Phone dropped in water',
    'landing.svcDiagTitle': 'Diagnosis',
    'landing.svcDiagDesc': '€35 to €80 depending on the device · free quote',
    'landing.tip1': '**Hello!** I can track your repair or give you an estimate.',
    'landing.tip2': '**6-month warranty** on all our repairs, parts and labour.',
    'landing.tip3': '**Diagnosis** from €35 to €80 depending on the device, quoted before we start.',
    'landing.tip4': 'Dropped in water? **Turn it off** and come quickly: water damage repair in our workshop.',
    'landing.tip5': 'Track your repair live with your reference **REM0001**.',
    'landing.tip6': '**Micro-soldering** and data recovery, even if the device no longer turns on.',
    'landing.tip7': 'Open **Mon–Fri 9am–7pm** and **Sat 9am–2pm**, drop-off without appointment.',
    'landing.tip8': '**Free quote** online, sent by email after confirmation.',
    'landing.tip9': 'For professionals: a dedicated **Business Space** (B2B portal).',
    'landing.tip10': 'iPhone, Samsung, Huawei, Xiaomi, tablets and **consoles**: we repair it all.',
    'landing.tipFromPrice': 'from {{price}} — price confirmed in store.',
    'landing.guideMe': 'Guide me',
    'landing.flashUntil': 'Until {{date}}',
    'landing.cadbotTitle': 'CADBOT, your assistant',
    'landing.cadbotDesc': 'Repair tracking, quote estimates, opening hours — it answers you right here on the site. The final price is always confirmed in store.',
    'landing.servicesTitle': 'Our Repair Services',
    'landing.servicesDesc': 'Express smartphone and tablet repair in Cayenne, French Guiana',
    'landing.seeAllPrices': 'See all our prices',
    'landing.readBlog': 'Read our blog',
    'landing.diagTitle': 'In-store diagnosis',
    'landing.diagDesc': 'From €35 to €80 depending on the device. The price is quoted to you before we start. The online quote remains free.',
    'landing.tierFrom': 'from',
    'landing.tierUpTo': 'up to',
    'landing.tierEntryTitle': 'Entry and mid-range',
    'landing.tierEntryDesc': 'Simple, identified fault',
    'landing.tierRecentTitle': 'Recent smartphones',
    'landing.tierRecentDesc': 'Several symptoms to check',
    'landing.tierComplexTitle': 'Complex cases',
    'landing.tierComplexDesc': 'Water damage, micro-soldering, consoles, tablets',
    'landing.enlarge': 'Enlarge',
    'landing.storePhotoAlt': 'Our Resurrection Mobile shop in Cayenne',
    'landing.storeTag': 'Our shop · Cayenne',
    'landing.enlargedPhoto': 'Enlarged photo',
    'landing.close': 'Close',
    'landing.storePhotoAltSimple': 'Resurrection Mobile shop',
    'landing.freeQuote': 'Free quote',
    'privacy.title': 'Privacy Policy',
    'privacy.last_updated': 'Last updated: March 19, 2026',
    'privacy.intro.part1': 'This Privacy Policy describes how ',
    'privacy.intro.part2': ' (“we”, “our”, “us”) collects, uses, retains and protects users’ personal data (“you”, “your”) in accordance with the ',
    'privacy.intro.rgpd': 'General Data Protection Regulation (GDPR — EU 2016/679)',
    'privacy.intro.part3': ' applicable in France and French Guiana.',
    'privacy.s1.title': 'Data controller',
    'privacy.s1.company_label': 'Company',
    'privacy.s1.status_label': 'Legal form',
    'privacy.s1.controller_note': 'The data controller is the person or entity that determines the purposes and means of the processing of your personal data.',
    'privacy.s2.title': 'Personal data collected',
    'privacy.s2.sub1_title': '2.1 Identification data',
    'privacy.s2.sub1_b1': 'First and last name',
    'privacy.s2.sub1_b2': 'Postal address',
    'privacy.s2.sub1_b3': 'Phone number',
    'privacy.s2.sub1_b4': 'Email address',
    'privacy.s2.sub1_b5': 'Company name (if a business customer)',
    'privacy.s2.sub2_title': '2.2 Service-related data',
    'privacy.s2.sub2_b1': 'Information about the devices entrusted to us (brand, model, IMEI, serial number)',
    'privacy.s2.sub2_b2': 'Repair history',
    'privacy.s2.sub2_b3': 'Orders, quotes and invoices',
    'privacy.s2.sub2_b4': 'Electronic signatures',
    'privacy.s2.sub3_title': '2.3 Payment data',
    'privacy.s2.sub3_b1': 'Transaction information',
    'privacy.s2.sub3_b2': 'Payment method used',
    'privacy.s2.payment_important_label': 'Important:',
    'privacy.s2.payment_important_text': 'We never store your complete banking details. Payments are processed by secure providers (Stripe).',
    'privacy.s2.sub4_title': '2.4 Technical data',
    'privacy.s2.sub4_b1': 'IP address',
    'privacy.s2.sub4_b2': 'Connection data',
    'privacy.s2.sub4_b3': 'Cookies and trackers',
    'privacy.s2.sub4_b4': 'Browsing data',
    'privacy.s3.title': 'Purposes of processing',
    'privacy.s3.b1': 'Provide our repair and sales services',
    'privacy.s3.b2': 'Manage orders, quotes and billing',
    'privacy.s3.b3': 'Ensure customer follow-up and after-sales service',
    'privacy.s3.b4': 'Communicate with you (SMS, email, phone)',
    'privacy.s3.b5': 'Comply with our legal and accounting obligations',
    'privacy.s3.b6': 'Improve our services and security',
    'privacy.s3.b7': 'Prevent fraud',
    'privacy.s4.title': 'Legal basis for processing',
    'privacy.s4.intro': 'In accordance with the GDPR, processing is based on:',
    'privacy.s4.i1': 'The performance of a contract',
    'privacy.s4.i2': 'Compliance with legal obligations',
    'privacy.s4.i3': 'Your consent (e.g. marketing)',
    'privacy.s4.i4': 'Our legitimate interest (security, improvement)',
    'privacy.s5.title': 'Data recipients',
    'privacy.s5.b1': 'Our authorized employees',
    'privacy.s5.b2': 'Our technical service providers (hosting, payment, SMS, email)',
    'privacy.s5.b3': 'Administrative or judicial authorities where required by law',
    'privacy.s5.no_sale': 'No personal data is sold to third parties.',
    'privacy.s6.title': 'Transfers outside the European Union',
    'privacy.s6.text': 'If some providers are located outside the EU, we ensure that they offer an adequate level of protection in compliance with the GDPR (standard contractual clauses, adequacy decisions, etc.).',
    'privacy.s7.title': 'Data retention period',
    'privacy.s7.r1_label': 'Customer data',
    'privacy.s7.r1_value': '5 years after the last commercial relationship',
    'privacy.s7.r2_label': 'Billing data',
    'privacy.s7.r2_value': '10 years (legal obligation)',
    'privacy.s7.r3_label': 'Marketing data',
    'privacy.s7.r3_value': 'Until consent is withdrawn',
    'privacy.s7.r4_label': 'Cookies',
    'privacy.s7.r4_value': 'Maximum 13 months',
    'privacy.s8.title': 'Data security',
    'privacy.s8.intro': 'We implement appropriate technical and organizational measures:',
    'privacy.s8.b1': 'Restricted access to data',
    'privacy.s8.b2': 'Secure hosting',
    'privacy.s8.b3': 'Encryption where necessary',
    'privacy.s8.b4': 'Regular backups',
    'privacy.s8.b5': 'Protection against unauthorized access',
    'privacy.s9.title': 'Your rights',
    'privacy.s9.intro': 'In accordance with the GDPR, you have the following rights:',
    'privacy.s9.r1': 'Right of access',
    'privacy.s9.r2': 'Right to rectification',
    'privacy.s9.r3': 'Right to erasure (“right to be forgotten”)',
    'privacy.s9.r4': 'Right to restriction of processing',
    'privacy.s9.r5': 'Right to object',
    'privacy.s9.r6': 'Right to data portability',
    'privacy.s9.r7': 'Right to withdraw your consent',
    'privacy.s9.exercise': 'To exercise your rights, contact us at:',
    'privacy.s9.complaint_before': 'You may also lodge a complaint with the ',
    'privacy.s9.complaint_after': '.',
    'privacy.s10.title': 'Cookies',
    'privacy.s10.intro': 'Our site may use cookies to:',
    'privacy.s10.b1': 'Ensure the site functions',
    'privacy.s10.b2': 'Measure audience',
    'privacy.s10.b3': 'Improve the user experience',
    'privacy.s10.manage': 'You can manage your preferences through your browser or our cookie banner.',
    'privacy.s11.title': 'Minors’ data',
    'privacy.s11.text': 'Our services are not intended for minors without parental authorization. If a minor’s data has been collected by mistake, please contact us to have it deleted.',
    'privacy.s12.title': 'Changes to this policy',
    'privacy.s12.text': 'We may amend this Policy at any time to reflect legal or technical developments. The version in force is the one published on our site.',
    'privacy.s13.title': 'Contact',
    'privacy.s13.intro': 'For any question regarding this Policy or your personal data:',
    'privacy.footer': 'By using our services, you acknowledge that you have read this Privacy Policy.',
    'track.title': 'Track my repair',
    'track.label_ref': 'Reference',
    'track.label_device': 'Device',
    'track.label_received': 'Received on',
    'track.label_expected': 'Expected ready',
    'track.label_completed': 'Completed on',
    'track.label_amount': 'Amount',
    'track.status_pending': 'Pending',
    'track.see_full': 'See full details',
    'track.input_placeholder': 'Enter your reference (ex: REM0001)',
    'track.btn_track': 'Track',
    'track.scan_qr': 'Scan my ticket QR code',
    'track.err_invalid_ref': 'Invalid reference. Expected format: REM0001',
    'track.err_not_found': 'Repair not found',
    'chatWidget.statusStaffOnline': 'Team online',
    'chatWidget.statusAiActive': 'AI active — automatic reply',
    'chatWidget.statusOffline': 'Offline — leave a message',
    'chatWidget.launcherLabel': 'Chat & Help',
    'chatWidget.tabStaff': 'Support chat',
    'chatWidget.tabAi': 'AI help',
    'chatWidget.newMessage': 'New message',
    'chatWidget.loading': 'Loading...',
    'chatWidget.noConversations': 'No conversations',
    'chatWidget.emptyConvoHint': 'Click "{{action}}" to contact us',
    'chatWidget.conversationFallback': 'Conversation',
    'chatWidget.autoReplyTitle': 'AI auto-reply mode active',
    'chatWidget.autoReplyDesc': 'The team is offline. The AI replies in the meantime.',
    'chatWidget.staffEmptyTitle': 'Send a message to the team',
    'chatWidget.staffEmptyDesc': 'We\'ll reply as soon as possible',
    'chatWidget.aiAssistant': 'AI assistant',
    'chatWidget.badgeAuto': 'auto',
    'chatWidget.badgeQuoteIndicative': 'indicative quote',
    'chatWidget.badgeQuotePending': 'quote in progress',
    'chatWidget.supportFallback': 'Support',
    'chatWidget.sending': 'Sending...',
    'chatWidget.staffInputPlaceholder': 'Your message...',
    'chatWidget.interactiveGuides': 'Interactive guides',
    'chatWidget.stepsCount': '{{count}} steps',
    'chatWidget.faqTitle': 'Frequently asked questions',
    'chatWidget.back': 'Back',
    'chatWidget.stepProgress': 'Step {{current}} / {{total}}',
    'chatWidget.previous': 'Previous',
    'chatWidget.next': 'Next',
    'chatWidget.finish': 'Finish',
    'chatWidget.aiInputPlaceholder': 'Ask your question...',
    'chatWidget.aiError': 'Sorry, an error occurred.',
    'chatWidget.me': 'Me',
    'chatWidget.newConversationSubject': 'New conversation',
    'hours.title': 'Opening hours',
    'hours.rows.weekdays.label': 'Monday - Friday',
    'hours.rows.weekdays.hours': '9 AM - 7 PM',
    'hours.rows.saturday.label': 'Saturday',
    'hours.rows.saturday.hours': '9 AM - 2 PM',
    'hours.rows.sunday.label': 'Sunday',
    'hours.closed': 'Closed',
    'hours.unit.hour': 'h',
    'hours.unit.minute': 'min',
    'hours.unit.second': 's',
    'hours.clock': 'it\'s {{time}} in Cayenne',
    'hours.ring.dayProgress': 'of the day',
    'hours.ring.untilReopen': 'until reopening',
    'hours.state.openNow': 'Open now',
    'hours.state.closingSoon': 'Closing soon',
    'hours.state.closed': 'Closed',
    'hours.count.untilClose': 'until closing ({{hour}}:00)',
    'hours.count.untilOpen': 'until opening',
    'hours.sub.openSince': 'Open for {{duration}}',
    'hours.sub.nextOpen': 'Next opening: {{when}} at {{hour}}:00',
    'hours.when.today': 'today',
    'hours.when.tomorrow': 'tomorrow',
    'hours.mood.closingSoon': '⏳ Final stretch — we\'re still here for a little while!',
    'hours.mood.justOpened': '☕ We\'ve just opened — come say hi!',
    'hours.mood.open': '🟢 We\'re open — drop by whenever you like!',
    'hours.mood.opensSoon': '🚪 Opening in under an hour — the shutters are about to rise!',
    'hours.mood.sundayRest': '🌴 Sunday is our day off — see you Monday at 9:00!',
    'hours.mood.morning': '🌅 Good morning! We open at {{hour}}:00 — get your devices ready.',
    'hours.mood.evening': '🌙 Closed for tonight — see you very soon!',
    'hours.dayName.0': 'Sunday',
    'hours.dayName.1': 'Monday',
    'hours.dayName.2': 'Tuesday',
    'hours.dayName.3': 'Wednesday',
    'hours.dayName.4': 'Thursday',
    'hours.dayName.5': 'Friday',
    'hours.dayName.6': 'Saturday',
    'cadbot.welcome': 'Hello, I\'m **CADBOT**, the Resurrection Mobile assistant. Enter your reference **REM0001** to track your repair, or describe your issue for an estimate.',
    'cadbot.chip.status': 'Where\'s my repair at?',
    'cadbot.chip.screen': 'iPhone 11 screen broken, how much?',
    'cadbot.chip.battery': 'Galaxy S21 battery, price?',
    'cadbot.chip.diagnostic': 'How much is the diagnostic?',
    'cadbot.chip.hours': 'Hours and address?',
    'cadbot.note': 'Estimates are indicative and always confirmed in store. The detailed quote is sent by email after validation by our team.',
    'cadbot.status.online': 'online',
    'cadbot.resume.label': 'Resume my conversation',
    'cadbot.resume.title': 'Show the conversation started in this tab',
    'cadbot.reset.label': 'New conversation',
    'cadbot.reset.title': 'Clear this conversation and start over',
    'cadbot.input.label': 'Your message',
    'cadbot.input.placeholderIdentity': 'Your name, phone or email…',
    'cadbot.input.placeholderDefault': 'REM0001, iPhone 13 screen, battery…',
    'cadbot.send.aria': 'Send',
    'cadbot.local.greeting': 'Hello! I\'m **CADBOT**. I can track your repair (reference REM0001), estimate a quote, or give you our opening hours.',
    'cadbot.local.diagnostic': 'The in-store diagnostic ranges from {{min}} to {{max}} depending on the device and complexity. The price is given to you before we start. The online quote, however, is free.',
    'cadbot.local.water': 'Turn it off and don\'t charge it, then bring it to the store as soon as possible. Deoxidation is quoted after diagnosis.',
    'cadbot.local.hoursLine': 'We\'re at **{{address}}**. Hours: {{hours}}. {{state}}',
    'cadbot.local.hoursOpen': '**{{state}}** — {{time}} {{countLabel}}.',
    'cadbot.local.hoursClosed': '**Closed** — {{sub}}.',
    'cadbot.local.closedLower': 'closed',
    'cadbot.local.warranty': 'All our repairs are guaranteed for **6 months**, parts and labor.',
    'cadbot.local.accounts': 'The access points are just above: **Client Area** (track your repairs), **Business Area** (B2B portal) and **Staff Area**.',
    'cadbot.local.trackAsk': 'Enter your reference in the format **REM0001** (it\'s on your drop-off ticket) and I\'ll give you the status.',
    'cadbot.local.quoteFollowup': 'Your quote is sent by email as soon as our team validates it (remember to check your spam). If you hear nothing within 24 h, message us on WhatsApp at **{{phone}}**.',
    'cadbot.local.contact': 'You can reach us at **{{phone}}** (call & WhatsApp).',
    'cadbot.track.here': 'Here\'s the tracking for **{{ref}}**:',
    'cadbot.track.notFound': 'I can\'t find the repair **{{ref}}**. Please check the reference on your drop-off ticket.',
    'cadbot.track.unavailable': 'Tracking is temporarily unavailable, please try again in a moment.',
    'cadbot.server.ackDefault': 'Thank you, a technician will reply very soon.',
    'cadbot.error.rateLimit': 'Too many requests at once — please wait {{wait}} then try again.',
    'cadbot.error.waitMinutes': '{{n}} min',
    'cadbot.error.waitFallback': 'a minute',
    'cadbot.error.server': 'I can\'t reach the server. Message us on WhatsApp at **{{phone}}**.',
    // ── tarifs.* (pilote i18n 2026-09-12 — à relire) ──
    'tarifs.back': 'Home',
    'tarifs.searchPlaceholder': 'Search a model or repair type…',
    'tarifs.loading': 'Loading prices…',
    'tarifs.updateTitle': 'Prices being updated',
    'tarifs.updateDesc': 'Our prices are being updated. Contact us for a free, personalized quote.',
    'tarifs.call': 'Call',
    'tarifs.callPrefix': 'Call: ',
    'tarifs.callNow': 'Call now',
    'tarifs.noResult': 'No results',
    'tarifs.soon': 'Prices coming soon',
    'tarifs.tryOther': 'Try other terms',
    'tarifs.contactFree': 'Contact us for a free quote',
    'tarifs.repairBrand': '{{brand}} repair',
    'tarifs.tariffsCount': '{{count}} price(s) available',
    'tarifs.colModel': 'Model',
    'tarifs.colRepair': 'Repair',
    'tarifs.colPrice': 'Price',
    'tarifs.colDelay': 'Time',
    'tarifs.allModels': 'All models',
    'tarifs.whatsapp': 'WhatsApp',
    'tarifs.portal': 'Client Portal',
    'tarifs.faqTitle': 'Frequently asked questions',
    'tarifs.titleFallback': 'Phone Repair Prices',
    'tarifs.subtitleFallback': 'Discover our repair prices for iPhone, Samsung, Huawei and more. Fast, guaranteed repair in Cayenne, French Guiana.',
    'tarifs.ctaTitleFallback': 'Need a personalized quote?',
    'tarifs.ctaDescFallback': 'Every repair is unique. Contact us for a free diagnosis and an accurate quote tailored to your situation.',
    _name: 'English',
    _flag: '🇬🇧',
    'nav.dashboard': 'Dashboard',
    'nav.pos': 'Point of Sale',
    'nav.calcul': 'Price Calculator',
    'nav.devis': 'Quotes / Invoices',
    'nav.devisDeplacement': 'Travel Quotes',
    'nav.commandes': 'Orders',
    'nav.addDevice': 'Add device',
    'nav.reparations': 'Repairs',
    'nav.clients': 'Clients',
    'nav.stock': 'Inventory',
    'nav.addStock': 'Add Inventory',
    'nav.etiquettes': 'Labels',
    'nav.users': 'Users',
    'nav.clientPwd': 'Client Passwords',
    'nav.boutiqueOrders': 'Shop Orders',
    'nav.caisseHistory': 'Cash Register History',
    'nav.database': 'Database',
    'nav.historique': 'History',
    'nav.paiements': 'Online Payments',
    'nav.chatClients': 'Client Chat',
    'nav.chat': 'Messages',
    'nav.notes': 'Notes',
    'nav.logout': 'Log out',
    'nav.quit': 'Quit',
    'nav.admin': 'Administration',
    'nav.navigation': 'Navigation',
    'nav.b2b': 'B2B Management',
    'nav.b2bPayments': 'B2B Payments',
    'nav.brandsModels': 'Brands & Models',
    'nav.activityHub': 'Activity Center',
    'nav.salesHistory': 'Sales history',
    'nav.equipeMagasins': 'Team & stores',
    'nav.usersLegacy': 'Users (legacy)',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.search': 'Search',
    'common.add': 'Add',
    'common.close': 'Close',
    'common.confirm': 'Confirm',
    'common.loading': 'Loading...',
    'common.noData': 'No data',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.total': 'Total',
    'common.print': 'Print',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.validate': 'Validate',
    'common.ref': 'Reference',
    'common.client': 'Client',
    'common.phone': 'Phone',
    'common.email': 'Email',
    'common.price': 'Price',
    'common.quantity': 'Quantity',
    'common.amount': 'Amount',
    'common.send': 'Send',
    'common.download': 'Download',
    'common.export': 'Export',
    'common.refresh': 'Refresh',
    'common.filter': 'Filter',
    'common.all': 'All',
    'common.name': 'Name',
    'common.address': 'Address',
    'common.description': 'Description',
    'common.payment': 'Payment',
    'common.paid': 'Paid',
    'common.pending': 'Pending',
    'common.accepted': 'Accepted',
    'common.refused': 'Refused',
    'layout.panel': 'Management panel',
    'pos.title': 'Point of Sale',
    'pos.scanner': 'Scanner',
    'pos.searchProduct': 'Search product (ref, name, barcode)...',
    'pos.outOfStock': 'Out of stock',
    'pos.article': 'Article',
    'pos.unitPrice': 'Unit price',
    'pos.qty': 'Qty',
    'pos.emptyCart': 'Empty cart',
    'pos.checkout': 'Checkout',
    'pos.clientOptional': 'Client (optional)',
    'pos.discount': 'Discount',
    'pos.subtotal': 'Subtotal',
    'pos.validateSale': 'Validate sale',
    'pos.paymentMode': 'Payment method',
    'pos.choosePayment': 'Choose payment method:',
    'pos.cash': 'Cash',
    'pos.card': 'Credit Card',
    'pos.mixed': 'Mixed',
    'pos.totalToCollect': 'Total to collect',
    'pos.change': 'Change',
    'pos.confirmPayment': 'Confirm payment',
    'pos.validating': 'Processing...',
    'pos.lastTicket': 'Last receipt',
    'pos.caisseClosed': 'Cash register is closed. Open it from the Dashboard to make sales.',
    'pos.insufficientCash': 'Insufficient cash amount',
    'pos.insufficientCard': 'Insufficient card amount',
    'pos.mixedMustEqual': 'Mixed payment must equal the total',
    'pos.emptyCartAlert': 'Cart is empty',
    'pos.selectPayment': 'Please choose a payment method',
    'pos.saleValidated': 'Sale validated!',
    'pos.adminOverride': 'Admin validation',
    'pos.outOfStockProduct': 'Out of stock product',
    'pos.adminId': 'Admin ID',
    'pos.adminCode': 'Admin code',
    'pos.manualAdd': 'Add out-of-stock item',
    'pos.designation': 'Description',
    'pos.stockInsufficient': 'Insufficient stock',
    'devis.title': 'Quotes & Invoices',
    'devis.subtitle': 'Documents from price calculation (convertible to order).',
    'devis.noDoc': 'No document found',
    'devis.type': 'Type',
    'devis.convertConfirm': 'Convert this quote to an order?',
    'devis.orderCreated': 'Order created',
    'devis.deleteConfirm': 'Delete this document?',
    'devis.deleted': 'Document deleted',
    'devDep.title': 'Travel Quotes',
    'devDep.subtitle': 'Manage quotes for home/on-site repairs',
    'devDep.new': 'New quote',
    'devDep.edit': 'Edit quote',
    'devDep.clientName': 'Client name',
    'devDep.clientPhone': 'Phone',
    'devDep.clientEmail': 'Email',
    'devDep.clientAddress': 'Address',
    'devDep.repairDesc': 'Repair description',
    'devDep.lines': 'Quote lines',
    'devDep.addLine': 'Add',
    'devDep.travelFee': 'Travel fee',
    'devDep.sendByEmail': 'Send by email',
    'devDep.sending': 'Sending...',
    'devDep.pdfDevis': 'PDF Quote',
    'devDep.pdfBon': 'PDF Purchase order',
    'devDep.pdfFacture': 'PDF Invoice',
    'devDep.searchPlaceholder': 'Search by ref, name, email...',
    'devDep.allStatuses': 'All statuses',
    'devDep.pending': 'Pending',
    'devDep.accepted': 'Accepted',
    'devDep.refused': 'Refused',
    'devDep.depositPaid': 'Deposit paid',
    'devDep.fullyPaid': 'Paid',
    'devDep.stats': 'Statistics',
    'devDep.revenues': 'Revenue',
    'devDep.activity30d': 'Last 30 days activity',
    'devDep.remind': 'Send reminder',
    'devDep.remindConfirm': 'Send a reminder to clients with pending quotes over 3 days?',
    'devDep.noDevis': 'No quotes created',
    'devDep.noResults': 'No results',
    'devDep.bon': 'Purchase order',
    'devDep.facture': 'Invoice',
    'devDep.emailSent': 'Email sent on',
    'devDep.reminderSent': 'Reminder sent on',
    'rep.title': 'Repairs',
    'rep.search': 'Search repair...',
    'rep.new': 'New repair',
    'rep.deviceRef': 'Device ref.',
    'rep.brand': 'Brand',
    'rep.model': 'Model',
    'rep.problem': 'Problem',
    'rep.technician': 'Technician',
    'rep.timeline': 'Timeline',
    'cmd.title': 'Orders',
    'cmd.search': 'Search order...',
    'cmd.piece': 'Part',
    'cmd.supplier': 'Supplier',
    'cmd.deposit': 'Deposit',
    'cmd.remaining': 'Remaining',
    'clients.title': 'Clients',
    'clients.search': 'Search client...',
    'clients.name': 'Name',
    'clients.address': 'Address',
    'clients.addClient': 'New client',
    'stock.title': 'Inventory Management',
    'stock.search': 'Search item...',
    'stock.addArticle': 'Add item',
    'stock.category': 'Category',
    'stock.buyPrice': 'Buy price',
    'stock.sellPrice': 'Sell price',
    'stock.available': 'Available',
    'dash.title': 'Dashboard',
    'dash.openCaisse': 'Open register',
    'dash.closeCaisse': 'Close register',
    'dash.todaySales': 'Today\'s sales',
    'dash.monthSales': 'Monthly sales',
    'dash.activeRepairs': 'Active repairs',
    'dash.pendingOrders': 'Pending orders',
    'login.title': 'Login',
    'login.username': 'Username',
    'login.password': 'Access code',
    'login.submit': 'Log in',
    'login.clientAccess': 'Client access',
    'login.staffAccess': 'Staff access',
    'lang.select': 'Language',
    'client.space': 'Client Area',
    'client.repairs': 'Repairs',
    'client.boutique': 'Shop',
    'client.orders': 'Orders',
    'client.messages': 'Messages',
    'client.devis': 'Quotes',
    'client.trackRepairs': 'Track your repairs',
    'client.noRepairs': 'No repairs in progress',
    'client.trackOrders': 'Track your orders',
    'client.noOrders': 'No orders in progress',
    'client.shop': 'Online shop',
    'client.noProducts': 'No products available',
    'client.addToCart': 'Add to cart',
    'client.yourMessages': 'Your messages',
    'client.noMessages': 'No messages',
    'client.send': 'Send',
    'client.brand': 'Brand',
    'client.model': 'Model',
    'client.problem': 'Problem',
    'client.status': 'Status',
    'client.deposit': 'Deposit',
    'client.remaining': 'Remaining',
    'client.total': 'Total',
    'client.timeline': 'Timeline',
    'client.noDevis': 'No quotes yet',
    'client.acceptRefuse': 'Accept / Refuse',
    'client.pay': 'Pay',
    // Landing
    'landing.mobileRepair': 'Mobile repair in French Guiana',
    'landing.staffSpace': 'STAFF AREA',
    'landing.staffDesc': 'Technical team access',
    'landing.clientSpace': 'CLIENT AREA',
    'landing.clientDesc': 'Repair tracking',
    'landing.businessSpace': 'BUSINESS AREA',
    'landing.businessDesc': 'B2B Portal',
    'landing.contact': 'Contact',
    'landing.callWhatsapp': 'Call & WhatsApp',
    'landing.writeUs': 'Write to us directly',
    'landing.hours': 'Opening hours',
    'landing.legal': 'Legal information',
    'landing.capital': 'with a capital of',
    'landing.headquarters': 'Headquarters',
    'landing.allRights': 'All rights reserved',
    'landing.heroSubtitle': 'Your mobile repair specialist in French Guiana',
    'landing.mondayFriday': 'Monday - Friday',
    'landing.saturday': 'Saturday',
    'landing.sunday': 'Sunday',
    'landing.closed': 'Closed',
    'landing.companyType': 'Simplified Joint Stock Company (SAS)',
    'landing.openMaps': 'Open in Maps',
    'landing.rcs': 'Commercial Register',
    'landing.siret': 'Business Reg. No.',
    'landing.euid': 'EU Business ID',
    'landing.shopAddress': 'Store location',
    // Login extra
    'login.clientSpace': 'Client Area',
    'login.businessSpace': 'Business Area',
    'login.staffSpace': 'Staff Area',
    'login.connectYou': 'Log in',
    'login.phoneNumber': 'Phone number',
    'login.proEmail': 'Professional email',
    'login.pin': 'PIN code (4 or 6 digits)',
    'login.pinHint': 'Enter your code using the keyboard or keypad.',
    'login.connecting': 'Connecting...',
    'login.connect': 'Log in',
    'login.noAccount': 'No account yet?',
    'login.createAccount': 'Create an account',
    'login.forgotPwd': 'Forgot password?',
    'login.notRegistered': 'Not registered yet?',
    'login.businessRegister': 'Business registration',
    'login.secure': 'Secure connection',
    'login.caricature': 'Create my caricature',
    'login.backHome': 'Back to home',
    'login.wrongCredentials': 'Incorrect credentials',
    'login.pinError': 'PIN code must be 4 or 6 digits',
    'login.b2bPassword': 'Password',
    'login.b2bPlaceholder': 'Your password',
    'login.yourId': 'Your username',
    // Dashboard extra
    'dash.hello': 'Hello',
    'dash.loggedAs': 'Logged in as',
    'dash.caisseOpen': 'Register open',
    'dash.closeCaisseReminder': 'Remember to close the register',
    'dash.noCaisse': 'No register open',
    'dash.openCaisseTitle': 'Open register',
    'dash.openTotal': 'Opening total',
    'dash.opening': 'Opening...',
    'dash.open': 'Open',
    'dash.searchPlaceholder': 'Search by reference, client, phone...',
    'dash.noResults': 'No results found',
    'dash.today': 'Today',
    'dash.thisMonth': 'This month',
    'dash.completed': 'Completed',
    'dash.repairsSub': 'repairs',
    'dash.inProgress': 'In progress',
    'dash.waitingParts': 'including waiting for parts',
    'dash.registeredMonth': 'registered this month',
    'dash.statsTitle': 'Statistics & Analytics',
    'dash.statsDesc': 'Revenue, repairs, B2B, clients',
    'dash.brandsModelsLabel': 'Brands & Models',
    'dash.brandsModelsDesc': 'Manage device catalog',
    'dash.b2bPaymentsLabel': 'B2B Payments',
    'dash.b2bPaymentsDesc': 'Invoice and payment tracking',
    'dash.stockAlerts': 'Stock Alerts',
    'dash.lowStock': 'products with low stock',
    'dash.outOfStock': 'out of stock',
    'dash.recentRepairs': 'Recent repairs',
    'dash.noClient': 'No client',
    'dash.unclosedTitle': 'Register not closed',
    'dash.unclosedNotClosed': 'was not closed',
    'dash.contactAdmin': 'Please contact an administrator to close it before continuing.',
    'dash.mustClose': 'You must close it before continuing.',
    'dash.forceClose': 'Force close',
    'dash.closing': 'Closing...',
    'dash.closeNormal': 'Close normally',
    'dash.noCaisseToday': 'No register is open for today.',
    'dash.openQuestion': 'Would you like to open the register now?',
    'dash.dontOpen': 'Do not open (continue)',
    'dash.salesBlocked': 'Sales will be blocked until the register is opened.',
    'dash.calculation': 'Calculator',
    'dash.repairs': 'Repairs',
    'dash.addDevice': 'Add',
    'dash.clients': 'Clients',
    'dash.openedBy': 'opened by',
    'dash.unknown': 'unknown',
    'dash.forceCloseConfirm': 'Force close register from',
    'dash.errorForceClose': 'Error during force close',
    'dash.errorOpenCaisse': 'Error opening register',
    // Devis Accept
    'devisAccept.error': 'Error',
    'devisAccept.notFound': 'Quote not found',
    'devisAccept.refused': 'Quote refused',
    'devisAccept.refusedMsg': 'You have refused quote',
    'devisAccept.thanks': 'Thank you for letting us know.',
    'devisAccept.accepted': 'Quote accepted!',
    'devisAccept.acceptedMsg': 'Thank you for accepting quote',
    'devisAccept.bonCommande': 'Purchase order',
    'devisAccept.facture': 'Invoice',
    'devisAccept.emailSent': 'An email with your purchase order, validation code and login credentials has been sent.',
    'devisAccept.proceedPayment': 'Proceed to payment',
    'devisAccept.paymentMsg': 'To finalize your order, please make a deposit or full payment:',
    'devisAccept.deposit50': 'Deposit 50%',
    'devisAccept.fullPayment': 'Full payment',
    'devisAccept.alreadyAccepted': 'This quote has already been accepted.',
    'devisAccept.alreadyRefused': 'This quote has been refused.',
    'devisAccept.statusMsg': 'Quote status',
    'devisAccept.payDeposit': 'Pay 50% deposit',
    'devisAccept.homeRepairQuote': 'Home repair quote',
    'devisAccept.hello': 'Hello',
    'devisAccept.findBelow': 'Please find the details of your quote below:',
    'devisAccept.designation': 'Description',
    'devisAccept.travelFee': 'Travel fee',
    'devisAccept.tvaNote': 'VAT not applicable, art. 293B of the CGI. Quote valid for 30 days.',
    'devisAccept.refuse': 'Refuse',
    'devisAccept.accept': 'Accept quote',
    'devisAccept.confirmRefuse': 'Are you sure you want to refuse this quote?',
    // Payment
    'payment.secure': 'Secure payment',
    'payment.error': 'Error',
    'payment.backToDevis': 'Back to quote',
    'payment.notAccepted': 'Quote not accepted',
    'payment.mustAcceptFirst': 'You must accept the quote before proceeding to payment.',
    'payment.viewDevis': 'View quote',
    'payment.fullyPaid': 'Invoice fully paid',
    'payment.alreadyPaid': 'is already fully paid.',
    'payment.accessClient': 'Access your client area',
    'payment.deposit50': 'Deposit 50%',
    'payment.fullPayment': 'Full payment',
    'payment.devis': 'Quote',
    'payment.client': 'Client',
    'payment.totalDevis': 'Quote total',
    'payment.alreadyPaidAmount': 'Already paid',
    'payment.remaining': 'Remaining',
    'payment.depositPercent': 'Deposit (50%)',
    'payment.amountToPay': 'Amount to pay',
    'payment.pay': 'Pay',
    'payment.redirecting': 'Redirecting to Stripe...',
    'payment.securedBy': 'Secured payment by Stripe',
    'payment.urlNotAvailable': 'Payment URL not available',
    'payment.creationError': 'Error creating payment',
    // Payment success
    'paySuccess.confirmed': 'Payment confirmed!',
    'paySuccess.paymentFor': 'Your payment for quote',
    'paySuccess.registered': 'has been successfully recorded.',
    'paySuccess.depositRegistered': 'Deposit registered!',
    'paySuccess.depositFor': 'Your deposit for quote',
    'paySuccess.depositDone': 'has been recorded.',
    'paySuccess.checking': 'Checking...',
    'paySuccess.pleaseWait': 'We are verifying your payment, please wait.',
    'paySuccess.waitingConfirm': 'Waiting for confirmation',
    'paySuccess.processing': 'Your payment is being processed. You will receive a confirmation email.',
    'paySuccess.totalInvoice': 'Invoice total',
    'paySuccess.amountPaid': 'Amount paid',
    'paySuccess.remaining': 'Remaining',
    'paySuccess.payRemaining': 'Pay remaining',
    'paySuccess.loginClient': 'Log in to your client area',
    // Registration
    'register.clientTitle': 'Create a client account',
    'register.fullName': 'Full name',
    'register.phone': 'Phone',
    'register.email': 'Email (optional)',
    'register.address': 'Address (optional)',
    'register.pin': 'PIN code (4 or 6 digits)',
    'register.confirmPin': 'Confirm PIN code',
    'register.creating': 'Creating...',
    'register.createAccount': 'Create my account',
    'register.alreadyAccount': 'Already have an account?',
    'register.login': 'Log in',
    'register.backHome': 'Back to home',
    'register.pinError': 'PIN code must be 4 or 6 digits',
    'register.pinNoMatch': 'PIN codes do not match',
    'register.pinMinLength': 'PIN code must be at least 4 digits',
    // B2B Registration
    'b2bRegister.title': 'Business Registration',
    'b2bRegister.subtitle': 'Create your professional account',
    'b2bRegister.companyName': 'Company name',
    'b2bRegister.managerName': 'Manager name',
    'b2bRegister.proEmail': 'Professional email',
    'b2bRegister.phone': 'Phone',
    'b2bRegister.address': 'Address',
    'b2bRegister.siret': 'SIRET',
    'b2bRegister.password': 'Password',
    'b2bRegister.confirmPassword': 'Confirm password',
    'b2bRegister.kbis': 'KBIS extract (PDF)',
    'b2bRegister.kbisDesc': 'Upload your KBIS extract or any supporting document (PDF)',
    'b2bRegister.dropFile': 'Click or drop your file here',
    'b2bRegister.creating': 'Registering...',
    'b2bRegister.submit': 'Register',
    'b2bRegister.success': 'Registration successful!',
    'b2bRegister.successMsg': 'Your business account is being validated. You will receive a confirmation email.',
    'b2bRegister.goLogin': 'Go to login',
    'b2bRegister.fillAll': 'Please fill in all required fields',
    'b2bRegister.siretError': 'SIRET must contain 14 digits',
    'b2bRegister.pwdNoMatch': 'Passwords do not match',
    'b2bRegister.pwdMinLength': 'Password must be at least 6 characters',
    'b2bRegister.kbisRequired': 'Please upload your KBIS extract',
    'b2bRegister.alreadyAccount': 'Already registered?',
    // Reset password
    'reset.forgotTitle': 'Forgot password',
    'reset.forgotDesc': 'Receive a reset link by email',
    'reset.enterEmail': 'Please enter your email',
    'reset.emailSent': 'Email sent',
    'reset.emailSentMsg': 'If an account exists with this address, you will receive an email with a link to reset your password.',
    'reset.linkValid': 'The link is valid for 1 hour.',
    'reset.backLogin': 'Back to login',
    'reset.clientEmail': 'Your account email address',
    'reset.sending': 'Sending...',
    'reset.sendLink': 'Send reset link',
    'reset.newPwdTitle': 'New password',
    'reset.newPwdDesc': 'Choose your new password',
    'reset.newPwd': 'New password',
    'reset.confirmPwd': 'Confirm password',
    'reset.resetting': 'Resetting...',
    'reset.resetPwd': 'Reset password',
    'reset.pwdReset': 'Password reset',
    'reset.pwdResetMsg': 'Your password has been changed successfully.',
    'reset.pwdMinLength': 'Password must be at least 4 characters',
    'reset.pwdNoMatch': 'Passwords do not match',
    'reset.error': 'An error occurred',
    // B2B Dashboard
    'b2b.welcome': 'Welcome',
    'b2b.newRepair': 'New repair',
    'b2b.registerDevice': 'Register a device',
    'b2b.myRepairs': 'My repairs',
    'b2b.viewAll': 'View all repairs',
    'b2b.recentRepairs': 'Recent repairs',
    'b2b.noRepairs': 'No repairs',
    'b2b.repairRegistered': 'Repair registered',
    'b2b.reference': 'Reference',
    'b2b.viewDetails': 'View details',
    'b2b.anotherRepair': 'New repair',
    'b2b.deviceInfo': 'Device information',
    'b2b.brand': 'Brand',
    'b2b.model': 'Model',
    'b2b.backGlass': 'Back glass',
    'b2b.backGlassBroken': 'Back glass broken',
    'b2b.backGlassOk': 'Back glass intact',
    'b2b.providePart': 'I provide the part',
    'b2b.partByShop': 'Part will be provided by R.E.Mobiles',
    'b2b.lockCode': 'Lock code',
    'b2b.lockTypeCode': 'Code (digits/letters)',
    'b2b.lockTypeSchema': 'Pattern',
    'b2b.problem': 'Problem / Description',
    'b2b.brokenParts': 'Non-functional parts',
    'b2b.deliveryMethod': 'Delivery method',
    'b2b.inStore': 'In store',
    'b2b.inStoreDesc': 'Drop off at store',
    'b2b.postal': 'Postal',
    'b2b.postalDesc': 'With tracking number',
    'b2b.pickup': 'Pickup',
    'b2b.pickupDesc': 'We come to pick up',
    'b2b.trackingNumber': 'Tracking number',
    'b2b.pickupAddress': 'Pickup address',
    'b2b.devicePhotos': 'Device photos',
    'b2b.addPhotos': 'Click to add photos',
    'b2b.additionalNotes': 'Additional notes',
    'b2b.submitting': 'Submitting...',
    'b2b.submitRepair': 'Submit repair',
    'b2b.brandModelRequired': 'Brand and model are required',
    'b2b.noRepairFound': 'No repairs found',
    'b2b.allStatus': 'All',
    'b2b.documents': 'Documents & Invoices',
    'b2b.documentsDesc': 'Validate your orders and download invoices',
    'b2b.pendingValidation': 'Orders pending validation',
    'b2b.enterCode': 'Enter the code received by email to validate each order.',
    'b2b.validate': 'Validate',
    'b2b.invoices': 'Invoices',
    'b2b.noInvoices': 'No invoices available',
    'b2b.device': 'Device',
    'b2b.amount': 'Amount',
    'b2b.date': 'Date',
    'b2b.actions': 'Actions',
    'b2b.paid': 'Paid',
    'b2b.repairAccepted': 'Repair accepted by staff',
    'b2b.repairRefused': 'Repair refused by staff',
    'b2b.orderValidated': 'Purchase order validated',
    'b2b.noPhotos': 'No photos',
    'b2b.history': 'History',
    'b2b.repairPrice': 'Repair price',
    'b2b.diagPrice': 'Diagnostic price',
    'b2b.priceWaiting': 'Pending - will be set by R.E.Mobiles',
    'b2b.createdOn': 'Created on',
    'b2b.clear': 'Clear',
    'b2b.thisMonth': 'This month',
    'b2b.waitingReception': 'Awaiting reception',
    'b2b.received': 'Received',
    'b2b.inProgress': 'In Progress',
    'b2b.waitingParts': 'Waiting Parts',
    'b2b.completed': 'Completed',
    'b2b.delivered': 'Delivered',
    // B2B Devis
    'b2bDevis.title': 'Travel Quotes',
    'b2bDevis.pending': 'pending',
    'b2bDevis.noDevis': 'No quotes',
    'b2bDevis.noDevisDesc': 'You have no travel quotes at the moment.',
    'b2bDevis.travelFee': 'Travel fee',
    'b2bDevis.validationCode': 'Validation code',
    'b2bDevis.codeHint': 'Enter the 6-digit code received by email.',
    'b2bDevis.acceptFirst': 'Please accept the quote first to validate it.',
    'b2bDevis.payDeposit': 'Pay 50% deposit',
    'b2bDevis.payFull': 'Pay full amount',
    'b2bDevis.payRemaining': 'Pay remaining',
    'b2bDevis.alreadyPaid': 'Already paid',
    'b2bDevis.remaining': 'Remaining',
    'b2bDevis.invoiceDownload': 'Download invoice',
    'b2bDevis.orderDownload': 'Download purchase order',
    'b2bDevis.quoteDownload': 'Download quote',
    // Admin Site Settings
    'adminSettings.title': 'Home Page',
    'adminSettings.preview': 'Preview',
    'adminSettings.saving': 'Saving...',
    'adminSettings.save': 'Save',
    'adminSettings.saved': 'Saved!',
    'adminSettings.error': 'Error',
    'adminSettings.heroSection': 'Hero / Header',
    'adminSettings.mainTitle': 'Main title',
    'adminSettings.subtitle': 'Subtitle',
    'adminSettings.accentColor': 'Accent color (hex)',
    'adminSettings.bgImage': 'Background image',
    'adminSettings.change': 'Change',
    'adminSettings.companyInfo': 'Company information',
    'adminSettings.companyName': 'Company name',
    'adminSettings.companyType': 'Type (SAS, SARL...)',
    'adminSettings.capital': 'Capital',
    'adminSettings.rcs': 'RCS',
    'adminSettings.siret': 'SIRET',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Headquarters',
    'adminSettings.salesPoint': 'Point of sale',
    'adminSettings.contactHours': 'Contact & Hours',
    'adminSettings.phone': 'Phone',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'Email',
    'adminSettings.googleMaps': 'Google Maps query',
    'adminSettings.gallery': 'Photo gallery',
    'adminSettings.addImage': 'Add image',
    // Admin Database
    'adminDb.title': 'Database Administration',
    'adminDb.subtitle': 'Export, import and data management',
    'adminDb.accessDenied': 'Access denied',
    'adminDb.adminOnly': 'This page is restricted to administrators',
    'adminDb.clients': 'Clients',
    'adminDb.users': 'Users',
    'adminDb.repairs': 'Repairs',
    'adminDb.stockArticles': 'Stock Items',
    'adminDb.exportTitle': 'Database Export',
    'adminDb.exportDesc': 'Export all data (clients, users, stock, repairs, sales) as a JSON file.',
    'adminDb.exportConfirm': 'Export the entire database?',
    'adminDb.exportBtn': 'Export full database',
    'adminDb.exportSuccess': 'Export successful!',
    'adminDb.exportError': 'Error during export',
    'adminDb.importTitle': 'Database Import',
    'adminDb.importDesc': 'Import a JSON file to restore or migrate data.',
    'adminDb.fileSelected': 'File selected',
    'adminDb.uploading': 'Uploading file...',
    'adminDb.importDone': 'Import completed!',
    'adminDb.importSuccess': 'Import successful!',
    'adminDb.importError': 'Error during import',
    'adminDb.importClientsBtn': 'Import Clients',
    'adminDb.importFullBtn': 'Full Import',
    'adminDb.importWarning': 'Full import will replace existing data',
    'adminDb.importConfirm': 'WARNING: This will replace existing data. Continue?',
    'adminDb.importClientsConfirm': 'Import clients? Accounts will be created with phone number as identifier.',
    'adminDb.selectFile': 'Please select a file',
    'adminDb.selectFileClients': 'Please select a JSON file with clients',
    'adminDb.logsTitle': 'Operations log',
    'adminDb.noLogs': 'No operations recorded',
    // Admin B2B
    'adminB2b.title': 'B2B Management',
    'adminB2b.home': 'Home',
    'adminB2b.monthlyRecap': 'Monthly Recap',
    'adminB2b.sending': 'Sending...',
    'adminB2b.search': 'Search...',
    'adminB2b.recapTitle': 'Monthly recap results',
    'adminB2b.recapSent': 'Sent',
    'adminB2b.recapSkipped': 'No repairs',
    'adminB2b.recapError': 'Error',
    'adminB2b.companies': 'Companies',
    'adminB2b.b2bRepairs': 'B2B Repairs',
    'adminB2b.paymentHistory': 'Payment History',
    'adminB2b.all': 'All',
    'adminB2b.pending': 'Pending',
    'adminB2b.validated': 'Validated',
    'adminB2b.refused': 'Refused',
    'adminB2b.suspended': 'Suspended',
    'adminB2b.noCompany': 'No company found',
    'adminB2b.phone': 'Phone',
    'adminB2b.siret': 'SIRET',
    'adminB2b.address': 'Address',
    'adminB2b.registeredOn': 'Registered on',
    'adminB2b.validatedBy': 'Validated by',
    'adminB2b.downloadKbis': 'Download KBIS',
    'adminB2b.validate': 'Validate',
    'adminB2b.refuse': 'Refuse',
    'adminB2b.suspend': 'Suspend',
    'adminB2b.confirmValidate': 'Do you want to validate this company?',
    'adminB2b.confirmRefuse': 'Do you want to refuse this company?',
    'adminB2b.confirmSuspend': 'Do you want to suspend this company?',
    'adminB2b.pendingReception': 'Awaiting reception',
    'adminB2b.confirmReception': 'Confirm reception',
    'adminB2b.ref': 'Ref',
    'adminB2b.company': 'Company',
    'adminB2b.brandModel': 'Brand / Model',
    'adminB2b.problem': 'Problem',
    'adminB2b.delivery': 'Delivery',
    'adminB2b.price': 'Price',
    'adminB2b.status': 'Status',
    'adminB2b.actions': 'Actions',
    'adminB2b.noRepairs': 'No B2B repairs found',
    'adminB2b.postal': 'Postal',
    'adminB2b.pickup': 'Pickup',
    'adminB2b.inStore': 'In store',
    'adminB2b.changeStatus': 'Change status',
    'adminB2b.setPrice': 'Set price',
    'adminB2b.repairPrice': 'Repair price',
    'adminB2b.diagPrice': 'Diagnostic price',
    'adminB2b.locked': 'Locked (paid)',
    'adminB2b.total': 'Total',
    'adminB2b.existingInvoices': 'Existing invoices',
    'adminB2b.diagnostic': 'Diagnostic',
    'adminB2b.repair': 'Repair',
    'adminB2b.combined': 'Combined',
    'adminB2b.paidMethod': 'Paid',
    'adminB2b.awaitingPayment': 'Awaiting payment',
    'adminB2b.markPaid': 'Paid',
    'adminB2b.finalize': 'Finalize billing',
    'adminB2b.backGlassBroken': 'Back glass broken',
    'adminB2b.clientPart': 'Client part',
    'adminB2b.bcValidated': 'PO validated',
    'adminB2b.invoiceCancelled': 'Invoice cancelled',
    'adminB2b.monthPrompt': 'Month (1-12)? Leave blank for previous month:',
    'adminB2b.yearPrompt': 'Year?',
    'adminB2b.paymentMethodPrompt': 'Payment method?',
    'adminB2b.filterCompany': 'Company',
    'adminB2b.filterDateStart': 'Start date',
    'adminB2b.filterDateEnd': 'End date',
    'adminB2b.filter': 'Filter',
    'adminB2b.clearFilter': 'Clear',
    'adminB2b.totalCollected': 'Total collected',
    'adminB2b.payments': 'payment(s)',
    'adminB2b.payHistoryTitle': 'B2B payment history',
    'adminB2b.noPayments': 'No B2B payments recorded',
    'adminB2b.invoice': 'Invoice',
    // Users Management
    'users.title': 'User Management',
    'users.count': 'user(s)',
    'users.new': 'New user',
    'users.edit': 'Edit user',
    'users.username': 'Username',
    'users.password': 'Password',
    'users.newPassword': 'New password (leave blank to keep current)',
    'users.role': 'Role',
    'users.roleAdmin': 'Administrator',
    'users.roleUser': 'Salesperson',
    'users.roleTech': 'Technician',
    'users.status': 'Status',
    'users.active': 'Active',
    'users.inactive': 'Inactive',
    'users.createdAt': 'Created on',
    'users.noUsers': 'No users',
    'users.accessDenied': 'Access restricted to administrators',
    'users.deleteConfirm': 'Delete this user?',
    // Clients (extra keys)
    'clients.manage': 'Client Management',
    'clients.total': 'clients total',
    'clients.add': 'Add',
    'clients.noClients': 'No clients found',
    'clients.type': 'Type',
    'clients.discount': 'Discount',
    'clients.account': 'Account',
    'clients.sent': 'Sent',
    'clients.activeAccount': 'Active',
    'clients.noEmail': 'No email',
    'clients.editClient': 'Edit client',
    'clients.newClient': 'New client',
    'clients.company': 'Company',
    'clients.clientType': 'Client type',
    'clients.individual': 'Individual',
    'clients.business': 'Business',
    'clients.discountPct': 'Discount (%)',
    'clients.deleteConfirm': 'Delete this client?',
    'clients.page': 'Page',
    // Stats
    'stats.title': 'Statistics & Analytics',
    'stats.revenue': 'Revenue',
    'stats.repairs': 'Repairs',
    'stats.b2b': 'B2B',
    'stats.clients': 'Clients',
    'stats.back': 'Back',
    'stats.monthlyRevenue': 'Monthly Revenue',
    'stats.revenueByType': 'Revenue by type',
    'stats.revenueByPayment': 'Revenue by payment method',
    'stats.totalRevenue': 'Total Revenue (12 months)',
    'stats.repairsByStatus': 'By status',
    'stats.repairsByBrand': 'By brand',
    'stats.topModels': 'Top models',
    'stats.monthly': 'Monthly trend',
    'stats.totalRepairs': 'Total repairs',
    'stats.avgRepairTime': 'Average duration',
    'stats.completionRate': 'Completion rate',
    'stats.b2bCompanies': 'B2B Companies',
    'stats.b2bRepairs': 'B2B Repairs',
    'stats.b2bRevenue': 'B2B Revenue',
    'stats.b2bByCompany': 'By company',
    'stats.totalClients': 'Total clients',
    'stats.newThisMonth': 'New this month',
    'stats.withAccount': 'With account',
    'stats.clientsByType': 'By type',
    'stats.registrations': 'Monthly registrations',
    'stats.noData': 'No data',
    // Reparations (extra)
    'rep.manage': 'Repair Management',
    'rep.noRepairs': 'No repairs found',
    'rep.allStatuses': 'All statuses',
    'rep.imei': 'IMEI / Serial',
    'rep.client': 'Client',
    'rep.phone': 'Phone',
    'rep.date': 'Date',
    'rep.deposit': 'Deposit',
    'rep.printFiche': 'Print sheet',
    'rep.printEtiquette': 'Print label',
    'rep.deleteConfirm': 'Delete this repair?',
    'rep.addDeposit': 'Add deposit',
    'rep.depositAmount': 'Deposit amount',
    'rep.paymentMode': 'Payment method',
    'rep.depositHistory': 'Deposit history',
    'rep.totalDeposits': 'Total deposits',
    'rep.changeStatus': 'Change status',
    'rep.notes': 'Internal notes',
    'rep.sendChat': 'Send message',
    'rep.noTimeline': 'No events',
    // Commandes (extra)
    'cmd.manage': 'Order Management',
    'cmd.noOrders': 'No orders found',
    'cmd.allStatuses': 'All statuses',
    'cmd.ordered': 'Ordered',
    'cmd.received': 'Received',
    'cmd.cancelled': 'Cancelled',
    'cmd.status': 'Status',
    'cmd.ref': 'Ref',
    'cmd.addOrder': 'New order',
    'cmd.editOrder': 'Edit order',
    'cmd.deleteConfirm': 'Delete this order?',
    // Stock (extra)
    'stock.manage': 'Stock Management',
    'stock.noItems': 'No items found',
    'stock.barcode': 'Barcode',
    'stock.reference': 'Reference',
    'stock.alert': 'Alert',
    'stock.lowStockAlert': 'Low stock',
    'stock.addForm': 'Add an item',
    'stock.editForm': 'Edit item',
    'stock.deleteConfirm': 'Delete this item?',
    // Historique
    'hist.title': 'Sales History',
    'hist.search': 'Search a sale...',
    'hist.noSales': 'No sales found',
    'hist.ref': 'Ref.',
    'hist.client': 'Client',
    'hist.amount': 'Amount',
    'hist.payment': 'Payment',
    'hist.date': 'Date',
    'hist.articles': 'Articles',
    'hist.refund': 'Refund',
    'hist.refundConfirm': 'Refund this sale?',
    // Paiements
    'pay.title': 'Online Payments',
    'pay.search': 'Search...',
    'pay.noPayments': 'No payments found',
    'pay.ref': 'Reference',
    'pay.client': 'Client',
    'pay.amount': 'Amount',
    'pay.status': 'Status',
    'pay.date': 'Date',
    'pay.type': 'Type',
    // Caisse
    'caisse.title': 'Cash Register History',
    'caisse.noCaisse': 'No register found',
    'caisse.openedBy': 'Opened by',
    'caisse.openingAmount': 'Opening amount',
    'caisse.closingAmount': 'Closing amount',
    'caisse.sales': 'Sales',
    'caisse.openDate': 'Opened',
    'caisse.closeDate': 'Closed',
    // Notes
    'notes.title': 'Notes',
    'notes.new': 'New note',
    'notes.noNotes': 'No notes',
    'notes.deleteConfirm': 'Delete this note?',
    // Etiquettes
    'labels.title': 'Labels',
    'labels.search': 'Search...',
    'labels.print': 'Print',
    'labels.selectAll': 'Select all',
    'labels.noLabels': 'No labels',
    // Calcul Prix
    'calc.title': 'Price Calculator',
    'calc.searchDevice': 'Search device...',
    'calc.selectRepair': 'Select repair',
    'calc.generateQuote': 'Generate quote',
    'calc.generateInvoice': 'Generate invoice',
    // Boutique
    'boutique.title': 'Shop Orders',
    'boutique.noOrders': 'No orders',
    'boutique.orderRef': 'Order ref.',
    'boutique.clientName': 'Client',
    'boutique.total': 'Total',
    'boutique.status': 'Status',
    // Chat
    'chat.title': 'Messages',
    'chat.noConversations': 'No conversations',
    'chat.typeMessage': 'Type your message...',
    // Brands & Models
    'brands.title': 'Brands & Models',
    'brands.addBrand': 'Add brand',
    'brands.addModel': 'Add model',
    'brands.noBrands': 'No brands',
    'brands.deleteConfirm': 'Delete this brand?',
    // Remcaches
    'remcaches.title': 'Cash Remittances',
    'remcaches.noItems': 'No items',
    // Close Caisse
    'closeCaisse.title': 'Close Cash Register',
    'closeCaisse.countCoins': 'Cash count',
    'closeCaisse.theoreticalTotal': 'Theoretical total',
    'closeCaisse.actualTotal': 'Actual total',
    'closeCaisse.difference': 'Difference',
    'closeCaisse.close': 'Close register',
    'closeCaisse.closing': 'Closing...',
    // Client Passwords
    'clientPwd.title': 'Client Passwords',
    'clientPwd.search': 'Search client...',
    'clientPwd.noClients': 'No clients found',
    'clientPwd.generatePin': 'Generate PIN',
    'clientPwd.sendByEmail': 'Send by email',
    // B2B Payments
    'b2bPay.title': 'B2B Payments',
    'b2bPay.noPayments': 'No payments',
    // Reparation Form
    'repForm.title': 'Add a device',
    'repForm.editTitle': 'Edit repair',
    'repForm.brand': 'Brand',
    'repForm.model': 'Model',
    'repForm.imei': 'IMEI / Serial number',
    'repForm.lockCode': 'Lock code',
    'repForm.problem': 'Problem found',
    'repForm.client': 'Client',
    'repForm.technician': 'Assigned technician',
    'repForm.price': 'Repair price',
    'repForm.submit': 'Save',
    'repForm.submitting': 'Saving...',
    // SumUp payment link
    'sumup.acceptOnlinePayment': 'Accept online payment (SumUp)',
    'sumup.acceptOnlinePaymentDesc': 'Client can request a SumUp payment link',
    'sumup.requestLink': 'Request SumUp payment link',
    'sumup.requestSent': 'Request sent! You will receive the link by email shortly.',
    'sumup.alreadyRequested': 'Request already in progress.',
    'sumup.onlinePayment': 'SumUp online payment',
    'sumup.receiveLink': 'Receive a secure payment link by email',
    'sumup.linkRequested': 'Link requested',
    'sumup.pendingRequests': 'SumUp link requests',
    'sumup.pending': 'pending',
    'sumup.pasteLinkHere': 'Paste SumUp link here...',
    'sumup.send': 'Send',
    'sumup.linkSent': 'SumUp link sent to client by email!',
  };

export default en;
